import * as React from 'react';
import React__default, { useContext, createElement as createElement$1, Fragment as Fragment$1, createContext, forwardRef, useState, useRef, useEffect, useMemo } from 'react';
import { jsx as jsx$1, jsxs as jsxs$1, Fragment as Fragment$2 } from 'react/jsx-runtime';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import ViewIcon from '@mui/icons-material/VisibilityRounded';
import { Box, SvgIcon, Tooltip, IconButton, Menu } from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';
import { LicenseInfo, DataGridPro, GridPreferencesPanel, GridActionsCellItem, GridLinkOperator, useGridApiContext, GridToolbarExport, GridToolbarContainer, GridPreferencePanelsValue } from '@mui/x-data-grid-pro';
import { styled, theme } from '@chargeafter/theme';
import { Button, Typography, VerticalSpace, ScrollArea, Checkbox, ToggleButton, TextField, MultiSelectWithSearch, areOptionsOfTypeCollection } from '@chargeafter/ui';
import AppsIcon from '@mui/icons-material/Apps';
import { Reorder, useDragControls } from 'framer-motion';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import { MobileDateRangePicker } from '@mui/x-date-pickers-pro';
import { differenceInDays, startOfDay, endOfDay, sub } from 'date-fns';
import Box$1 from '@mui/material/Box';

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

var check = function (it) {
  return it && it.Math == Math && it;
};

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global$d =
  // eslint-disable-next-line es/no-global-this -- safe
  check(typeof globalThis == 'object' && globalThis) ||
  check(typeof window == 'object' && window) ||
  // eslint-disable-next-line no-restricted-globals -- safe
  check(typeof self == 'object' && self) ||
  check(typeof commonjsGlobal == 'object' && commonjsGlobal) ||
  // eslint-disable-next-line no-new-func -- fallback
  (function () { return this; })() || Function('return this')();

var objectGetOwnPropertyDescriptor = {};

var fails$e = function (exec) {
  try {
    return !!exec();
  } catch (error) {
    return true;
  }
};

var fails$d = fails$e;

// Detect IE8's incomplete defineProperty implementation
var descriptors = !fails$d(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
  return Object.defineProperty({}, 1, { get: function () { return 7; } })[1] != 7;
});

var fails$c = fails$e;

var functionBindNative = !fails$c(function () {
  // eslint-disable-next-line es/no-function-prototype-bind -- safe
  var test = (function () { /* empty */ }).bind();
  // eslint-disable-next-line no-prototype-builtins -- safe
  return typeof test != 'function' || test.hasOwnProperty('prototype');
});

var NATIVE_BIND$1 = functionBindNative;

var call$7 = Function.prototype.call;

var functionCall = NATIVE_BIND$1 ? call$7.bind(call$7) : function () {
  return call$7.apply(call$7, arguments);
};

var objectPropertyIsEnumerable = {};

var $propertyIsEnumerable = {}.propertyIsEnumerable;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getOwnPropertyDescriptor$1 = Object.getOwnPropertyDescriptor;

// Nashorn ~ JDK8 bug
var NASHORN_BUG = getOwnPropertyDescriptor$1 && !$propertyIsEnumerable.call({ 1: 2 }, 1);

// `Object.prototype.propertyIsEnumerable` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.propertyisenumerable
objectPropertyIsEnumerable.f = NASHORN_BUG ? function propertyIsEnumerable(V) {
  var descriptor = getOwnPropertyDescriptor$1(this, V);
  return !!descriptor && descriptor.enumerable;
} : $propertyIsEnumerable;

var createPropertyDescriptor$3 = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};

var NATIVE_BIND = functionBindNative;

var FunctionPrototype$1 = Function.prototype;
var call$6 = FunctionPrototype$1.call;
var uncurryThisWithBind = NATIVE_BIND && FunctionPrototype$1.bind.bind(call$6, call$6);

var functionUncurryThis = NATIVE_BIND ? uncurryThisWithBind : function (fn) {
  return function () {
    return call$6.apply(fn, arguments);
  };
};

var uncurryThis$b = functionUncurryThis;

var toString$4 = uncurryThis$b({}.toString);
var stringSlice$1 = uncurryThis$b(''.slice);

var classofRaw$1 = function (it) {
  return stringSlice$1(toString$4(it), 8, -1);
};

var uncurryThis$a = functionUncurryThis;
var fails$b = fails$e;
var classof$4 = classofRaw$1;

var $Object$4 = Object;
var split = uncurryThis$a(''.split);

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var indexedObject = fails$b(function () {
  // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
  // eslint-disable-next-line no-prototype-builtins -- safe
  return !$Object$4('z').propertyIsEnumerable(0);
}) ? function (it) {
  return classof$4(it) == 'String' ? split(it, '') : $Object$4(it);
} : $Object$4;

// we can't use just `it == null` since of `document.all` special case
// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot-aec
var isNullOrUndefined$2 = function (it) {
  return it === null || it === undefined;
};

var isNullOrUndefined$1 = isNullOrUndefined$2;

var $TypeError$8 = TypeError;

// `RequireObjectCoercible` abstract operation
// https://tc39.es/ecma262/#sec-requireobjectcoercible
var requireObjectCoercible$3 = function (it) {
  if (isNullOrUndefined$1(it)) throw $TypeError$8("Can't call method on " + it);
  return it;
};

// toObject with fallback for non-array-like ES3 strings
var IndexedObject$2 = indexedObject;
var requireObjectCoercible$2 = requireObjectCoercible$3;

var toIndexedObject$5 = function (it) {
  return IndexedObject$2(requireObjectCoercible$2(it));
};

var documentAll$2 = typeof document == 'object' && document.all;

// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot
// eslint-disable-next-line unicorn/no-typeof-undefined -- required for testing
var IS_HTMLDDA = typeof documentAll$2 == 'undefined' && documentAll$2 !== undefined;

var documentAll_1 = {
  all: documentAll$2,
  IS_HTMLDDA: IS_HTMLDDA
};

var $documentAll$1 = documentAll_1;

var documentAll$1 = $documentAll$1.all;

// `IsCallable` abstract operation
// https://tc39.es/ecma262/#sec-iscallable
var isCallable$g = $documentAll$1.IS_HTMLDDA ? function (argument) {
  return typeof argument == 'function' || argument === documentAll$1;
} : function (argument) {
  return typeof argument == 'function';
};

var isCallable$f = isCallable$g;
var $documentAll = documentAll_1;

var documentAll = $documentAll.all;

var isObject$7 = $documentAll.IS_HTMLDDA ? function (it) {
  return typeof it == 'object' ? it !== null : isCallable$f(it) || it === documentAll;
} : function (it) {
  return typeof it == 'object' ? it !== null : isCallable$f(it);
};

var global$c = global$d;
var isCallable$e = isCallable$g;

var aFunction = function (argument) {
  return isCallable$e(argument) ? argument : undefined;
};

var getBuiltIn$4 = function (namespace, method) {
  return arguments.length < 2 ? aFunction(global$c[namespace]) : global$c[namespace] && global$c[namespace][method];
};

var uncurryThis$9 = functionUncurryThis;

var objectIsPrototypeOf = uncurryThis$9({}.isPrototypeOf);

var getBuiltIn$3 = getBuiltIn$4;

var engineUserAgent = getBuiltIn$3('navigator', 'userAgent') || '';

var global$b = global$d;
var userAgent = engineUserAgent;

var process$1 = global$b.process;
var Deno = global$b.Deno;
var versions = process$1 && process$1.versions || Deno && Deno.version;
var v8 = versions && versions.v8;
var match$1, version;

if (v8) {
  match$1 = v8.split('.');
  // in old Chrome, versions of V8 isn't V8 = Chrome / 10
  // but their correct versions are not interesting for us
  version = match$1[0] > 0 && match$1[0] < 4 ? 1 : +(match$1[0] + match$1[1]);
}

// BrowserFS NodeJS `process` polyfill incorrectly set `.v8` to `0.0`
// so check `userAgent` even if `.v8` exists, but 0
if (!version && userAgent) {
  match$1 = userAgent.match(/Edge\/(\d+)/);
  if (!match$1 || match$1[1] >= 74) {
    match$1 = userAgent.match(/Chrome\/(\d+)/);
    if (match$1) version = +match$1[1];
  }
}

var engineV8Version = version;

/* eslint-disable es/no-symbol -- required for testing */

var V8_VERSION = engineV8Version;
var fails$a = fails$e;

// eslint-disable-next-line es/no-object-getownpropertysymbols -- required for testing
var symbolConstructorDetection = !!Object.getOwnPropertySymbols && !fails$a(function () {
  var symbol = Symbol();
  // Chrome 38 Symbol has incorrect toString conversion
  // `get-own-property-symbols` polyfill symbols converted to object are not Symbol instances
  return !String(symbol) || !(Object(symbol) instanceof Symbol) ||
    // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
    !Symbol.sham && V8_VERSION && V8_VERSION < 41;
});

/* eslint-disable es/no-symbol -- required for testing */

var NATIVE_SYMBOL$2 = symbolConstructorDetection;

var useSymbolAsUid = NATIVE_SYMBOL$2
  && !Symbol.sham
  && typeof Symbol.iterator == 'symbol';

var getBuiltIn$2 = getBuiltIn$4;
var isCallable$d = isCallable$g;
var isPrototypeOf$2 = objectIsPrototypeOf;
var USE_SYMBOL_AS_UID$1 = useSymbolAsUid;

var $Object$3 = Object;

var isSymbol$2 = USE_SYMBOL_AS_UID$1 ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  var $Symbol = getBuiltIn$2('Symbol');
  return isCallable$d($Symbol) && isPrototypeOf$2($Symbol.prototype, $Object$3(it));
};

var $String$3 = String;

var tryToString$1 = function (argument) {
  try {
    return $String$3(argument);
  } catch (error) {
    return 'Object';
  }
};

var isCallable$c = isCallable$g;
var tryToString = tryToString$1;

var $TypeError$7 = TypeError;

// `Assert: IsCallable(argument) is true`
var aCallable$2 = function (argument) {
  if (isCallable$c(argument)) return argument;
  throw $TypeError$7(tryToString(argument) + ' is not a function');
};

var aCallable$1 = aCallable$2;
var isNullOrUndefined = isNullOrUndefined$2;

// `GetMethod` abstract operation
// https://tc39.es/ecma262/#sec-getmethod
var getMethod$1 = function (V, P) {
  var func = V[P];
  return isNullOrUndefined(func) ? undefined : aCallable$1(func);
};

var call$5 = functionCall;
var isCallable$b = isCallable$g;
var isObject$6 = isObject$7;

var $TypeError$6 = TypeError;

// `OrdinaryToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-ordinarytoprimitive
var ordinaryToPrimitive$1 = function (input, pref) {
  var fn, val;
  if (pref === 'string' && isCallable$b(fn = input.toString) && !isObject$6(val = call$5(fn, input))) return val;
  if (isCallable$b(fn = input.valueOf) && !isObject$6(val = call$5(fn, input))) return val;
  if (pref !== 'string' && isCallable$b(fn = input.toString) && !isObject$6(val = call$5(fn, input))) return val;
  throw $TypeError$6("Can't convert object to primitive value");
};

var shared$3 = {exports: {}};

var global$a = global$d;

// eslint-disable-next-line es/no-object-defineproperty -- safe
var defineProperty$6 = Object.defineProperty;

var defineGlobalProperty$3 = function (key, value) {
  try {
    defineProperty$6(global$a, key, { value: value, configurable: true, writable: true });
  } catch (error) {
    global$a[key] = value;
  } return value;
};

var global$9 = global$d;
var defineGlobalProperty$2 = defineGlobalProperty$3;

var SHARED = '__core-js_shared__';
var store$3 = global$9[SHARED] || defineGlobalProperty$2(SHARED, {});

var sharedStore = store$3;

var store$2 = sharedStore;

(shared$3.exports = function (key, value) {
  return store$2[key] || (store$2[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: '3.27.1',
  mode: 'global',
  copyright: '© 2014-2022 Denis Pushkarev (zloirock.ru)',
  license: 'https://github.com/zloirock/core-js/blob/v3.27.1/LICENSE',
  source: 'https://github.com/zloirock/core-js'
});

var requireObjectCoercible$1 = requireObjectCoercible$3;

var $Object$2 = Object;

// `ToObject` abstract operation
// https://tc39.es/ecma262/#sec-toobject
var toObject$4 = function (argument) {
  return $Object$2(requireObjectCoercible$1(argument));
};

var uncurryThis$8 = functionUncurryThis;
var toObject$3 = toObject$4;

var hasOwnProperty$1 = uncurryThis$8({}.hasOwnProperty);

// `HasOwnProperty` abstract operation
// https://tc39.es/ecma262/#sec-hasownproperty
// eslint-disable-next-line es/no-object-hasown -- safe
var hasOwnProperty_1 = Object.hasOwn || function hasOwn(it, key) {
  return hasOwnProperty$1(toObject$3(it), key);
};

var uncurryThis$7 = functionUncurryThis;

var id = 0;
var postfix = Math.random();
var toString$3 = uncurryThis$7(1.0.toString);

var uid$2 = function (key) {
  return 'Symbol(' + (key === undefined ? '' : key) + ')_' + toString$3(++id + postfix, 36);
};

var global$8 = global$d;
var shared$2 = shared$3.exports;
var hasOwn$a = hasOwnProperty_1;
var uid$1 = uid$2;
var NATIVE_SYMBOL$1 = symbolConstructorDetection;
var USE_SYMBOL_AS_UID = useSymbolAsUid;

var WellKnownSymbolsStore = shared$2('wks');
var Symbol$1 = global$8.Symbol;
var symbolFor = Symbol$1 && Symbol$1['for'];
var createWellKnownSymbol = USE_SYMBOL_AS_UID ? Symbol$1 : Symbol$1 && Symbol$1.withoutSetter || uid$1;

var wellKnownSymbol$a = function (name) {
  if (!hasOwn$a(WellKnownSymbolsStore, name) || !(NATIVE_SYMBOL$1 || typeof WellKnownSymbolsStore[name] == 'string')) {
    var description = 'Symbol.' + name;
    if (NATIVE_SYMBOL$1 && hasOwn$a(Symbol$1, name)) {
      WellKnownSymbolsStore[name] = Symbol$1[name];
    } else if (USE_SYMBOL_AS_UID && symbolFor) {
      WellKnownSymbolsStore[name] = symbolFor(description);
    } else {
      WellKnownSymbolsStore[name] = createWellKnownSymbol(description);
    }
  } return WellKnownSymbolsStore[name];
};

var call$4 = functionCall;
var isObject$5 = isObject$7;
var isSymbol$1 = isSymbol$2;
var getMethod = getMethod$1;
var ordinaryToPrimitive = ordinaryToPrimitive$1;
var wellKnownSymbol$9 = wellKnownSymbol$a;

var $TypeError$5 = TypeError;
var TO_PRIMITIVE = wellKnownSymbol$9('toPrimitive');

// `ToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-toprimitive
var toPrimitive$1 = function (input, pref) {
  if (!isObject$5(input) || isSymbol$1(input)) return input;
  var exoticToPrim = getMethod(input, TO_PRIMITIVE);
  var result;
  if (exoticToPrim) {
    if (pref === undefined) pref = 'default';
    result = call$4(exoticToPrim, input, pref);
    if (!isObject$5(result) || isSymbol$1(result)) return result;
    throw $TypeError$5("Can't convert object to primitive value");
  }
  if (pref === undefined) pref = 'number';
  return ordinaryToPrimitive(input, pref);
};

var toPrimitive = toPrimitive$1;
var isSymbol = isSymbol$2;

// `ToPropertyKey` abstract operation
// https://tc39.es/ecma262/#sec-topropertykey
var toPropertyKey$2 = function (argument) {
  var key = toPrimitive(argument, 'string');
  return isSymbol(key) ? key : key + '';
};

var global$7 = global$d;
var isObject$4 = isObject$7;

var document$1 = global$7.document;
// typeof document.createElement is 'object' in old IE
var EXISTS$1 = isObject$4(document$1) && isObject$4(document$1.createElement);

var documentCreateElement$2 = function (it) {
  return EXISTS$1 ? document$1.createElement(it) : {};
};

var DESCRIPTORS$a = descriptors;
var fails$9 = fails$e;
var createElement = documentCreateElement$2;

// Thanks to IE8 for its funny defineProperty
var ie8DomDefine = !DESCRIPTORS$a && !fails$9(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
  return Object.defineProperty(createElement('div'), 'a', {
    get: function () { return 7; }
  }).a != 7;
});

var DESCRIPTORS$9 = descriptors;
var call$3 = functionCall;
var propertyIsEnumerableModule$1 = objectPropertyIsEnumerable;
var createPropertyDescriptor$2 = createPropertyDescriptor$3;
var toIndexedObject$4 = toIndexedObject$5;
var toPropertyKey$1 = toPropertyKey$2;
var hasOwn$9 = hasOwnProperty_1;
var IE8_DOM_DEFINE$1 = ie8DomDefine;

// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $getOwnPropertyDescriptor$1 = Object.getOwnPropertyDescriptor;

// `Object.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
objectGetOwnPropertyDescriptor.f = DESCRIPTORS$9 ? $getOwnPropertyDescriptor$1 : function getOwnPropertyDescriptor(O, P) {
  O = toIndexedObject$4(O);
  P = toPropertyKey$1(P);
  if (IE8_DOM_DEFINE$1) try {
    return $getOwnPropertyDescriptor$1(O, P);
  } catch (error) { /* empty */ }
  if (hasOwn$9(O, P)) return createPropertyDescriptor$2(!call$3(propertyIsEnumerableModule$1.f, O, P), O[P]);
};

var objectDefineProperty = {};

var DESCRIPTORS$8 = descriptors;
var fails$8 = fails$e;

// V8 ~ Chrome 36-
// https://bugs.chromium.org/p/v8/issues/detail?id=3334
var v8PrototypeDefineBug = DESCRIPTORS$8 && fails$8(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
  return Object.defineProperty(function () { /* empty */ }, 'prototype', {
    value: 42,
    writable: false
  }).prototype != 42;
});

var isObject$3 = isObject$7;

var $String$2 = String;
var $TypeError$4 = TypeError;

// `Assert: Type(argument) is Object`
var anObject$7 = function (argument) {
  if (isObject$3(argument)) return argument;
  throw $TypeError$4($String$2(argument) + ' is not an object');
};

var DESCRIPTORS$7 = descriptors;
var IE8_DOM_DEFINE = ie8DomDefine;
var V8_PROTOTYPE_DEFINE_BUG$1 = v8PrototypeDefineBug;
var anObject$6 = anObject$7;
var toPropertyKey = toPropertyKey$2;

var $TypeError$3 = TypeError;
// eslint-disable-next-line es/no-object-defineproperty -- safe
var $defineProperty = Object.defineProperty;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var ENUMERABLE = 'enumerable';
var CONFIGURABLE$1 = 'configurable';
var WRITABLE = 'writable';

// `Object.defineProperty` method
// https://tc39.es/ecma262/#sec-object.defineproperty
objectDefineProperty.f = DESCRIPTORS$7 ? V8_PROTOTYPE_DEFINE_BUG$1 ? function defineProperty(O, P, Attributes) {
  anObject$6(O);
  P = toPropertyKey(P);
  anObject$6(Attributes);
  if (typeof O === 'function' && P === 'prototype' && 'value' in Attributes && WRITABLE in Attributes && !Attributes[WRITABLE]) {
    var current = $getOwnPropertyDescriptor(O, P);
    if (current && current[WRITABLE]) {
      O[P] = Attributes.value;
      Attributes = {
        configurable: CONFIGURABLE$1 in Attributes ? Attributes[CONFIGURABLE$1] : current[CONFIGURABLE$1],
        enumerable: ENUMERABLE in Attributes ? Attributes[ENUMERABLE] : current[ENUMERABLE],
        writable: false
      };
    }
  } return $defineProperty(O, P, Attributes);
} : $defineProperty : function defineProperty(O, P, Attributes) {
  anObject$6(O);
  P = toPropertyKey(P);
  anObject$6(Attributes);
  if (IE8_DOM_DEFINE) try {
    return $defineProperty(O, P, Attributes);
  } catch (error) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw $TypeError$3('Accessors not supported');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};

var DESCRIPTORS$6 = descriptors;
var definePropertyModule$3 = objectDefineProperty;
var createPropertyDescriptor$1 = createPropertyDescriptor$3;

var createNonEnumerableProperty$4 = DESCRIPTORS$6 ? function (object, key, value) {
  return definePropertyModule$3.f(object, key, createPropertyDescriptor$1(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};

var makeBuiltIn$2 = {exports: {}};

var DESCRIPTORS$5 = descriptors;
var hasOwn$8 = hasOwnProperty_1;

var FunctionPrototype = Function.prototype;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getDescriptor = DESCRIPTORS$5 && Object.getOwnPropertyDescriptor;

var EXISTS = hasOwn$8(FunctionPrototype, 'name');
// additional protection from minified / mangled / dropped function names
var PROPER = EXISTS && (function something() { /* empty */ }).name === 'something';
var CONFIGURABLE = EXISTS && (!DESCRIPTORS$5 || (DESCRIPTORS$5 && getDescriptor(FunctionPrototype, 'name').configurable));

var functionName = {
  EXISTS: EXISTS,
  PROPER: PROPER,
  CONFIGURABLE: CONFIGURABLE
};

var uncurryThis$6 = functionUncurryThis;
var isCallable$a = isCallable$g;
var store$1 = sharedStore;

var functionToString = uncurryThis$6(Function.toString);

// this helper broken in `core-js@3.4.1-3.4.4`, so we can't use `shared` helper
if (!isCallable$a(store$1.inspectSource)) {
  store$1.inspectSource = function (it) {
    return functionToString(it);
  };
}

var inspectSource$1 = store$1.inspectSource;

var global$6 = global$d;
var isCallable$9 = isCallable$g;

var WeakMap$2 = global$6.WeakMap;

var weakMapBasicDetection = isCallable$9(WeakMap$2) && /native code/.test(String(WeakMap$2));

var shared$1 = shared$3.exports;
var uid = uid$2;

var keys = shared$1('keys');

var sharedKey$3 = function (key) {
  return keys[key] || (keys[key] = uid(key));
};

var hiddenKeys$4 = {};

var NATIVE_WEAK_MAP = weakMapBasicDetection;
var global$5 = global$d;
var isObject$2 = isObject$7;
var createNonEnumerableProperty$3 = createNonEnumerableProperty$4;
var hasOwn$7 = hasOwnProperty_1;
var shared = sharedStore;
var sharedKey$2 = sharedKey$3;
var hiddenKeys$3 = hiddenKeys$4;

var OBJECT_ALREADY_INITIALIZED = 'Object already initialized';
var TypeError$1 = global$5.TypeError;
var WeakMap$1 = global$5.WeakMap;
var set, get, has;

var enforce = function (it) {
  return has(it) ? get(it) : set(it, {});
};

var getterFor = function (TYPE) {
  return function (it) {
    var state;
    if (!isObject$2(it) || (state = get(it)).type !== TYPE) {
      throw TypeError$1('Incompatible receiver, ' + TYPE + ' required');
    } return state;
  };
};

if (NATIVE_WEAK_MAP || shared.state) {
  var store = shared.state || (shared.state = new WeakMap$1());
  /* eslint-disable no-self-assign -- prototype methods protection */
  store.get = store.get;
  store.has = store.has;
  store.set = store.set;
  /* eslint-enable no-self-assign -- prototype methods protection */
  set = function (it, metadata) {
    if (store.has(it)) throw TypeError$1(OBJECT_ALREADY_INITIALIZED);
    metadata.facade = it;
    store.set(it, metadata);
    return metadata;
  };
  get = function (it) {
    return store.get(it) || {};
  };
  has = function (it) {
    return store.has(it);
  };
} else {
  var STATE = sharedKey$2('state');
  hiddenKeys$3[STATE] = true;
  set = function (it, metadata) {
    if (hasOwn$7(it, STATE)) throw TypeError$1(OBJECT_ALREADY_INITIALIZED);
    metadata.facade = it;
    createNonEnumerableProperty$3(it, STATE, metadata);
    return metadata;
  };
  get = function (it) {
    return hasOwn$7(it, STATE) ? it[STATE] : {};
  };
  has = function (it) {
    return hasOwn$7(it, STATE);
  };
}

var internalState = {
  set: set,
  get: get,
  has: has,
  enforce: enforce,
  getterFor: getterFor
};

var fails$7 = fails$e;
var isCallable$8 = isCallable$g;
var hasOwn$6 = hasOwnProperty_1;
var DESCRIPTORS$4 = descriptors;
var CONFIGURABLE_FUNCTION_NAME$1 = functionName.CONFIGURABLE;
var inspectSource = inspectSource$1;
var InternalStateModule$1 = internalState;

var enforceInternalState = InternalStateModule$1.enforce;
var getInternalState$1 = InternalStateModule$1.get;
// eslint-disable-next-line es/no-object-defineproperty -- safe
var defineProperty$5 = Object.defineProperty;

var CONFIGURABLE_LENGTH = DESCRIPTORS$4 && !fails$7(function () {
  return defineProperty$5(function () { /* empty */ }, 'length', { value: 8 }).length !== 8;
});

var TEMPLATE = String(String).split('String');

var makeBuiltIn$1 = makeBuiltIn$2.exports = function (value, name, options) {
  if (String(name).slice(0, 7) === 'Symbol(') {
    name = '[' + String(name).replace(/^Symbol\(([^)]*)\)/, '$1') + ']';
  }
  if (options && options.getter) name = 'get ' + name;
  if (options && options.setter) name = 'set ' + name;
  if (!hasOwn$6(value, 'name') || (CONFIGURABLE_FUNCTION_NAME$1 && value.name !== name)) {
    if (DESCRIPTORS$4) defineProperty$5(value, 'name', { value: name, configurable: true });
    else value.name = name;
  }
  if (CONFIGURABLE_LENGTH && options && hasOwn$6(options, 'arity') && value.length !== options.arity) {
    defineProperty$5(value, 'length', { value: options.arity });
  }
  try {
    if (options && hasOwn$6(options, 'constructor') && options.constructor) {
      if (DESCRIPTORS$4) defineProperty$5(value, 'prototype', { writable: false });
    // in V8 ~ Chrome 53, prototypes of some methods, like `Array.prototype.values`, are non-writable
    } else if (value.prototype) value.prototype = undefined;
  } catch (error) { /* empty */ }
  var state = enforceInternalState(value);
  if (!hasOwn$6(state, 'source')) {
    state.source = TEMPLATE.join(typeof name == 'string' ? name : '');
  } return value;
};

// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
// eslint-disable-next-line no-extend-native -- required
Function.prototype.toString = makeBuiltIn$1(function toString() {
  return isCallable$8(this) && getInternalState$1(this).source || inspectSource(this);
}, 'toString');

var isCallable$7 = isCallable$g;
var definePropertyModule$2 = objectDefineProperty;
var makeBuiltIn = makeBuiltIn$2.exports;
var defineGlobalProperty$1 = defineGlobalProperty$3;

var defineBuiltIn$4 = function (O, key, value, options) {
  if (!options) options = {};
  var simple = options.enumerable;
  var name = options.name !== undefined ? options.name : key;
  if (isCallable$7(value)) makeBuiltIn(value, name, options);
  if (options.global) {
    if (simple) O[key] = value;
    else defineGlobalProperty$1(key, value);
  } else {
    try {
      if (!options.unsafe) delete O[key];
      else if (O[key]) simple = true;
    } catch (error) { /* empty */ }
    if (simple) O[key] = value;
    else definePropertyModule$2.f(O, key, {
      value: value,
      enumerable: false,
      configurable: !options.nonConfigurable,
      writable: !options.nonWritable
    });
  } return O;
};

var objectGetOwnPropertyNames = {};

var ceil = Math.ceil;
var floor = Math.floor;

// `Math.trunc` method
// https://tc39.es/ecma262/#sec-math.trunc
// eslint-disable-next-line es/no-math-trunc -- safe
var mathTrunc = Math.trunc || function trunc(x) {
  var n = +x;
  return (n > 0 ? floor : ceil)(n);
};

var trunc = mathTrunc;

// `ToIntegerOrInfinity` abstract operation
// https://tc39.es/ecma262/#sec-tointegerorinfinity
var toIntegerOrInfinity$2 = function (argument) {
  var number = +argument;
  // eslint-disable-next-line no-self-compare -- NaN check
  return number !== number || number === 0 ? 0 : trunc(number);
};

var toIntegerOrInfinity$1 = toIntegerOrInfinity$2;

var max = Math.max;
var min$1 = Math.min;

// Helper for a popular repeating case of the spec:
// Let integer be ? ToInteger(index).
// If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).
var toAbsoluteIndex$1 = function (index, length) {
  var integer = toIntegerOrInfinity$1(index);
  return integer < 0 ? max(integer + length, 0) : min$1(integer, length);
};

var toIntegerOrInfinity = toIntegerOrInfinity$2;

var min = Math.min;

// `ToLength` abstract operation
// https://tc39.es/ecma262/#sec-tolength
var toLength$1 = function (argument) {
  return argument > 0 ? min(toIntegerOrInfinity(argument), 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
};

var toLength = toLength$1;

// `LengthOfArrayLike` abstract operation
// https://tc39.es/ecma262/#sec-lengthofarraylike
var lengthOfArrayLike$2 = function (obj) {
  return toLength(obj.length);
};

var toIndexedObject$3 = toIndexedObject$5;
var toAbsoluteIndex = toAbsoluteIndex$1;
var lengthOfArrayLike$1 = lengthOfArrayLike$2;

// `Array.prototype.{ indexOf, includes }` methods implementation
var createMethod$1 = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIndexedObject$3($this);
    var length = lengthOfArrayLike$1(O);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare -- NaN check
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare -- NaN check
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) {
      if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};

var arrayIncludes = {
  // `Array.prototype.includes` method
  // https://tc39.es/ecma262/#sec-array.prototype.includes
  includes: createMethod$1(true),
  // `Array.prototype.indexOf` method
  // https://tc39.es/ecma262/#sec-array.prototype.indexof
  indexOf: createMethod$1(false)
};

var uncurryThis$5 = functionUncurryThis;
var hasOwn$5 = hasOwnProperty_1;
var toIndexedObject$2 = toIndexedObject$5;
var indexOf = arrayIncludes.indexOf;
var hiddenKeys$2 = hiddenKeys$4;

var push = uncurryThis$5([].push);

var objectKeysInternal = function (object, names) {
  var O = toIndexedObject$2(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) !hasOwn$5(hiddenKeys$2, key) && hasOwn$5(O, key) && push(result, key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (hasOwn$5(O, key = names[i++])) {
    ~indexOf(result, key) || push(result, key);
  }
  return result;
};

// IE8- don't enum bug keys
var enumBugKeys$3 = [
  'constructor',
  'hasOwnProperty',
  'isPrototypeOf',
  'propertyIsEnumerable',
  'toLocaleString',
  'toString',
  'valueOf'
];

var internalObjectKeys$1 = objectKeysInternal;
var enumBugKeys$2 = enumBugKeys$3;

var hiddenKeys$1 = enumBugKeys$2.concat('length', 'prototype');

// `Object.getOwnPropertyNames` method
// https://tc39.es/ecma262/#sec-object.getownpropertynames
// eslint-disable-next-line es/no-object-getownpropertynames -- safe
objectGetOwnPropertyNames.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return internalObjectKeys$1(O, hiddenKeys$1);
};

var objectGetOwnPropertySymbols = {};

// eslint-disable-next-line es/no-object-getownpropertysymbols -- safe
objectGetOwnPropertySymbols.f = Object.getOwnPropertySymbols;

var getBuiltIn$1 = getBuiltIn$4;
var uncurryThis$4 = functionUncurryThis;
var getOwnPropertyNamesModule = objectGetOwnPropertyNames;
var getOwnPropertySymbolsModule$1 = objectGetOwnPropertySymbols;
var anObject$5 = anObject$7;

var concat$1 = uncurryThis$4([].concat);

// all object keys, includes non-enumerable and symbols
var ownKeys$1 = getBuiltIn$1('Reflect', 'ownKeys') || function ownKeys(it) {
  var keys = getOwnPropertyNamesModule.f(anObject$5(it));
  var getOwnPropertySymbols = getOwnPropertySymbolsModule$1.f;
  return getOwnPropertySymbols ? concat$1(keys, getOwnPropertySymbols(it)) : keys;
};

var hasOwn$4 = hasOwnProperty_1;
var ownKeys = ownKeys$1;
var getOwnPropertyDescriptorModule = objectGetOwnPropertyDescriptor;
var definePropertyModule$1 = objectDefineProperty;

var copyConstructorProperties$2 = function (target, source, exceptions) {
  var keys = ownKeys(source);
  var defineProperty = definePropertyModule$1.f;
  var getOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    if (!hasOwn$4(target, key) && !(exceptions && hasOwn$4(exceptions, key))) {
      defineProperty(target, key, getOwnPropertyDescriptor(source, key));
    }
  }
};

var fails$6 = fails$e;
var isCallable$6 = isCallable$g;

var replacement = /#|\.prototype\./;

var isForced$1 = function (feature, detection) {
  var value = data[normalize(feature)];
  return value == POLYFILL ? true
    : value == NATIVE ? false
    : isCallable$6(detection) ? fails$6(detection)
    : !!detection;
};

var normalize = isForced$1.normalize = function (string) {
  return String(string).replace(replacement, '.').toLowerCase();
};

var data = isForced$1.data = {};
var NATIVE = isForced$1.NATIVE = 'N';
var POLYFILL = isForced$1.POLYFILL = 'P';

var isForced_1 = isForced$1;

var global$4 = global$d;
var getOwnPropertyDescriptor = objectGetOwnPropertyDescriptor.f;
var createNonEnumerableProperty$2 = createNonEnumerableProperty$4;
var defineBuiltIn$3 = defineBuiltIn$4;
var defineGlobalProperty = defineGlobalProperty$3;
var copyConstructorProperties$1 = copyConstructorProperties$2;
var isForced = isForced_1;

/*
  options.target         - name of the target object
  options.global         - target is the global object
  options.stat           - export as static methods of target
  options.proto          - export as prototype methods of target
  options.real           - real prototype method for the `pure` version
  options.forced         - export even if the native feature is available
  options.bind           - bind methods to the target, required for the `pure` version
  options.wrap           - wrap constructors to preventing global pollution, required for the `pure` version
  options.unsafe         - use the simple assignment of property instead of delete + defineProperty
  options.sham           - add a flag to not completely full polyfills
  options.enumerable     - export as enumerable property
  options.dontCallGetSet - prevent calling a getter on target
  options.name           - the .name of the function if it does not match the key
*/
var _export = function (options, source) {
  var TARGET = options.target;
  var GLOBAL = options.global;
  var STATIC = options.stat;
  var FORCED, target, key, targetProperty, sourceProperty, descriptor;
  if (GLOBAL) {
    target = global$4;
  } else if (STATIC) {
    target = global$4[TARGET] || defineGlobalProperty(TARGET, {});
  } else {
    target = (global$4[TARGET] || {}).prototype;
  }
  if (target) for (key in source) {
    sourceProperty = source[key];
    if (options.dontCallGetSet) {
      descriptor = getOwnPropertyDescriptor(target, key);
      targetProperty = descriptor && descriptor.value;
    } else targetProperty = target[key];
    FORCED = isForced(GLOBAL ? key : TARGET + (STATIC ? '.' : '#') + key, options.forced);
    // contained in target
    if (!FORCED && targetProperty !== undefined) {
      if (typeof sourceProperty == typeof targetProperty) continue;
      copyConstructorProperties$1(sourceProperty, targetProperty);
    }
    // add a flag to not completely full polyfills
    if (options.sham || (targetProperty && targetProperty.sham)) {
      createNonEnumerableProperty$2(sourceProperty, 'sham', true);
    }
    defineBuiltIn$3(target, key, sourceProperty, options);
  }
};

var internalObjectKeys = objectKeysInternal;
var enumBugKeys$1 = enumBugKeys$3;

// `Object.keys` method
// https://tc39.es/ecma262/#sec-object.keys
// eslint-disable-next-line es/no-object-keys -- safe
var objectKeys$2 = Object.keys || function keys(O) {
  return internalObjectKeys(O, enumBugKeys$1);
};

var DESCRIPTORS$3 = descriptors;
var uncurryThis$3 = functionUncurryThis;
var call$2 = functionCall;
var fails$5 = fails$e;
var objectKeys$1 = objectKeys$2;
var getOwnPropertySymbolsModule = objectGetOwnPropertySymbols;
var propertyIsEnumerableModule = objectPropertyIsEnumerable;
var toObject$2 = toObject$4;
var IndexedObject$1 = indexedObject;

// eslint-disable-next-line es/no-object-assign -- safe
var $assign = Object.assign;
// eslint-disable-next-line es/no-object-defineproperty -- required for testing
var defineProperty$4 = Object.defineProperty;
var concat = uncurryThis$3([].concat);

// `Object.assign` method
// https://tc39.es/ecma262/#sec-object.assign
var objectAssign = !$assign || fails$5(function () {
  // should have correct order of operations (Edge bug)
  if (DESCRIPTORS$3 && $assign({ b: 1 }, $assign(defineProperty$4({}, 'a', {
    enumerable: true,
    get: function () {
      defineProperty$4(this, 'b', {
        value: 3,
        enumerable: false
      });
    }
  }), { b: 2 })).b !== 1) return true;
  // should work with symbols and should have deterministic property order (V8 bug)
  var A = {};
  var B = {};
  // eslint-disable-next-line es/no-symbol -- safe
  var symbol = Symbol();
  var alphabet = 'abcdefghijklmnopqrst';
  A[symbol] = 7;
  alphabet.split('').forEach(function (chr) { B[chr] = chr; });
  return $assign({}, A)[symbol] != 7 || objectKeys$1($assign({}, B)).join('') != alphabet;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars -- required for `.length`
  var T = toObject$2(target);
  var argumentsLength = arguments.length;
  var index = 1;
  var getOwnPropertySymbols = getOwnPropertySymbolsModule.f;
  var propertyIsEnumerable = propertyIsEnumerableModule.f;
  while (argumentsLength > index) {
    var S = IndexedObject$1(arguments[index++]);
    var keys = getOwnPropertySymbols ? concat(objectKeys$1(S), getOwnPropertySymbols(S)) : objectKeys$1(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) {
      key = keys[j++];
      if (!DESCRIPTORS$3 || call$2(propertyIsEnumerable, S, key)) T[key] = S[key];
    }
  } return T;
} : $assign;

var $$5 = _export;
var assign$1 = objectAssign;

// `Object.assign` method
// https://tc39.es/ecma262/#sec-object.assign
// eslint-disable-next-line es/no-object-assign -- required for testing
$$5({ target: 'Object', stat: true, arity: 2, forced: Object.assign !== assign$1 }, {
  assign: assign$1
});

var objectDefineProperties = {};

var DESCRIPTORS$2 = descriptors;
var V8_PROTOTYPE_DEFINE_BUG = v8PrototypeDefineBug;
var definePropertyModule = objectDefineProperty;
var anObject$4 = anObject$7;
var toIndexedObject$1 = toIndexedObject$5;
var objectKeys = objectKeys$2;

// `Object.defineProperties` method
// https://tc39.es/ecma262/#sec-object.defineproperties
// eslint-disable-next-line es/no-object-defineproperties -- safe
objectDefineProperties.f = DESCRIPTORS$2 && !V8_PROTOTYPE_DEFINE_BUG ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject$4(O);
  var props = toIndexedObject$1(Properties);
  var keys = objectKeys(Properties);
  var length = keys.length;
  var index = 0;
  var key;
  while (length > index) definePropertyModule.f(O, key = keys[index++], props[key]);
  return O;
};

var getBuiltIn = getBuiltIn$4;

var html$1 = getBuiltIn('document', 'documentElement');

/* global ActiveXObject -- old IE, WSH */

var anObject$3 = anObject$7;
var definePropertiesModule = objectDefineProperties;
var enumBugKeys = enumBugKeys$3;
var hiddenKeys = hiddenKeys$4;
var html = html$1;
var documentCreateElement$1 = documentCreateElement$2;
var sharedKey$1 = sharedKey$3;

var GT = '>';
var LT = '<';
var PROTOTYPE = 'prototype';
var SCRIPT = 'script';
var IE_PROTO$1 = sharedKey$1('IE_PROTO');

var EmptyConstructor = function () { /* empty */ };

var scriptTag = function (content) {
  return LT + SCRIPT + GT + content + LT + '/' + SCRIPT + GT;
};

// Create object with fake `null` prototype: use ActiveX Object with cleared prototype
var NullProtoObjectViaActiveX = function (activeXDocument) {
  activeXDocument.write(scriptTag(''));
  activeXDocument.close();
  var temp = activeXDocument.parentWindow.Object;
  activeXDocument = null; // avoid memory leak
  return temp;
};

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var NullProtoObjectViaIFrame = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = documentCreateElement$1('iframe');
  var JS = 'java' + SCRIPT + ':';
  var iframeDocument;
  iframe.style.display = 'none';
  html.appendChild(iframe);
  // https://github.com/zloirock/core-js/issues/475
  iframe.src = String(JS);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(scriptTag('document.F=Object'));
  iframeDocument.close();
  return iframeDocument.F;
};

// Check for document.domain and active x support
// No need to use active x approach when document.domain is not set
// see https://github.com/es-shims/es5-shim/issues/150
// variation of https://github.com/kitcambridge/es5-shim/commit/4f738ac066346
// avoid IE GC bug
var activeXDocument;
var NullProtoObject = function () {
  try {
    activeXDocument = new ActiveXObject('htmlfile');
  } catch (error) { /* ignore */ }
  NullProtoObject = typeof document != 'undefined'
    ? document.domain && activeXDocument
      ? NullProtoObjectViaActiveX(activeXDocument) // old IE
      : NullProtoObjectViaIFrame()
    : NullProtoObjectViaActiveX(activeXDocument); // WSH
  var length = enumBugKeys.length;
  while (length--) delete NullProtoObject[PROTOTYPE][enumBugKeys[length]];
  return NullProtoObject();
};

hiddenKeys[IE_PROTO$1] = true;

// `Object.create` method
// https://tc39.es/ecma262/#sec-object.create
// eslint-disable-next-line es/no-object-create -- safe
var objectCreate = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    EmptyConstructor[PROTOTYPE] = anObject$3(O);
    result = new EmptyConstructor();
    EmptyConstructor[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO$1] = O;
  } else result = NullProtoObject();
  return Properties === undefined ? result : definePropertiesModule.f(result, Properties);
};

var wellKnownSymbol$8 = wellKnownSymbol$a;
var create$1 = objectCreate;
var defineProperty$3 = objectDefineProperty.f;

var UNSCOPABLES = wellKnownSymbol$8('unscopables');
var ArrayPrototype = Array.prototype;

// Array.prototype[@@unscopables]
// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
if (ArrayPrototype[UNSCOPABLES] == undefined) {
  defineProperty$3(ArrayPrototype, UNSCOPABLES, {
    configurable: true,
    value: create$1(null)
  });
}

// add a key to Array.prototype[@@unscopables]
var addToUnscopables$2 = function (key) {
  ArrayPrototype[UNSCOPABLES][key] = true;
};

var iterators = {};

var fails$4 = fails$e;

var correctPrototypeGetter = !fails$4(function () {
  function F() { /* empty */ }
  F.prototype.constructor = null;
  // eslint-disable-next-line es/no-object-getprototypeof -- required for testing
  return Object.getPrototypeOf(new F()) !== F.prototype;
});

var hasOwn$3 = hasOwnProperty_1;
var isCallable$5 = isCallable$g;
var toObject$1 = toObject$4;
var sharedKey = sharedKey$3;
var CORRECT_PROTOTYPE_GETTER = correctPrototypeGetter;

var IE_PROTO = sharedKey('IE_PROTO');
var $Object$1 = Object;
var ObjectPrototype = $Object$1.prototype;

// `Object.getPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.getprototypeof
// eslint-disable-next-line es/no-object-getprototypeof -- safe
var objectGetPrototypeOf = CORRECT_PROTOTYPE_GETTER ? $Object$1.getPrototypeOf : function (O) {
  var object = toObject$1(O);
  if (hasOwn$3(object, IE_PROTO)) return object[IE_PROTO];
  var constructor = object.constructor;
  if (isCallable$5(constructor) && object instanceof constructor) {
    return constructor.prototype;
  } return object instanceof $Object$1 ? ObjectPrototype : null;
};

var fails$3 = fails$e;
var isCallable$4 = isCallable$g;
var isObject$1 = isObject$7;
var getPrototypeOf$1 = objectGetPrototypeOf;
var defineBuiltIn$2 = defineBuiltIn$4;
var wellKnownSymbol$7 = wellKnownSymbol$a;

var ITERATOR$2 = wellKnownSymbol$7('iterator');
var BUGGY_SAFARI_ITERATORS$1 = false;

// `%IteratorPrototype%` object
// https://tc39.es/ecma262/#sec-%iteratorprototype%-object
var IteratorPrototype$2, PrototypeOfArrayIteratorPrototype, arrayIterator;

/* eslint-disable es/no-array-prototype-keys -- safe */
if ([].keys) {
  arrayIterator = [].keys();
  // Safari 8 has buggy iterators w/o `next`
  if (!('next' in arrayIterator)) BUGGY_SAFARI_ITERATORS$1 = true;
  else {
    PrototypeOfArrayIteratorPrototype = getPrototypeOf$1(getPrototypeOf$1(arrayIterator));
    if (PrototypeOfArrayIteratorPrototype !== Object.prototype) IteratorPrototype$2 = PrototypeOfArrayIteratorPrototype;
  }
}

var NEW_ITERATOR_PROTOTYPE = !isObject$1(IteratorPrototype$2) || fails$3(function () {
  var test = {};
  // FF44- legacy iterators case
  return IteratorPrototype$2[ITERATOR$2].call(test) !== test;
});

if (NEW_ITERATOR_PROTOTYPE) IteratorPrototype$2 = {};

// `%IteratorPrototype%[@@iterator]()` method
// https://tc39.es/ecma262/#sec-%iteratorprototype%-@@iterator
if (!isCallable$4(IteratorPrototype$2[ITERATOR$2])) {
  defineBuiltIn$2(IteratorPrototype$2, ITERATOR$2, function () {
    return this;
  });
}

var iteratorsCore = {
  IteratorPrototype: IteratorPrototype$2,
  BUGGY_SAFARI_ITERATORS: BUGGY_SAFARI_ITERATORS$1
};

var defineProperty$2 = objectDefineProperty.f;
var hasOwn$2 = hasOwnProperty_1;
var wellKnownSymbol$6 = wellKnownSymbol$a;

var TO_STRING_TAG$3 = wellKnownSymbol$6('toStringTag');

var setToStringTag$2 = function (target, TAG, STATIC) {
  if (target && !STATIC) target = target.prototype;
  if (target && !hasOwn$2(target, TO_STRING_TAG$3)) {
    defineProperty$2(target, TO_STRING_TAG$3, { configurable: true, value: TAG });
  }
};

var IteratorPrototype$1 = iteratorsCore.IteratorPrototype;
var create = objectCreate;
var createPropertyDescriptor = createPropertyDescriptor$3;
var setToStringTag$1 = setToStringTag$2;
var Iterators$2 = iterators;

var returnThis$1 = function () { return this; };

var iteratorCreateConstructor = function (IteratorConstructor, NAME, next, ENUMERABLE_NEXT) {
  var TO_STRING_TAG = NAME + ' Iterator';
  IteratorConstructor.prototype = create(IteratorPrototype$1, { next: createPropertyDescriptor(+!ENUMERABLE_NEXT, next) });
  setToStringTag$1(IteratorConstructor, TO_STRING_TAG, false);
  Iterators$2[TO_STRING_TAG] = returnThis$1;
  return IteratorConstructor;
};

var isCallable$3 = isCallable$g;

var $String$1 = String;
var $TypeError$2 = TypeError;

var aPossiblePrototype$1 = function (argument) {
  if (typeof argument == 'object' || isCallable$3(argument)) return argument;
  throw $TypeError$2("Can't set " + $String$1(argument) + ' as a prototype');
};

/* eslint-disable no-proto -- safe */

var uncurryThis$2 = functionUncurryThis;
var anObject$2 = anObject$7;
var aPossiblePrototype = aPossiblePrototype$1;

// `Object.setPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.setprototypeof
// Works with __proto__ only. Old v8 can't work with null proto objects.
// eslint-disable-next-line es/no-object-setprototypeof -- safe
var objectSetPrototypeOf = Object.setPrototypeOf || ('__proto__' in {} ? function () {
  var CORRECT_SETTER = false;
  var test = {};
  var setter;
  try {
    // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
    setter = uncurryThis$2(Object.getOwnPropertyDescriptor(Object.prototype, '__proto__').set);
    setter(test, []);
    CORRECT_SETTER = test instanceof Array;
  } catch (error) { /* empty */ }
  return function setPrototypeOf(O, proto) {
    anObject$2(O);
    aPossiblePrototype(proto);
    if (CORRECT_SETTER) setter(O, proto);
    else O.__proto__ = proto;
    return O;
  };
}() : undefined);

var $$4 = _export;
var call$1 = functionCall;
var FunctionName = functionName;
var isCallable$2 = isCallable$g;
var createIteratorConstructor = iteratorCreateConstructor;
var getPrototypeOf = objectGetPrototypeOf;
var setPrototypeOf = objectSetPrototypeOf;
var setToStringTag = setToStringTag$2;
var createNonEnumerableProperty$1 = createNonEnumerableProperty$4;
var defineBuiltIn$1 = defineBuiltIn$4;
var wellKnownSymbol$5 = wellKnownSymbol$a;
var Iterators$1 = iterators;
var IteratorsCore = iteratorsCore;

var PROPER_FUNCTION_NAME$1 = FunctionName.PROPER;
var CONFIGURABLE_FUNCTION_NAME = FunctionName.CONFIGURABLE;
var IteratorPrototype = IteratorsCore.IteratorPrototype;
var BUGGY_SAFARI_ITERATORS = IteratorsCore.BUGGY_SAFARI_ITERATORS;
var ITERATOR$1 = wellKnownSymbol$5('iterator');
var KEYS = 'keys';
var VALUES = 'values';
var ENTRIES = 'entries';

var returnThis = function () { return this; };

var iteratorDefine = function (Iterable, NAME, IteratorConstructor, next, DEFAULT, IS_SET, FORCED) {
  createIteratorConstructor(IteratorConstructor, NAME, next);

  var getIterationMethod = function (KIND) {
    if (KIND === DEFAULT && defaultIterator) return defaultIterator;
    if (!BUGGY_SAFARI_ITERATORS && KIND in IterablePrototype) return IterablePrototype[KIND];
    switch (KIND) {
      case KEYS: return function keys() { return new IteratorConstructor(this, KIND); };
      case VALUES: return function values() { return new IteratorConstructor(this, KIND); };
      case ENTRIES: return function entries() { return new IteratorConstructor(this, KIND); };
    } return function () { return new IteratorConstructor(this); };
  };

  var TO_STRING_TAG = NAME + ' Iterator';
  var INCORRECT_VALUES_NAME = false;
  var IterablePrototype = Iterable.prototype;
  var nativeIterator = IterablePrototype[ITERATOR$1]
    || IterablePrototype['@@iterator']
    || DEFAULT && IterablePrototype[DEFAULT];
  var defaultIterator = !BUGGY_SAFARI_ITERATORS && nativeIterator || getIterationMethod(DEFAULT);
  var anyNativeIterator = NAME == 'Array' ? IterablePrototype.entries || nativeIterator : nativeIterator;
  var CurrentIteratorPrototype, methods, KEY;

  // fix native
  if (anyNativeIterator) {
    CurrentIteratorPrototype = getPrototypeOf(anyNativeIterator.call(new Iterable()));
    if (CurrentIteratorPrototype !== Object.prototype && CurrentIteratorPrototype.next) {
      if (getPrototypeOf(CurrentIteratorPrototype) !== IteratorPrototype) {
        if (setPrototypeOf) {
          setPrototypeOf(CurrentIteratorPrototype, IteratorPrototype);
        } else if (!isCallable$2(CurrentIteratorPrototype[ITERATOR$1])) {
          defineBuiltIn$1(CurrentIteratorPrototype, ITERATOR$1, returnThis);
        }
      }
      // Set @@toStringTag to native iterators
      setToStringTag(CurrentIteratorPrototype, TO_STRING_TAG, true);
    }
  }

  // fix Array.prototype.{ values, @@iterator }.name in V8 / FF
  if (PROPER_FUNCTION_NAME$1 && DEFAULT == VALUES && nativeIterator && nativeIterator.name !== VALUES) {
    if (CONFIGURABLE_FUNCTION_NAME) {
      createNonEnumerableProperty$1(IterablePrototype, 'name', VALUES);
    } else {
      INCORRECT_VALUES_NAME = true;
      defaultIterator = function values() { return call$1(nativeIterator, this); };
    }
  }

  // export additional methods
  if (DEFAULT) {
    methods = {
      values: getIterationMethod(VALUES),
      keys: IS_SET ? defaultIterator : getIterationMethod(KEYS),
      entries: getIterationMethod(ENTRIES)
    };
    if (FORCED) for (KEY in methods) {
      if (BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME || !(KEY in IterablePrototype)) {
        defineBuiltIn$1(IterablePrototype, KEY, methods[KEY]);
      }
    } else $$4({ target: NAME, proto: true, forced: BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME }, methods);
  }

  // define iterator
  if (IterablePrototype[ITERATOR$1] !== defaultIterator) {
    defineBuiltIn$1(IterablePrototype, ITERATOR$1, defaultIterator, { name: DEFAULT });
  }
  Iterators$1[NAME] = defaultIterator;

  return methods;
};

// `CreateIterResultObject` abstract operation
// https://tc39.es/ecma262/#sec-createiterresultobject
var createIterResultObject$1 = function (value, done) {
  return { value: value, done: done };
};

var toIndexedObject = toIndexedObject$5;
var addToUnscopables$1 = addToUnscopables$2;
var Iterators = iterators;
var InternalStateModule = internalState;
var defineProperty$1 = objectDefineProperty.f;
var defineIterator = iteratorDefine;
var createIterResultObject = createIterResultObject$1;
var DESCRIPTORS$1 = descriptors;

var ARRAY_ITERATOR = 'Array Iterator';
var setInternalState = InternalStateModule.set;
var getInternalState = InternalStateModule.getterFor(ARRAY_ITERATOR);

// `Array.prototype.entries` method
// https://tc39.es/ecma262/#sec-array.prototype.entries
// `Array.prototype.keys` method
// https://tc39.es/ecma262/#sec-array.prototype.keys
// `Array.prototype.values` method
// https://tc39.es/ecma262/#sec-array.prototype.values
// `Array.prototype[@@iterator]` method
// https://tc39.es/ecma262/#sec-array.prototype-@@iterator
// `CreateArrayIterator` internal method
// https://tc39.es/ecma262/#sec-createarrayiterator
var es_array_iterator = defineIterator(Array, 'Array', function (iterated, kind) {
  setInternalState(this, {
    type: ARRAY_ITERATOR,
    target: toIndexedObject(iterated), // target
    index: 0,                          // next index
    kind: kind                         // kind
  });
// `%ArrayIteratorPrototype%.next` method
// https://tc39.es/ecma262/#sec-%arrayiteratorprototype%.next
}, function () {
  var state = getInternalState(this);
  var target = state.target;
  var kind = state.kind;
  var index = state.index++;
  if (!target || index >= target.length) {
    state.target = undefined;
    return createIterResultObject(undefined, true);
  }
  if (kind == 'keys') return createIterResultObject(index, false);
  if (kind == 'values') return createIterResultObject(target[index], false);
  return createIterResultObject([index, target[index]], false);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values%
// https://tc39.es/ecma262/#sec-createunmappedargumentsobject
// https://tc39.es/ecma262/#sec-createmappedargumentsobject
var values = Iterators.Arguments = Iterators.Array;

// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables$1('keys');
addToUnscopables$1('values');
addToUnscopables$1('entries');

// V8 ~ Chrome 45- bug
if (DESCRIPTORS$1 && values.name !== 'values') try {
  defineProperty$1(values, 'name', { value: 'values' });
} catch (error) { /* empty */ }

// iterable DOM collections
// flag - `iterable` interface - 'entries', 'keys', 'values', 'forEach' methods
var domIterables = {
  CSSRuleList: 0,
  CSSStyleDeclaration: 0,
  CSSValueList: 0,
  ClientRectList: 0,
  DOMRectList: 0,
  DOMStringList: 0,
  DOMTokenList: 1,
  DataTransferItemList: 0,
  FileList: 0,
  HTMLAllCollection: 0,
  HTMLCollection: 0,
  HTMLFormElement: 0,
  HTMLSelectElement: 0,
  MediaList: 0,
  MimeTypeArray: 0,
  NamedNodeMap: 0,
  NodeList: 1,
  PaintRequestList: 0,
  Plugin: 0,
  PluginArray: 0,
  SVGLengthList: 0,
  SVGNumberList: 0,
  SVGPathSegList: 0,
  SVGPointList: 0,
  SVGStringList: 0,
  SVGTransformList: 0,
  SourceBufferList: 0,
  StyleSheetList: 0,
  TextTrackCueList: 0,
  TextTrackList: 0,
  TouchList: 0
};

// in old WebKit versions, `element.classList` is not an instance of global `DOMTokenList`
var documentCreateElement = documentCreateElement$2;

var classList = documentCreateElement('span').classList;
var DOMTokenListPrototype$1 = classList && classList.constructor && classList.constructor.prototype;

var domTokenListPrototype = DOMTokenListPrototype$1 === Object.prototype ? undefined : DOMTokenListPrototype$1;

var global$3 = global$d;
var DOMIterables = domIterables;
var DOMTokenListPrototype = domTokenListPrototype;
var ArrayIteratorMethods = es_array_iterator;
var createNonEnumerableProperty = createNonEnumerableProperty$4;
var wellKnownSymbol$4 = wellKnownSymbol$a;

var ITERATOR = wellKnownSymbol$4('iterator');
var TO_STRING_TAG$2 = wellKnownSymbol$4('toStringTag');
var ArrayValues = ArrayIteratorMethods.values;

var handlePrototype = function (CollectionPrototype, COLLECTION_NAME) {
  if (CollectionPrototype) {
    // some Chrome versions have non-configurable methods on DOMTokenList
    if (CollectionPrototype[ITERATOR] !== ArrayValues) try {
      createNonEnumerableProperty(CollectionPrototype, ITERATOR, ArrayValues);
    } catch (error) {
      CollectionPrototype[ITERATOR] = ArrayValues;
    }
    if (!CollectionPrototype[TO_STRING_TAG$2]) {
      createNonEnumerableProperty(CollectionPrototype, TO_STRING_TAG$2, COLLECTION_NAME);
    }
    if (DOMIterables[COLLECTION_NAME]) for (var METHOD_NAME in ArrayIteratorMethods) {
      // some Chrome versions have non-configurable methods on DOMTokenList
      if (CollectionPrototype[METHOD_NAME] !== ArrayIteratorMethods[METHOD_NAME]) try {
        createNonEnumerableProperty(CollectionPrototype, METHOD_NAME, ArrayIteratorMethods[METHOD_NAME]);
      } catch (error) {
        CollectionPrototype[METHOD_NAME] = ArrayIteratorMethods[METHOD_NAME];
      }
    }
  }
};

for (var COLLECTION_NAME in DOMIterables) {
  handlePrototype(global$3[COLLECTION_NAME] && global$3[COLLECTION_NAME].prototype, COLLECTION_NAME);
}

handlePrototype(DOMTokenListPrototype, 'DOMTokenList');

var $$3 = _export;
var $includes = arrayIncludes.includes;
var fails$2 = fails$e;
var addToUnscopables = addToUnscopables$2;

// FF99+ bug
var BROKEN_ON_SPARSE = fails$2(function () {
  return !Array(1).includes();
});

// `Array.prototype.includes` method
// https://tc39.es/ecma262/#sec-array.prototype.includes
$$3({ target: 'Array', proto: true, forced: BROKEN_ON_SPARSE }, {
  includes: function includes(el /* , fromIndex = 0 */) {
    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
  }
});

// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables('includes');

var isObject = isObject$7;
var classof$3 = classofRaw$1;
var wellKnownSymbol$3 = wellKnownSymbol$a;

var MATCH$1 = wellKnownSymbol$3('match');

// `IsRegExp` abstract operation
// https://tc39.es/ecma262/#sec-isregexp
var isRegexp = function (it) {
  var isRegExp;
  return isObject(it) && ((isRegExp = it[MATCH$1]) !== undefined ? !!isRegExp : classof$3(it) == 'RegExp');
};

var isRegExp = isRegexp;

var $TypeError$1 = TypeError;

var notARegexp = function (it) {
  if (isRegExp(it)) {
    throw $TypeError$1("The method doesn't accept regular expressions");
  } return it;
};

var wellKnownSymbol$2 = wellKnownSymbol$a;

var TO_STRING_TAG$1 = wellKnownSymbol$2('toStringTag');
var test = {};

test[TO_STRING_TAG$1] = 'z';

var toStringTagSupport = String(test) === '[object z]';

var TO_STRING_TAG_SUPPORT = toStringTagSupport;
var isCallable$1 = isCallable$g;
var classofRaw = classofRaw$1;
var wellKnownSymbol$1 = wellKnownSymbol$a;

var TO_STRING_TAG = wellKnownSymbol$1('toStringTag');
var $Object = Object;

// ES3 wrong here
var CORRECT_ARGUMENTS = classofRaw(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (error) { /* empty */ }
};

// getting tag from ES6+ `Object.prototype.toString`
var classof$2 = TO_STRING_TAG_SUPPORT ? classofRaw : function (it) {
  var O, tag, result;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (tag = tryGet(O = $Object(it), TO_STRING_TAG)) == 'string' ? tag
    // builtinTag case
    : CORRECT_ARGUMENTS ? classofRaw(O)
    // ES3 arguments fallback
    : (result = classofRaw(O)) == 'Object' && isCallable$1(O.callee) ? 'Arguments' : result;
};

var classof$1 = classof$2;

var $String = String;

var toString$2 = function (argument) {
  if (classof$1(argument) === 'Symbol') throw TypeError('Cannot convert a Symbol value to a string');
  return $String(argument);
};

var wellKnownSymbol = wellKnownSymbol$a;

var MATCH = wellKnownSymbol('match');

var correctIsRegexpLogic = function (METHOD_NAME) {
  var regexp = /./;
  try {
    '/./'[METHOD_NAME](regexp);
  } catch (error1) {
    try {
      regexp[MATCH] = false;
      return '/./'[METHOD_NAME](regexp);
    } catch (error2) { /* empty */ }
  } return false;
};

var $$2 = _export;
var uncurryThis$1 = functionUncurryThis;
var notARegExp = notARegexp;
var requireObjectCoercible = requireObjectCoercible$3;
var toString$1 = toString$2;
var correctIsRegExpLogic = correctIsRegexpLogic;

var stringIndexOf = uncurryThis$1(''.indexOf);

// `String.prototype.includes` method
// https://tc39.es/ecma262/#sec-string.prototype.includes
$$2({ target: 'String', proto: true, forced: !correctIsRegExpLogic('includes') }, {
  includes: function includes(searchString /* , position = 0 */) {
    return !!~stringIndexOf(
      toString$1(requireObjectCoercible(this)),
      toString$1(notARegExp(searchString)),
      arguments.length > 1 ? arguments[1] : undefined
    );
  }
});

var aCallable = aCallable$2;
var toObject = toObject$4;
var IndexedObject = indexedObject;
var lengthOfArrayLike = lengthOfArrayLike$2;

var $TypeError = TypeError;

// `Array.prototype.{ reduce, reduceRight }` methods implementation
var createMethod = function (IS_RIGHT) {
  return function (that, callbackfn, argumentsLength, memo) {
    aCallable(callbackfn);
    var O = toObject(that);
    var self = IndexedObject(O);
    var length = lengthOfArrayLike(O);
    var index = IS_RIGHT ? length - 1 : 0;
    var i = IS_RIGHT ? -1 : 1;
    if (argumentsLength < 2) while (true) {
      if (index in self) {
        memo = self[index];
        index += i;
        break;
      }
      index += i;
      if (IS_RIGHT ? index < 0 : length <= index) {
        throw $TypeError('Reduce of empty array with no initial value');
      }
    }
    for (;IS_RIGHT ? index >= 0 : length > index; index += i) if (index in self) {
      memo = callbackfn(memo, self[index], index, O);
    }
    return memo;
  };
};

var arrayReduce = {
  // `Array.prototype.reduce` method
  // https://tc39.es/ecma262/#sec-array.prototype.reduce
  left: createMethod(false),
  // `Array.prototype.reduceRight` method
  // https://tc39.es/ecma262/#sec-array.prototype.reduceright
  right: createMethod(true)
};

var fails$1 = fails$e;

var arrayMethodIsStrict$1 = function (METHOD_NAME, argument) {
  var method = [][METHOD_NAME];
  return !!method && fails$1(function () {
    // eslint-disable-next-line no-useless-call -- required for testing
    method.call(null, argument || function () { return 1; }, 1);
  });
};

var classof = classofRaw$1;
var global$2 = global$d;

var engineIsNode = classof(global$2.process) == 'process';

var $$1 = _export;
var $reduce = arrayReduce.left;
var arrayMethodIsStrict = arrayMethodIsStrict$1;
var CHROME_VERSION = engineV8Version;
var IS_NODE = engineIsNode;

var STRICT_METHOD = arrayMethodIsStrict('reduce');
// Chrome 80-82 has a critical bug
// https://bugs.chromium.org/p/chromium/issues/detail?id=1049982
var CHROME_BUG = !IS_NODE && CHROME_VERSION > 79 && CHROME_VERSION < 83;

// `Array.prototype.reduce` method
// https://tc39.es/ecma262/#sec-array.prototype.reduce
$$1({ target: 'Array', proto: true, forced: !STRICT_METHOD || CHROME_BUG }, {
  reduce: function reduce(callbackfn /* , initialValue */) {
    var length = arguments.length;
    return $reduce(this, callbackfn, length, length > 1 ? arguments[1] : undefined);
  }
});

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

/*

Based off glamor's StyleSheet, thanks Sunil ❤️

high performance StyleSheet for css-in-js systems

- uses multiple style tags behind the scenes for millions of rules
- uses `insertRule` for appending in production for *much* faster performance

// usage

import { StyleSheet } from '@emotion/sheet'

let styleSheet = new StyleSheet({ key: '', container: document.head })

styleSheet.insert('#box { border: 1px solid red; }')
- appends a css rule into the stylesheet

styleSheet.flush()
- empties the stylesheet of all its contents

*/
// $FlowFixMe
function sheetForTag(tag) {
  if (tag.sheet) {
    // $FlowFixMe
    return tag.sheet;
  } // this weirdness brought to you by firefox

  /* istanbul ignore next */


  for (var i = 0; i < document.styleSheets.length; i++) {
    if (document.styleSheets[i].ownerNode === tag) {
      // $FlowFixMe
      return document.styleSheets[i];
    }
  }
}

function createStyleElement(options) {
  var tag = document.createElement('style');
  tag.setAttribute('data-emotion', options.key);

  if (options.nonce !== undefined) {
    tag.setAttribute('nonce', options.nonce);
  }

  tag.appendChild(document.createTextNode(''));
  tag.setAttribute('data-s', '');
  return tag;
}

var StyleSheet = /*#__PURE__*/function () {
  // Using Node instead of HTMLElement since container may be a ShadowRoot
  function StyleSheet(options) {
    var _this = this;

    this._insertTag = function (tag) {
      var before;

      if (_this.tags.length === 0) {
        if (_this.insertionPoint) {
          before = _this.insertionPoint.nextSibling;
        } else if (_this.prepend) {
          before = _this.container.firstChild;
        } else {
          before = _this.before;
        }
      } else {
        before = _this.tags[_this.tags.length - 1].nextSibling;
      }

      _this.container.insertBefore(tag, before);

      _this.tags.push(tag);
    };

    this.isSpeedy = options.speedy === undefined ? process.env.NODE_ENV === 'production' : options.speedy;
    this.tags = [];
    this.ctr = 0;
    this.nonce = options.nonce; // key is the value of the data-emotion attribute, it's used to identify different sheets

    this.key = options.key;
    this.container = options.container;
    this.prepend = options.prepend;
    this.insertionPoint = options.insertionPoint;
    this.before = null;
  }

  var _proto = StyleSheet.prototype;

  _proto.hydrate = function hydrate(nodes) {
    nodes.forEach(this._insertTag);
  };

  _proto.insert = function insert(rule) {
    // the max length is how many rules we have per style tag, it's 65000 in speedy mode
    // it's 1 in dev because we insert source maps that map a single rule to a location
    // and you can only have one source map per style tag
    if (this.ctr % (this.isSpeedy ? 65000 : 1) === 0) {
      this._insertTag(createStyleElement(this));
    }

    var tag = this.tags[this.tags.length - 1];

    if (process.env.NODE_ENV !== 'production') {
      var isImportRule = rule.charCodeAt(0) === 64 && rule.charCodeAt(1) === 105;

      if (isImportRule && this._alreadyInsertedOrderInsensitiveRule) {
        // this would only cause problem in speedy mode
        // but we don't want enabling speedy to affect the observable behavior
        // so we report this error at all times
        console.error("You're attempting to insert the following rule:\n" + rule + '\n\n`@import` rules must be before all other types of rules in a stylesheet but other rules have already been inserted. Please ensure that `@import` rules are before all other rules.');
      }
      this._alreadyInsertedOrderInsensitiveRule = this._alreadyInsertedOrderInsensitiveRule || !isImportRule;
    }

    if (this.isSpeedy) {
      var sheet = sheetForTag(tag);

      try {
        // this is the ultrafast version, works across browsers
        // the big drawback is that the css won't be editable in devtools
        sheet.insertRule(rule, sheet.cssRules.length);
      } catch (e) {
        if (process.env.NODE_ENV !== 'production' && !/:(-moz-placeholder|-moz-focus-inner|-moz-focusring|-ms-input-placeholder|-moz-read-write|-moz-read-only|-ms-clear|-ms-expand|-ms-reveal){/.test(rule)) {
          console.error("There was a problem inserting the following rule: \"" + rule + "\"", e);
        }
      }
    } else {
      tag.appendChild(document.createTextNode(rule));
    }

    this.ctr++;
  };

  _proto.flush = function flush() {
    // $FlowFixMe
    this.tags.forEach(function (tag) {
      return tag.parentNode && tag.parentNode.removeChild(tag);
    });
    this.tags = [];
    this.ctr = 0;

    if (process.env.NODE_ENV !== 'production') {
      this._alreadyInsertedOrderInsensitiveRule = false;
    }
  };

  return StyleSheet;
}();

var MS = '-ms-';
var MOZ = '-moz-';
var WEBKIT = '-webkit-';

var COMMENT = 'comm';
var RULESET = 'rule';
var DECLARATION = 'decl';
var IMPORT = '@import';
var KEYFRAMES = '@keyframes';

/**
 * @param {number}
 * @return {number}
 */
var abs = Math.abs;

/**
 * @param {number}
 * @return {string}
 */
var from = String.fromCharCode;

/**
 * @param {object}
 * @return {object}
 */
var assign = Object.assign;

/**
 * @param {string} value
 * @param {number} length
 * @return {number}
 */
function hash (value, length) {
	return charat(value, 0) ^ 45 ? (((((((length << 2) ^ charat(value, 0)) << 2) ^ charat(value, 1)) << 2) ^ charat(value, 2)) << 2) ^ charat(value, 3) : 0
}

/**
 * @param {string} value
 * @return {string}
 */
function trim (value) {
	return value.trim()
}

/**
 * @param {string} value
 * @param {RegExp} pattern
 * @return {string?}
 */
function match (value, pattern) {
	return (value = pattern.exec(value)) ? value[0] : value
}

/**
 * @param {string} value
 * @param {(string|RegExp)} pattern
 * @param {string} replacement
 * @return {string}
 */
function replace$1 (value, pattern, replacement) {
	return value.replace(pattern, replacement)
}

/**
 * @param {string} value
 * @param {string} search
 * @return {number}
 */
function indexof (value, search) {
	return value.indexOf(search)
}

/**
 * @param {string} value
 * @param {number} index
 * @return {number}
 */
function charat (value, index) {
	return value.charCodeAt(index) | 0
}

/**
 * @param {string} value
 * @param {number} begin
 * @param {number} end
 * @return {string}
 */
function substr (value, begin, end) {
	return value.slice(begin, end)
}

/**
 * @param {string} value
 * @return {number}
 */
function strlen (value) {
	return value.length
}

/**
 * @param {any[]} value
 * @return {number}
 */
function sizeof (value) {
	return value.length
}

/**
 * @param {any} value
 * @param {any[]} array
 * @return {any}
 */
function append (value, array) {
	return array.push(value), value
}

/**
 * @param {string[]} array
 * @param {function} callback
 * @return {string}
 */
function combine (array, callback) {
	return array.map(callback).join('')
}

var line = 1;
var column = 1;
var length = 0;
var position = 0;
var character = 0;
var characters = '';

/**
 * @param {string} value
 * @param {object | null} root
 * @param {object | null} parent
 * @param {string} type
 * @param {string[] | string} props
 * @param {object[] | string} children
 * @param {number} length
 */
function node (value, root, parent, type, props, children, length) {
	return {value: value, root: root, parent: parent, type: type, props: props, children: children, line: line, column: column, length: length, return: ''}
}

/**
 * @param {object} root
 * @param {object} props
 * @return {object}
 */
function copy (root, props) {
	return assign(node('', null, null, '', null, null, 0), root, {length: -root.length}, props)
}

/**
 * @return {number}
 */
function char () {
	return character
}

/**
 * @return {number}
 */
function prev () {
	character = position > 0 ? charat(characters, --position) : 0;

	if (column--, character === 10)
		column = 1, line--;

	return character
}

/**
 * @return {number}
 */
function next () {
	character = position < length ? charat(characters, position++) : 0;

	if (column++, character === 10)
		column = 1, line++;

	return character
}

/**
 * @return {number}
 */
function peek () {
	return charat(characters, position)
}

/**
 * @return {number}
 */
function caret () {
	return position
}

/**
 * @param {number} begin
 * @param {number} end
 * @return {string}
 */
function slice (begin, end) {
	return substr(characters, begin, end)
}

/**
 * @param {number} type
 * @return {number}
 */
function token (type) {
	switch (type) {
		// \0 \t \n \r \s whitespace token
		case 0: case 9: case 10: case 13: case 32:
			return 5
		// ! + , / > @ ~ isolate token
		case 33: case 43: case 44: case 47: case 62: case 64: case 126:
		// ; { } breakpoint token
		case 59: case 123: case 125:
			return 4
		// : accompanied token
		case 58:
			return 3
		// " ' ( [ opening delimit token
		case 34: case 39: case 40: case 91:
			return 2
		// ) ] closing delimit token
		case 41: case 93:
			return 1
	}

	return 0
}

/**
 * @param {string} value
 * @return {any[]}
 */
function alloc (value) {
	return line = column = 1, length = strlen(characters = value), position = 0, []
}

/**
 * @param {any} value
 * @return {any}
 */
function dealloc (value) {
	return characters = '', value
}

/**
 * @param {number} type
 * @return {string}
 */
function delimit (type) {
	return trim(slice(position - 1, delimiter(type === 91 ? type + 2 : type === 40 ? type + 1 : type)))
}

/**
 * @param {number} type
 * @return {string}
 */
function whitespace (type) {
	while (character = peek())
		if (character < 33)
			next();
		else
			break

	return token(type) > 2 || token(character) > 3 ? '' : ' '
}

/**
 * @param {number} index
 * @param {number} count
 * @return {string}
 */
function escaping (index, count) {
	while (--count && next())
		// not 0-9 A-F a-f
		if (character < 48 || character > 102 || (character > 57 && character < 65) || (character > 70 && character < 97))
			break

	return slice(index, caret() + (count < 6 && peek() == 32 && next() == 32))
}

/**
 * @param {number} type
 * @return {number}
 */
function delimiter (type) {
	while (next())
		switch (character) {
			// ] ) " '
			case type:
				return position
			// " '
			case 34: case 39:
				if (type !== 34 && type !== 39)
					delimiter(character);
				break
			// (
			case 40:
				if (type === 41)
					delimiter(type);
				break
			// \
			case 92:
				next();
				break
		}

	return position
}

/**
 * @param {number} type
 * @param {number} index
 * @return {number}
 */
function commenter (type, index) {
	while (next())
		// //
		if (type + character === 47 + 10)
			break
		// /*
		else if (type + character === 42 + 42 && peek() === 47)
			break

	return '/*' + slice(index, position - 1) + '*' + from(type === 47 ? type : next())
}

/**
 * @param {number} index
 * @return {string}
 */
function identifier (index) {
	while (!token(peek()))
		next();

	return slice(index, position)
}

/**
 * @param {string} value
 * @return {object[]}
 */
function compile (value) {
	return dealloc(parse('', null, null, null, [''], value = alloc(value), 0, [0], value))
}

/**
 * @param {string} value
 * @param {object} root
 * @param {object?} parent
 * @param {string[]} rule
 * @param {string[]} rules
 * @param {string[]} rulesets
 * @param {number[]} pseudo
 * @param {number[]} points
 * @param {string[]} declarations
 * @return {object}
 */
function parse (value, root, parent, rule, rules, rulesets, pseudo, points, declarations) {
	var index = 0;
	var offset = 0;
	var length = pseudo;
	var atrule = 0;
	var property = 0;
	var previous = 0;
	var variable = 1;
	var scanning = 1;
	var ampersand = 1;
	var character = 0;
	var type = '';
	var props = rules;
	var children = rulesets;
	var reference = rule;
	var characters = type;

	while (scanning)
		switch (previous = character, character = next()) {
			// (
			case 40:
				if (previous != 108 && charat(characters, length - 1) == 58) {
					if (indexof(characters += replace$1(delimit(character), '&', '&\f'), '&\f') != -1)
						ampersand = -1;
					break
				}
			// " ' [
			case 34: case 39: case 91:
				characters += delimit(character);
				break
			// \t \n \r \s
			case 9: case 10: case 13: case 32:
				characters += whitespace(previous);
				break
			// \
			case 92:
				characters += escaping(caret() - 1, 7);
				continue
			// /
			case 47:
				switch (peek()) {
					case 42: case 47:
						append(comment(commenter(next(), caret()), root, parent), declarations);
						break
					default:
						characters += '/';
				}
				break
			// {
			case 123 * variable:
				points[index++] = strlen(characters) * ampersand;
			// } ; \0
			case 125 * variable: case 59: case 0:
				switch (character) {
					// \0 }
					case 0: case 125: scanning = 0;
					// ;
					case 59 + offset:
						if (property > 0 && (strlen(characters) - length))
							append(property > 32 ? declaration(characters + ';', rule, parent, length - 1) : declaration(replace$1(characters, ' ', '') + ';', rule, parent, length - 2), declarations);
						break
					// @ ;
					case 59: characters += ';';
					// { rule/at-rule
					default:
						append(reference = ruleset(characters, root, parent, index, offset, rules, points, type, props = [], children = [], length), rulesets);

						if (character === 123)
							if (offset === 0)
								parse(characters, root, reference, reference, props, rulesets, length, points, children);
							else
								switch (atrule === 99 && charat(characters, 3) === 110 ? 100 : atrule) {
									// d m s
									case 100: case 109: case 115:
										parse(value, reference, reference, rule && append(ruleset(value, reference, reference, 0, 0, rules, points, type, rules, props = [], length), children), rules, children, length, points, rule ? props : children);
										break
									default:
										parse(characters, reference, reference, reference, [''], children, 0, points, children);
								}
				}

				index = offset = property = 0, variable = ampersand = 1, type = characters = '', length = pseudo;
				break
			// :
			case 58:
				length = 1 + strlen(characters), property = previous;
			default:
				if (variable < 1)
					if (character == 123)
						--variable;
					else if (character == 125 && variable++ == 0 && prev() == 125)
						continue

				switch (characters += from(character), character * variable) {
					// &
					case 38:
						ampersand = offset > 0 ? 1 : (characters += '\f', -1);
						break
					// ,
					case 44:
						points[index++] = (strlen(characters) - 1) * ampersand, ampersand = 1;
						break
					// @
					case 64:
						// -
						if (peek() === 45)
							characters += delimit(next());

						atrule = peek(), offset = length = strlen(type = characters += identifier(caret())), character++;
						break
					// -
					case 45:
						if (previous === 45 && strlen(characters) == 2)
							variable = 0;
				}
		}

	return rulesets
}

/**
 * @param {string} value
 * @param {object} root
 * @param {object?} parent
 * @param {number} index
 * @param {number} offset
 * @param {string[]} rules
 * @param {number[]} points
 * @param {string} type
 * @param {string[]} props
 * @param {string[]} children
 * @param {number} length
 * @return {object}
 */
function ruleset (value, root, parent, index, offset, rules, points, type, props, children, length) {
	var post = offset - 1;
	var rule = offset === 0 ? rules : [''];
	var size = sizeof(rule);

	for (var i = 0, j = 0, k = 0; i < index; ++i)
		for (var x = 0, y = substr(value, post + 1, post = abs(j = points[i])), z = value; x < size; ++x)
			if (z = trim(j > 0 ? rule[x] + ' ' + y : replace$1(y, /&\f/g, rule[x])))
				props[k++] = z;

	return node(value, root, parent, offset === 0 ? RULESET : type, props, children, length)
}

/**
 * @param {number} value
 * @param {object} root
 * @param {object?} parent
 * @return {object}
 */
function comment (value, root, parent) {
	return node(value, root, parent, COMMENT, from(char()), substr(value, 2, -2), 0)
}

/**
 * @param {string} value
 * @param {object} root
 * @param {object?} parent
 * @param {number} length
 * @return {object}
 */
function declaration (value, root, parent, length) {
	return node(value, root, parent, DECLARATION, substr(value, 0, length), substr(value, length + 1, -1), length)
}

/**
 * @param {object[]} children
 * @param {function} callback
 * @return {string}
 */
function serialize (children, callback) {
	var output = '';
	var length = sizeof(children);

	for (var i = 0; i < length; i++)
		output += callback(children[i], i, children, callback) || '';

	return output
}

/**
 * @param {object} element
 * @param {number} index
 * @param {object[]} children
 * @param {function} callback
 * @return {string}
 */
function stringify (element, index, children, callback) {
	switch (element.type) {
		case IMPORT: case DECLARATION: return element.return = element.return || element.value
		case COMMENT: return ''
		case KEYFRAMES: return element.return = element.value + '{' + serialize(element.children, callback) + '}'
		case RULESET: element.value = element.props.join(',');
	}

	return strlen(children = serialize(element.children, callback)) ? element.return = element.value + '{' + children + '}' : ''
}

/**
 * @param {function[]} collection
 * @return {function}
 */
function middleware (collection) {
	var length = sizeof(collection);

	return function (element, index, children, callback) {
		var output = '';

		for (var i = 0; i < length; i++)
			output += collection[i](element, index, children, callback) || '';

		return output
	}
}

/**
 * @param {function} callback
 * @return {function}
 */
function rulesheet (callback) {
	return function (element) {
		if (!element.root)
			if (element = element.return)
				callback(element);
	}
}

var weakMemoize = function weakMemoize(func) {
  // $FlowFixMe flow doesn't include all non-primitive types as allowed for weakmaps
  var cache = new WeakMap();
  return function (arg) {
    if (cache.has(arg)) {
      // $FlowFixMe
      return cache.get(arg);
    }

    var ret = func(arg);
    cache.set(arg, ret);
    return ret;
  };
};

function memoize(fn) {
  var cache = Object.create(null);
  return function (arg) {
    if (cache[arg] === undefined) cache[arg] = fn(arg);
    return cache[arg];
  };
}

var identifierWithPointTracking = function identifierWithPointTracking(begin, points, index) {
  var previous = 0;
  var character = 0;

  while (true) {
    previous = character;
    character = peek(); // &\f

    if (previous === 38 && character === 12) {
      points[index] = 1;
    }

    if (token(character)) {
      break;
    }

    next();
  }

  return slice(begin, position);
};

var toRules = function toRules(parsed, points) {
  // pretend we've started with a comma
  var index = -1;
  var character = 44;

  do {
    switch (token(character)) {
      case 0:
        // &\f
        if (character === 38 && peek() === 12) {
          // this is not 100% correct, we don't account for literal sequences here - like for example quoted strings
          // stylis inserts \f after & to know when & where it should replace this sequence with the context selector
          // and when it should just concatenate the outer and inner selectors
          // it's very unlikely for this sequence to actually appear in a different context, so we just leverage this fact here
          points[index] = 1;
        }

        parsed[index] += identifierWithPointTracking(position - 1, points, index);
        break;

      case 2:
        parsed[index] += delimit(character);
        break;

      case 4:
        // comma
        if (character === 44) {
          // colon
          parsed[++index] = peek() === 58 ? '&\f' : '';
          points[index] = parsed[index].length;
          break;
        }

      // fallthrough

      default:
        parsed[index] += from(character);
    }
  } while (character = next());

  return parsed;
};

var getRules = function getRules(value, points) {
  return dealloc(toRules(alloc(value), points));
}; // WeakSet would be more appropriate, but only WeakMap is supported in IE11


var fixedElements = /* #__PURE__ */new WeakMap();
var compat = function compat(element) {
  if (element.type !== 'rule' || !element.parent || // positive .length indicates that this rule contains pseudo
  // negative .length indicates that this rule has been already prefixed
  element.length < 1) {
    return;
  }

  var value = element.value,
      parent = element.parent;
  var isImplicitRule = element.column === parent.column && element.line === parent.line;

  while (parent.type !== 'rule') {
    parent = parent.parent;
    if (!parent) return;
  } // short-circuit for the simplest case


  if (element.props.length === 1 && value.charCodeAt(0) !== 58
  /* colon */
  && !fixedElements.get(parent)) {
    return;
  } // if this is an implicitly inserted rule (the one eagerly inserted at the each new nested level)
  // then the props has already been manipulated beforehand as they that array is shared between it and its "rule parent"


  if (isImplicitRule) {
    return;
  }

  fixedElements.set(element, true);
  var points = [];
  var rules = getRules(value, points);
  var parentRules = parent.props;

  for (var i = 0, k = 0; i < rules.length; i++) {
    for (var j = 0; j < parentRules.length; j++, k++) {
      element.props[k] = points[i] ? rules[i].replace(/&\f/g, parentRules[j]) : parentRules[j] + " " + rules[i];
    }
  }
};
var removeLabel = function removeLabel(element) {
  if (element.type === 'decl') {
    var value = element.value;

    if ( // charcode for l
    value.charCodeAt(0) === 108 && // charcode for b
    value.charCodeAt(2) === 98) {
      // this ignores label
      element["return"] = '';
      element.value = '';
    }
  }
};
var ignoreFlag = 'emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason';

var isIgnoringComment = function isIgnoringComment(element) {
  return element.type === 'comm' && element.children.indexOf(ignoreFlag) > -1;
};

var createUnsafeSelectorsAlarm = function createUnsafeSelectorsAlarm(cache) {
  return function (element, index, children) {
    if (element.type !== 'rule' || cache.compat) return;
    var unsafePseudoClasses = element.value.match(/(:first|:nth|:nth-last)-child/g);

    if (unsafePseudoClasses) {
      var isNested = element.parent === children[0]; // in nested rules comments become children of the "auto-inserted" rule
      //
      // considering this input:
      // .a {
      //   .b /* comm */ {}
      //   color: hotpink;
      // }
      // we get output corresponding to this:
      // .a {
      //   & {
      //     /* comm */
      //     color: hotpink;
      //   }
      //   .b {}
      // }

      var commentContainer = isNested ? children[0].children : // global rule at the root level
      children;

      for (var i = commentContainer.length - 1; i >= 0; i--) {
        var node = commentContainer[i];

        if (node.line < element.line) {
          break;
        } // it is quite weird but comments are *usually* put at `column: element.column - 1`
        // so we seek *from the end* for the node that is earlier than the rule's `element` and check that
        // this will also match inputs like this:
        // .a {
        //   /* comm */
        //   .b {}
        // }
        //
        // but that is fine
        //
        // it would be the easiest to change the placement of the comment to be the first child of the rule:
        // .a {
        //   .b { /* comm */ }
        // }
        // with such inputs we wouldn't have to search for the comment at all
        // TODO: consider changing this comment placement in the next major version


        if (node.column < element.column) {
          if (isIgnoringComment(node)) {
            return;
          }

          break;
        }
      }

      unsafePseudoClasses.forEach(function (unsafePseudoClass) {
        console.error("The pseudo class \"" + unsafePseudoClass + "\" is potentially unsafe when doing server-side rendering. Try changing it to \"" + unsafePseudoClass.split('-child')[0] + "-of-type\".");
      });
    }
  };
};

var isImportRule = function isImportRule(element) {
  return element.type.charCodeAt(1) === 105 && element.type.charCodeAt(0) === 64;
};

var isPrependedWithRegularRules = function isPrependedWithRegularRules(index, children) {
  for (var i = index - 1; i >= 0; i--) {
    if (!isImportRule(children[i])) {
      return true;
    }
  }

  return false;
}; // use this to remove incorrect elements from further processing
// so they don't get handed to the `sheet` (or anything else)
// as that could potentially lead to additional logs which in turn could be overhelming to the user


var nullifyElement = function nullifyElement(element) {
  element.type = '';
  element.value = '';
  element["return"] = '';
  element.children = '';
  element.props = '';
};

var incorrectImportAlarm = function incorrectImportAlarm(element, index, children) {
  if (!isImportRule(element)) {
    return;
  }

  if (element.parent) {
    console.error("`@import` rules can't be nested inside other rules. Please move it to the top level and put it before regular rules. Keep in mind that they can only be used within global styles.");
    nullifyElement(element);
  } else if (isPrependedWithRegularRules(index, children)) {
    console.error("`@import` rules can't be after other rules. Please put your `@import` rules before your other rules.");
    nullifyElement(element);
  }
};

/* eslint-disable no-fallthrough */

function prefix(value, length) {
  switch (hash(value, length)) {
    // color-adjust
    case 5103:
      return WEBKIT + 'print-' + value + value;
    // animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)

    case 5737:
    case 4201:
    case 3177:
    case 3433:
    case 1641:
    case 4457:
    case 2921: // text-decoration, filter, clip-path, backface-visibility, column, box-decoration-break

    case 5572:
    case 6356:
    case 5844:
    case 3191:
    case 6645:
    case 3005: // mask, mask-image, mask-(mode|clip|size), mask-(repeat|origin), mask-position, mask-composite,

    case 6391:
    case 5879:
    case 5623:
    case 6135:
    case 4599:
    case 4855: // background-clip, columns, column-(count|fill|gap|rule|rule-color|rule-style|rule-width|span|width)

    case 4215:
    case 6389:
    case 5109:
    case 5365:
    case 5621:
    case 3829:
      return WEBKIT + value + value;
    // appearance, user-select, transform, hyphens, text-size-adjust

    case 5349:
    case 4246:
    case 4810:
    case 6968:
    case 2756:
      return WEBKIT + value + MOZ + value + MS + value + value;
    // flex, flex-direction

    case 6828:
    case 4268:
      return WEBKIT + value + MS + value + value;
    // order

    case 6165:
      return WEBKIT + value + MS + 'flex-' + value + value;
    // align-items

    case 5187:
      return WEBKIT + value + replace$1(value, /(\w+).+(:[^]+)/, WEBKIT + 'box-$1$2' + MS + 'flex-$1$2') + value;
    // align-self

    case 5443:
      return WEBKIT + value + MS + 'flex-item-' + replace$1(value, /flex-|-self/, '') + value;
    // align-content

    case 4675:
      return WEBKIT + value + MS + 'flex-line-pack' + replace$1(value, /align-content|flex-|-self/, '') + value;
    // flex-shrink

    case 5548:
      return WEBKIT + value + MS + replace$1(value, 'shrink', 'negative') + value;
    // flex-basis

    case 5292:
      return WEBKIT + value + MS + replace$1(value, 'basis', 'preferred-size') + value;
    // flex-grow

    case 6060:
      return WEBKIT + 'box-' + replace$1(value, '-grow', '') + WEBKIT + value + MS + replace$1(value, 'grow', 'positive') + value;
    // transition

    case 4554:
      return WEBKIT + replace$1(value, /([^-])(transform)/g, '$1' + WEBKIT + '$2') + value;
    // cursor

    case 6187:
      return replace$1(replace$1(replace$1(value, /(zoom-|grab)/, WEBKIT + '$1'), /(image-set)/, WEBKIT + '$1'), value, '') + value;
    // background, background-image

    case 5495:
    case 3959:
      return replace$1(value, /(image-set\([^]*)/, WEBKIT + '$1' + '$`$1');
    // justify-content

    case 4968:
      return replace$1(replace$1(value, /(.+:)(flex-)?(.*)/, WEBKIT + 'box-pack:$3' + MS + 'flex-pack:$3'), /s.+-b[^;]+/, 'justify') + WEBKIT + value + value;
    // (margin|padding)-inline-(start|end)

    case 4095:
    case 3583:
    case 4068:
    case 2532:
      return replace$1(value, /(.+)-inline(.+)/, WEBKIT + '$1$2') + value;
    // (min|max)?(width|height|inline-size|block-size)

    case 8116:
    case 7059:
    case 5753:
    case 5535:
    case 5445:
    case 5701:
    case 4933:
    case 4677:
    case 5533:
    case 5789:
    case 5021:
    case 4765:
      // stretch, max-content, min-content, fill-available
      if (strlen(value) - 1 - length > 6) switch (charat(value, length + 1)) {
        // (m)ax-content, (m)in-content
        case 109:
          // -
          if (charat(value, length + 4) !== 45) break;
        // (f)ill-available, (f)it-content

        case 102:
          return replace$1(value, /(.+:)(.+)-([^]+)/, '$1' + WEBKIT + '$2-$3' + '$1' + MOZ + (charat(value, length + 3) == 108 ? '$3' : '$2-$3')) + value;
        // (s)tretch

        case 115:
          return ~indexof(value, 'stretch') ? prefix(replace$1(value, 'stretch', 'fill-available'), length) + value : value;
      }
      break;
    // position: sticky

    case 4949:
      // (s)ticky?
      if (charat(value, length + 1) !== 115) break;
    // display: (flex|inline-flex)

    case 6444:
      switch (charat(value, strlen(value) - 3 - (~indexof(value, '!important') && 10))) {
        // stic(k)y
        case 107:
          return replace$1(value, ':', ':' + WEBKIT) + value;
        // (inline-)?fl(e)x

        case 101:
          return replace$1(value, /(.+:)([^;!]+)(;|!.+)?/, '$1' + WEBKIT + (charat(value, 14) === 45 ? 'inline-' : '') + 'box$3' + '$1' + WEBKIT + '$2$3' + '$1' + MS + '$2box$3') + value;
      }

      break;
    // writing-mode

    case 5936:
      switch (charat(value, length + 11)) {
        // vertical-l(r)
        case 114:
          return WEBKIT + value + MS + replace$1(value, /[svh]\w+-[tblr]{2}/, 'tb') + value;
        // vertical-r(l)

        case 108:
          return WEBKIT + value + MS + replace$1(value, /[svh]\w+-[tblr]{2}/, 'tb-rl') + value;
        // horizontal(-)tb

        case 45:
          return WEBKIT + value + MS + replace$1(value, /[svh]\w+-[tblr]{2}/, 'lr') + value;
      }

      return WEBKIT + value + MS + value + value;
  }

  return value;
}

var prefixer = function prefixer(element, index, children, callback) {
  if (element.length > -1) if (!element["return"]) switch (element.type) {
    case DECLARATION:
      element["return"] = prefix(element.value, element.length);
      break;

    case KEYFRAMES:
      return serialize([copy(element, {
        value: replace$1(element.value, '@', '@' + WEBKIT)
      })], callback);

    case RULESET:
      if (element.length) return combine(element.props, function (value) {
        switch (match(value, /(::plac\w+|:read-\w+)/)) {
          // :read-(only|write)
          case ':read-only':
          case ':read-write':
            return serialize([copy(element, {
              props: [replace$1(value, /:(read-\w+)/, ':' + MOZ + '$1')]
            })], callback);
          // :placeholder

          case '::placeholder':
            return serialize([copy(element, {
              props: [replace$1(value, /:(plac\w+)/, ':' + WEBKIT + 'input-$1')]
            }), copy(element, {
              props: [replace$1(value, /:(plac\w+)/, ':' + MOZ + '$1')]
            }), copy(element, {
              props: [replace$1(value, /:(plac\w+)/, MS + 'input-$1')]
            })], callback);
        }

        return '';
      });
  }
};

var isBrowser$3 = typeof document !== 'undefined';
var getServerStylisCache = isBrowser$3 ? undefined : weakMemoize(function () {
  return memoize(function () {
    var cache = {};
    return function (name) {
      return cache[name];
    };
  });
});
var defaultStylisPlugins = [prefixer];

var createCache = function createCache(options) {
  var key = options.key;

  if (process.env.NODE_ENV !== 'production' && !key) {
    throw new Error("You have to configure `key` for your cache. Please make sure it's unique (and not equal to 'css') as it's used for linking styles to your cache.\n" + "If multiple caches share the same key they might \"fight\" for each other's style elements.");
  }

  if (isBrowser$3 && key === 'css') {
    var ssrStyles = document.querySelectorAll("style[data-emotion]:not([data-s])"); // get SSRed styles out of the way of React's hydration
    // document.head is a safe place to move them to(though note document.head is not necessarily the last place they will be)
    // note this very very intentionally targets all style elements regardless of the key to ensure
    // that creating a cache works inside of render of a React component

    Array.prototype.forEach.call(ssrStyles, function (node) {
      // we want to only move elements which have a space in the data-emotion attribute value
      // because that indicates that it is an Emotion 11 server-side rendered style elements
      // while we will already ignore Emotion 11 client-side inserted styles because of the :not([data-s]) part in the selector
      // Emotion 10 client-side inserted styles did not have data-s (but importantly did not have a space in their data-emotion attributes)
      // so checking for the space ensures that loading Emotion 11 after Emotion 10 has inserted some styles
      // will not result in the Emotion 10 styles being destroyed
      var dataEmotionAttribute = node.getAttribute('data-emotion');

      if (dataEmotionAttribute.indexOf(' ') === -1) {
        return;
      }
      document.head.appendChild(node);
      node.setAttribute('data-s', '');
    });
  }

  var stylisPlugins = options.stylisPlugins || defaultStylisPlugins;

  if (process.env.NODE_ENV !== 'production') {
    // $FlowFixMe
    if (/[^a-z-]/.test(key)) {
      throw new Error("Emotion key must only contain lower case alphabetical characters and - but \"" + key + "\" was passed");
    }
  }

  var inserted = {};
  var container;
  var nodesToHydrate = [];

  if (isBrowser$3) {
    container = options.container || document.head;
    Array.prototype.forEach.call( // this means we will ignore elements which don't have a space in them which
    // means that the style elements we're looking at are only Emotion 11 server-rendered style elements
    document.querySelectorAll("style[data-emotion^=\"" + key + " \"]"), function (node) {
      var attrib = node.getAttribute("data-emotion").split(' '); // $FlowFixMe

      for (var i = 1; i < attrib.length; i++) {
        inserted[attrib[i]] = true;
      }

      nodesToHydrate.push(node);
    });
  }

  var _insert;

  var omnipresentPlugins = [compat, removeLabel];

  if (process.env.NODE_ENV !== 'production') {
    omnipresentPlugins.push(createUnsafeSelectorsAlarm({
      get compat() {
        return cache.compat;
      }

    }), incorrectImportAlarm);
  }

  if (isBrowser$3) {
    var currentSheet;
    var finalizingPlugins = [stringify, process.env.NODE_ENV !== 'production' ? function (element) {
      if (!element.root) {
        if (element["return"]) {
          currentSheet.insert(element["return"]);
        } else if (element.value && element.type !== COMMENT) {
          // insert empty rule in non-production environments
          // so @emotion/jest can grab `key` from the (JS)DOM for caches without any rules inserted yet
          currentSheet.insert(element.value + "{}");
        }
      }
    } : rulesheet(function (rule) {
      currentSheet.insert(rule);
    })];
    var serializer = middleware(omnipresentPlugins.concat(stylisPlugins, finalizingPlugins));

    var stylis = function stylis(styles) {
      return serialize(compile(styles), serializer);
    };

    _insert = function insert(selector, serialized, sheet, shouldCache) {
      currentSheet = sheet;

      if (process.env.NODE_ENV !== 'production' && serialized.map !== undefined) {
        currentSheet = {
          insert: function insert(rule) {
            sheet.insert(rule + serialized.map);
          }
        };
      }

      stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);

      if (shouldCache) {
        cache.inserted[serialized.name] = true;
      }
    };
  } else {
    var _finalizingPlugins = [stringify];

    var _serializer = middleware(omnipresentPlugins.concat(stylisPlugins, _finalizingPlugins));

    var _stylis = function _stylis(styles) {
      return serialize(compile(styles), _serializer);
    }; // $FlowFixMe


    var serverStylisCache = getServerStylisCache(stylisPlugins)(key);

    var getRules = function getRules(selector, serialized) {
      var name = serialized.name;

      if (serverStylisCache[name] === undefined) {
        serverStylisCache[name] = _stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
      }

      return serverStylisCache[name];
    };

    _insert = function _insert(selector, serialized, sheet, shouldCache) {
      var name = serialized.name;
      var rules = getRules(selector, serialized);

      if (cache.compat === undefined) {
        // in regular mode, we don't set the styles on the inserted cache
        // since we don't need to and that would be wasting memory
        // we return them so that they are rendered in a style tag
        if (shouldCache) {
          cache.inserted[name] = true;
        }

        if ( // using === development instead of !== production
        // because if people do ssr in tests, the source maps showing up would be annoying
        process.env.NODE_ENV === 'development' && serialized.map !== undefined) {
          return rules + serialized.map;
        }

        return rules;
      } else {
        // in compat mode, we put the styles on the inserted cache so
        // that emotion-server can pull out the styles
        // except when we don't want to cache it which was in Global but now
        // is nowhere but we don't want to do a major right now
        // and just in case we're going to leave the case here
        // it's also not affecting client side bundle size
        // so it's really not a big deal
        if (shouldCache) {
          cache.inserted[name] = rules;
        } else {
          return rules;
        }
      }
    };
  }

  var cache = {
    key: key,
    sheet: new StyleSheet({
      key: key,
      container: container,
      nonce: options.nonce,
      speedy: options.speedy,
      prepend: options.prepend,
      insertionPoint: options.insertionPoint
    }),
    nonce: options.nonce,
    inserted: inserted,
    registered: {},
    insert: _insert
  };
  cache.sheet.hydrate(nodesToHydrate);
  return cache;
};

var reactIs$1 = {exports: {}};

var reactIs_production_min = {};

/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?
Symbol.for("react.suspense_list"):60120,r=b?Symbol.for("react.memo"):60115,t=b?Symbol.for("react.lazy"):60116,v=b?Symbol.for("react.block"):60121,w=b?Symbol.for("react.fundamental"):60117,x=b?Symbol.for("react.responder"):60118,y=b?Symbol.for("react.scope"):60119;
function z(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case t:case r:case h:return a;default:return u}}case d:return u}}}function A(a){return z(a)===m}reactIs_production_min.AsyncMode=l;reactIs_production_min.ConcurrentMode=m;reactIs_production_min.ContextConsumer=k;reactIs_production_min.ContextProvider=h;reactIs_production_min.Element=c;reactIs_production_min.ForwardRef=n;reactIs_production_min.Fragment=e;reactIs_production_min.Lazy=t;reactIs_production_min.Memo=r;reactIs_production_min.Portal=d;
reactIs_production_min.Profiler=g;reactIs_production_min.StrictMode=f;reactIs_production_min.Suspense=p;reactIs_production_min.isAsyncMode=function(a){return A(a)||z(a)===l};reactIs_production_min.isConcurrentMode=A;reactIs_production_min.isContextConsumer=function(a){return z(a)===k};reactIs_production_min.isContextProvider=function(a){return z(a)===h};reactIs_production_min.isElement=function(a){return "object"===typeof a&&null!==a&&a.$$typeof===c};reactIs_production_min.isForwardRef=function(a){return z(a)===n};reactIs_production_min.isFragment=function(a){return z(a)===e};reactIs_production_min.isLazy=function(a){return z(a)===t};
reactIs_production_min.isMemo=function(a){return z(a)===r};reactIs_production_min.isPortal=function(a){return z(a)===d};reactIs_production_min.isProfiler=function(a){return z(a)===g};reactIs_production_min.isStrictMode=function(a){return z(a)===f};reactIs_production_min.isSuspense=function(a){return z(a)===p};
reactIs_production_min.isValidElementType=function(a){return "string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||a===q||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n||a.$$typeof===w||a.$$typeof===x||a.$$typeof===y||a.$$typeof===v)};reactIs_production_min.typeOf=z;

var reactIs_development = {};

/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



if (process.env.NODE_ENV !== "production") {
  (function() {

// The Symbol used to tag the ReactElement-like types. If there is no native Symbol
// nor polyfill, then a plain number is used for performance.
var hasSymbol = typeof Symbol === 'function' && Symbol.for;
var REACT_ELEMENT_TYPE = hasSymbol ? Symbol.for('react.element') : 0xeac7;
var REACT_PORTAL_TYPE = hasSymbol ? Symbol.for('react.portal') : 0xeaca;
var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol.for('react.fragment') : 0xeacb;
var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for('react.strict_mode') : 0xeacc;
var REACT_PROFILER_TYPE = hasSymbol ? Symbol.for('react.profiler') : 0xead2;
var REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for('react.provider') : 0xeacd;
var REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for('react.context') : 0xeace; // TODO: We don't use AsyncMode or ConcurrentMode anymore. They were temporary
// (unstable) APIs that have been removed. Can we remove the symbols?

var REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol.for('react.async_mode') : 0xeacf;
var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol.for('react.concurrent_mode') : 0xeacf;
var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for('react.forward_ref') : 0xead0;
var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol.for('react.suspense') : 0xead1;
var REACT_SUSPENSE_LIST_TYPE = hasSymbol ? Symbol.for('react.suspense_list') : 0xead8;
var REACT_MEMO_TYPE = hasSymbol ? Symbol.for('react.memo') : 0xead3;
var REACT_LAZY_TYPE = hasSymbol ? Symbol.for('react.lazy') : 0xead4;
var REACT_BLOCK_TYPE = hasSymbol ? Symbol.for('react.block') : 0xead9;
var REACT_FUNDAMENTAL_TYPE = hasSymbol ? Symbol.for('react.fundamental') : 0xead5;
var REACT_RESPONDER_TYPE = hasSymbol ? Symbol.for('react.responder') : 0xead6;
var REACT_SCOPE_TYPE = hasSymbol ? Symbol.for('react.scope') : 0xead7;

function isValidElementType(type) {
  return typeof type === 'string' || typeof type === 'function' || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
  type === REACT_FRAGMENT_TYPE || type === REACT_CONCURRENT_MODE_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || typeof type === 'object' && type !== null && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_RESPONDER_TYPE || type.$$typeof === REACT_SCOPE_TYPE || type.$$typeof === REACT_BLOCK_TYPE);
}

function typeOf(object) {
  if (typeof object === 'object' && object !== null) {
    var $$typeof = object.$$typeof;

    switch ($$typeof) {
      case REACT_ELEMENT_TYPE:
        var type = object.type;

        switch (type) {
          case REACT_ASYNC_MODE_TYPE:
          case REACT_CONCURRENT_MODE_TYPE:
          case REACT_FRAGMENT_TYPE:
          case REACT_PROFILER_TYPE:
          case REACT_STRICT_MODE_TYPE:
          case REACT_SUSPENSE_TYPE:
            return type;

          default:
            var $$typeofType = type && type.$$typeof;

            switch ($$typeofType) {
              case REACT_CONTEXT_TYPE:
              case REACT_FORWARD_REF_TYPE:
              case REACT_LAZY_TYPE:
              case REACT_MEMO_TYPE:
              case REACT_PROVIDER_TYPE:
                return $$typeofType;

              default:
                return $$typeof;
            }

        }

      case REACT_PORTAL_TYPE:
        return $$typeof;
    }
  }

  return undefined;
} // AsyncMode is deprecated along with isAsyncMode

var AsyncMode = REACT_ASYNC_MODE_TYPE;
var ConcurrentMode = REACT_CONCURRENT_MODE_TYPE;
var ContextConsumer = REACT_CONTEXT_TYPE;
var ContextProvider = REACT_PROVIDER_TYPE;
var Element = REACT_ELEMENT_TYPE;
var ForwardRef = REACT_FORWARD_REF_TYPE;
var Fragment = REACT_FRAGMENT_TYPE;
var Lazy = REACT_LAZY_TYPE;
var Memo = REACT_MEMO_TYPE;
var Portal = REACT_PORTAL_TYPE;
var Profiler = REACT_PROFILER_TYPE;
var StrictMode = REACT_STRICT_MODE_TYPE;
var Suspense = REACT_SUSPENSE_TYPE;
var hasWarnedAboutDeprecatedIsAsyncMode = false; // AsyncMode should be deprecated

function isAsyncMode(object) {
  {
    if (!hasWarnedAboutDeprecatedIsAsyncMode) {
      hasWarnedAboutDeprecatedIsAsyncMode = true; // Using console['warn'] to evade Babel and ESLint

      console['warn']('The ReactIs.isAsyncMode() alias has been deprecated, ' + 'and will be removed in React 17+. Update your code to use ' + 'ReactIs.isConcurrentMode() instead. It has the exact same API.');
    }
  }

  return isConcurrentMode(object) || typeOf(object) === REACT_ASYNC_MODE_TYPE;
}
function isConcurrentMode(object) {
  return typeOf(object) === REACT_CONCURRENT_MODE_TYPE;
}
function isContextConsumer(object) {
  return typeOf(object) === REACT_CONTEXT_TYPE;
}
function isContextProvider(object) {
  return typeOf(object) === REACT_PROVIDER_TYPE;
}
function isElement(object) {
  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
}
function isForwardRef(object) {
  return typeOf(object) === REACT_FORWARD_REF_TYPE;
}
function isFragment(object) {
  return typeOf(object) === REACT_FRAGMENT_TYPE;
}
function isLazy(object) {
  return typeOf(object) === REACT_LAZY_TYPE;
}
function isMemo(object) {
  return typeOf(object) === REACT_MEMO_TYPE;
}
function isPortal(object) {
  return typeOf(object) === REACT_PORTAL_TYPE;
}
function isProfiler(object) {
  return typeOf(object) === REACT_PROFILER_TYPE;
}
function isStrictMode(object) {
  return typeOf(object) === REACT_STRICT_MODE_TYPE;
}
function isSuspense(object) {
  return typeOf(object) === REACT_SUSPENSE_TYPE;
}

reactIs_development.AsyncMode = AsyncMode;
reactIs_development.ConcurrentMode = ConcurrentMode;
reactIs_development.ContextConsumer = ContextConsumer;
reactIs_development.ContextProvider = ContextProvider;
reactIs_development.Element = Element;
reactIs_development.ForwardRef = ForwardRef;
reactIs_development.Fragment = Fragment;
reactIs_development.Lazy = Lazy;
reactIs_development.Memo = Memo;
reactIs_development.Portal = Portal;
reactIs_development.Profiler = Profiler;
reactIs_development.StrictMode = StrictMode;
reactIs_development.Suspense = Suspense;
reactIs_development.isAsyncMode = isAsyncMode;
reactIs_development.isConcurrentMode = isConcurrentMode;
reactIs_development.isContextConsumer = isContextConsumer;
reactIs_development.isContextProvider = isContextProvider;
reactIs_development.isElement = isElement;
reactIs_development.isForwardRef = isForwardRef;
reactIs_development.isFragment = isFragment;
reactIs_development.isLazy = isLazy;
reactIs_development.isMemo = isMemo;
reactIs_development.isPortal = isPortal;
reactIs_development.isProfiler = isProfiler;
reactIs_development.isStrictMode = isStrictMode;
reactIs_development.isSuspense = isSuspense;
reactIs_development.isValidElementType = isValidElementType;
reactIs_development.typeOf = typeOf;
  })();
}

if (process.env.NODE_ENV === 'production') {
  reactIs$1.exports = reactIs_production_min;
} else {
  reactIs$1.exports = reactIs_development;
}

var reactIs = reactIs$1.exports;
var FORWARD_REF_STATICS = {
  '$$typeof': true,
  render: true,
  defaultProps: true,
  displayName: true,
  propTypes: true
};
var MEMO_STATICS = {
  '$$typeof': true,
  compare: true,
  defaultProps: true,
  displayName: true,
  propTypes: true,
  type: true
};
var TYPE_STATICS = {};
TYPE_STATICS[reactIs.ForwardRef] = FORWARD_REF_STATICS;
TYPE_STATICS[reactIs.Memo] = MEMO_STATICS;

var isBrowser$2 = typeof document !== 'undefined';
function getRegisteredStyles(registered, registeredStyles, classNames) {
  var rawClassName = '';
  classNames.split(' ').forEach(function (className) {
    if (registered[className] !== undefined) {
      registeredStyles.push(registered[className] + ";");
    } else {
      rawClassName += className + " ";
    }
  });
  return rawClassName;
}
var registerStyles = function registerStyles(cache, serialized, isStringTag) {
  var className = cache.key + "-" + serialized.name;

  if ( // we only need to add the styles to the registered cache if the
  // class name could be used further down
  // the tree but if it's a string tag, we know it won't
  // so we don't have to add it to registered cache.
  // this improves memory usage since we can avoid storing the whole style string
  (isStringTag === false || // we need to always store it if we're in compat mode and
  // in node since emotion-server relies on whether a style is in
  // the registered cache to know whether a style is global or not
  // also, note that this check will be dead code eliminated in the browser
  isBrowser$2 === false && cache.compat !== undefined) && cache.registered[className] === undefined) {
    cache.registered[className] = serialized.styles;
  }
};
var insertStyles = function insertStyles(cache, serialized, isStringTag) {
  registerStyles(cache, serialized, isStringTag);
  var className = cache.key + "-" + serialized.name;

  if (cache.inserted[serialized.name] === undefined) {
    var stylesForSSR = '';
    var current = serialized;

    do {
      var maybeStyles = cache.insert(serialized === current ? "." + className : '', current, cache.sheet, true);

      if (!isBrowser$2 && maybeStyles !== undefined) {
        stylesForSSR += maybeStyles;
      }

      current = current.next;
    } while (current !== undefined);

    if (!isBrowser$2 && stylesForSSR.length !== 0) {
      return stylesForSSR;
    }
  }
};

/* eslint-disable */
// Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
function murmur2(str) {
  // 'm' and 'r' are mixing constants generated offline.
  // They're not really 'magic', they just happen to work well.
  // const m = 0x5bd1e995;
  // const r = 24;
  // Initialize the hash
  var h = 0; // Mix 4 bytes at a time into the hash

  var k,
      i = 0,
      len = str.length;

  for (; len >= 4; ++i, len -= 4) {
    k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
    k =
    /* Math.imul(k, m): */
    (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
    k ^=
    /* k >>> r: */
    k >>> 24;
    h =
    /* Math.imul(k, m): */
    (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^
    /* Math.imul(h, m): */
    (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
  } // Handle the last few bytes of the input array


  switch (len) {
    case 3:
      h ^= (str.charCodeAt(i + 2) & 0xff) << 16;

    case 2:
      h ^= (str.charCodeAt(i + 1) & 0xff) << 8;

    case 1:
      h ^= str.charCodeAt(i) & 0xff;
      h =
      /* Math.imul(h, m): */
      (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
  } // Do a few final mixes of the hash to ensure the last few
  // bytes are well-incorporated.


  h ^= h >>> 13;
  h =
  /* Math.imul(h, m): */
  (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
  return ((h ^ h >>> 15) >>> 0).toString(36);
}

var unitlessKeys = {
  animationIterationCount: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
};

var ILLEGAL_ESCAPE_SEQUENCE_ERROR = "You have illegal escape sequence in your template literal, most likely inside content's property value.\nBecause you write your CSS inside a JavaScript string you actually have to do double escaping, so for example \"content: '\\00d7';\" should become \"content: '\\\\00d7';\".\nYou can read more about this here:\nhttps://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences";
var UNDEFINED_AS_OBJECT_KEY_ERROR = "You have passed in falsy value as style object's key (can happen when in example you pass unexported component as computed key).";
var hyphenateRegex = /[A-Z]|^ms/g;
var animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;

var isCustomProperty = function isCustomProperty(property) {
  return property.charCodeAt(1) === 45;
};

var isProcessableValue = function isProcessableValue(value) {
  return value != null && typeof value !== 'boolean';
};

var processStyleName = /* #__PURE__ */memoize(function (styleName) {
  return isCustomProperty(styleName) ? styleName : styleName.replace(hyphenateRegex, '-$&').toLowerCase();
});

var processStyleValue = function processStyleValue(key, value) {
  switch (key) {
    case 'animation':
    case 'animationName':
      {
        if (typeof value === 'string') {
          return value.replace(animationRegex, function (match, p1, p2) {
            cursor = {
              name: p1,
              styles: p2,
              next: cursor
            };
            return p1;
          });
        }
      }
  }

  if (unitlessKeys[key] !== 1 && !isCustomProperty(key) && typeof value === 'number' && value !== 0) {
    return value + 'px';
  }

  return value;
};

if (process.env.NODE_ENV !== 'production') {
  var contentValuePattern = /(var|attr|counters?|url|element|(((repeating-)?(linear|radial))|conic)-gradient)\(|(no-)?(open|close)-quote/;
  var contentValues = ['normal', 'none', 'initial', 'inherit', 'unset'];
  var oldProcessStyleValue = processStyleValue;
  var msPattern = /^-ms-/;
  var hyphenPattern = /-(.)/g;
  var hyphenatedCache = {};

  processStyleValue = function processStyleValue(key, value) {
    if (key === 'content') {
      if (typeof value !== 'string' || contentValues.indexOf(value) === -1 && !contentValuePattern.test(value) && (value.charAt(0) !== value.charAt(value.length - 1) || value.charAt(0) !== '"' && value.charAt(0) !== "'")) {
        throw new Error("You seem to be using a value for 'content' without quotes, try replacing it with `content: '\"" + value + "\"'`");
      }
    }

    var processed = oldProcessStyleValue(key, value);

    if (processed !== '' && !isCustomProperty(key) && key.indexOf('-') !== -1 && hyphenatedCache[key] === undefined) {
      hyphenatedCache[key] = true;
      console.error("Using kebab-case for css properties in objects is not supported. Did you mean " + key.replace(msPattern, 'ms-').replace(hyphenPattern, function (str, _char) {
        return _char.toUpperCase();
      }) + "?");
    }

    return processed;
  };
}

var noComponentSelectorMessage = 'Component selectors can only be used in conjunction with ' + '@emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware ' + 'compiler transform.';

function handleInterpolation(mergedProps, registered, interpolation) {
  if (interpolation == null) {
    return '';
  }

  if (interpolation.__emotion_styles !== undefined) {
    if (process.env.NODE_ENV !== 'production' && interpolation.toString() === 'NO_COMPONENT_SELECTOR') {
      throw new Error(noComponentSelectorMessage);
    }

    return interpolation;
  }

  switch (typeof interpolation) {
    case 'boolean':
      {
        return '';
      }

    case 'object':
      {
        if (interpolation.anim === 1) {
          cursor = {
            name: interpolation.name,
            styles: interpolation.styles,
            next: cursor
          };
          return interpolation.name;
        }

        if (interpolation.styles !== undefined) {
          var next = interpolation.next;

          if (next !== undefined) {
            // not the most efficient thing ever but this is a pretty rare case
            // and there will be very few iterations of this generally
            while (next !== undefined) {
              cursor = {
                name: next.name,
                styles: next.styles,
                next: cursor
              };
              next = next.next;
            }
          }

          var styles = interpolation.styles + ";";

          if (process.env.NODE_ENV !== 'production' && interpolation.map !== undefined) {
            styles += interpolation.map;
          }

          return styles;
        }

        return createStringFromObject(mergedProps, registered, interpolation);
      }

    case 'function':
      {
        if (mergedProps !== undefined) {
          var previousCursor = cursor;
          var result = interpolation(mergedProps);
          cursor = previousCursor;
          return handleInterpolation(mergedProps, registered, result);
        } else if (process.env.NODE_ENV !== 'production') {
          console.error('Functions that are interpolated in css calls will be stringified.\n' + 'If you want to have a css call based on props, create a function that returns a css call like this\n' + 'let dynamicStyle = (props) => css`color: ${props.color}`\n' + 'It can be called directly with props or interpolated in a styled call like this\n' + "let SomeComponent = styled('div')`${dynamicStyle}`");
        }

        break;
      }

    case 'string':
      if (process.env.NODE_ENV !== 'production') {
        var matched = [];
        var replaced = interpolation.replace(animationRegex, function (match, p1, p2) {
          var fakeVarName = "animation" + matched.length;
          matched.push("const " + fakeVarName + " = keyframes`" + p2.replace(/^@keyframes animation-\w+/, '') + "`");
          return "${" + fakeVarName + "}";
        });

        if (matched.length) {
          console.error('`keyframes` output got interpolated into plain string, please wrap it with `css`.\n\n' + 'Instead of doing this:\n\n' + [].concat(matched, ["`" + replaced + "`"]).join('\n') + '\n\nYou should wrap it with `css` like this:\n\n' + ("css`" + replaced + "`"));
        }
      }

      break;
  } // finalize string values (regular strings and functions interpolated into css calls)


  if (registered == null) {
    return interpolation;
  }

  var cached = registered[interpolation];
  return cached !== undefined ? cached : interpolation;
}

function createStringFromObject(mergedProps, registered, obj) {
  var string = '';

  if (Array.isArray(obj)) {
    for (var i = 0; i < obj.length; i++) {
      string += handleInterpolation(mergedProps, registered, obj[i]) + ";";
    }
  } else {
    for (var _key in obj) {
      var value = obj[_key];

      if (typeof value !== 'object') {
        if (registered != null && registered[value] !== undefined) {
          string += _key + "{" + registered[value] + "}";
        } else if (isProcessableValue(value)) {
          string += processStyleName(_key) + ":" + processStyleValue(_key, value) + ";";
        }
      } else {
        if (_key === 'NO_COMPONENT_SELECTOR' && process.env.NODE_ENV !== 'production') {
          throw new Error(noComponentSelectorMessage);
        }

        if (Array.isArray(value) && typeof value[0] === 'string' && (registered == null || registered[value[0]] === undefined)) {
          for (var _i = 0; _i < value.length; _i++) {
            if (isProcessableValue(value[_i])) {
              string += processStyleName(_key) + ":" + processStyleValue(_key, value[_i]) + ";";
            }
          }
        } else {
          var interpolated = handleInterpolation(mergedProps, registered, value);

          switch (_key) {
            case 'animation':
            case 'animationName':
              {
                string += processStyleName(_key) + ":" + interpolated + ";";
                break;
              }

            default:
              {
                if (process.env.NODE_ENV !== 'production' && _key === 'undefined') {
                  console.error(UNDEFINED_AS_OBJECT_KEY_ERROR);
                }

                string += _key + "{" + interpolated + "}";
              }
          }
        }
      }
    }
  }

  return string;
}

var labelPattern = /label:\s*([^\s;\n{]+)\s*(;|$)/g;
var sourceMapPattern;

if (process.env.NODE_ENV !== 'production') {
  sourceMapPattern = /\/\*#\ssourceMappingURL=data:application\/json;\S+\s+\*\//g;
} // this is the cursor for keyframes
// keyframes are stored on the SerializedStyles object as a linked list


var cursor;
var serializeStyles = function serializeStyles(args, registered, mergedProps) {
  if (args.length === 1 && typeof args[0] === 'object' && args[0] !== null && args[0].styles !== undefined) {
    return args[0];
  }

  var stringMode = true;
  var styles = '';
  cursor = undefined;
  var strings = args[0];

  if (strings == null || strings.raw === undefined) {
    stringMode = false;
    styles += handleInterpolation(mergedProps, registered, strings);
  } else {
    if (process.env.NODE_ENV !== 'production' && strings[0] === undefined) {
      console.error(ILLEGAL_ESCAPE_SEQUENCE_ERROR);
    }

    styles += strings[0];
  } // we start at 1 since we've already handled the first arg


  for (var i = 1; i < args.length; i++) {
    styles += handleInterpolation(mergedProps, registered, args[i]);

    if (stringMode) {
      if (process.env.NODE_ENV !== 'production' && strings[i] === undefined) {
        console.error(ILLEGAL_ESCAPE_SEQUENCE_ERROR);
      }

      styles += strings[i];
    }
  }

  var sourceMap;

  if (process.env.NODE_ENV !== 'production') {
    styles = styles.replace(sourceMapPattern, function (match) {
      sourceMap = match;
      return '';
    });
  } // using a global regex with .exec is stateful so lastIndex has to be reset each time


  labelPattern.lastIndex = 0;
  var identifierName = '';
  var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5

  while ((match = labelPattern.exec(styles)) !== null) {
    identifierName += '-' + // $FlowFixMe we know it's not null
    match[1];
  }

  var name = murmur2(styles) + identifierName;

  if (process.env.NODE_ENV !== 'production') {
    // $FlowFixMe SerializedStyles type doesn't have toString property (and we don't want to add it)
    return {
      name: name,
      styles: styles,
      map: sourceMap,
      next: cursor,
      toString: function toString() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
      }
    };
  }

  return {
    name: name,
    styles: styles,
    next: cursor
  };
};

var isBrowser = typeof document !== 'undefined';
var hasOwnProperty = {}.hasOwnProperty;

var EmotionCacheContext = /* #__PURE__ */createContext( // we're doing this to avoid preconstruct's dead code elimination in this one case
// because this module is primarily intended for the browser and node
// but it's also required in react native and similar environments sometimes
// and we could have a special build just for that
// but this is much easier and the native packages
// might use a different theme context in the future anyway
typeof HTMLElement !== 'undefined' ? /* #__PURE__ */createCache({
  key: 'css'
}) : null);

if (process.env.NODE_ENV !== 'production') {
  EmotionCacheContext.displayName = 'EmotionCacheContext';
}

EmotionCacheContext.Provider;

var withEmotionCache = function withEmotionCache(func) {
  // $FlowFixMe
  return /*#__PURE__*/forwardRef(function (props, ref) {
    // the cache will never be null in the browser
    var cache = useContext(EmotionCacheContext);
    return func(props, cache, ref);
  });
};

if (!isBrowser) {
  withEmotionCache = function withEmotionCache(func) {
    return function (props) {
      var cache = useContext(EmotionCacheContext);

      if (cache === null) {
        // yes, we're potentially creating this on every render
        // it doesn't actually matter though since it's only on the server
        // so there will only every be a single render
        // that could change in the future because of suspense and etc. but for now,
        // this works and i don't want to optimise for a future thing that we aren't sure about
        cache = createCache({
          key: 'css'
        });
        return /*#__PURE__*/createElement$1(EmotionCacheContext.Provider, {
          value: cache
        }, func(props, cache));
      } else {
        return func(props, cache);
      }
    };
  };
}

var ThemeContext = /* #__PURE__ */createContext({});

if (process.env.NODE_ENV !== 'production') {
  ThemeContext.displayName = 'EmotionThemeContext';
}

var getLastPart = function getLastPart(functionName) {
  // The match may be something like 'Object.createEmotionProps' or
  // 'Loader.prototype.render'
  var parts = functionName.split('.');
  return parts[parts.length - 1];
};

var getFunctionNameFromStackTraceLine = function getFunctionNameFromStackTraceLine(line) {
  // V8
  var match = /^\s+at\s+([A-Za-z0-9$.]+)\s/.exec(line);
  if (match) return getLastPart(match[1]); // Safari / Firefox

  match = /^([A-Za-z0-9$.]+)@/.exec(line);
  if (match) return getLastPart(match[1]);
  return undefined;
};

var internalReactFunctionNames = /* #__PURE__ */new Set(['renderWithHooks', 'processChild', 'finishClassComponent', 'renderToString']); // These identifiers come from error stacks, so they have to be valid JS
// identifiers, thus we only need to replace what is a valid character for JS,
// but not for CSS.

var sanitizeIdentifier = function sanitizeIdentifier(identifier) {
  return identifier.replace(/\$/g, '-');
};

var getLabelFromStackTrace = function getLabelFromStackTrace(stackTrace) {
  if (!stackTrace) return undefined;
  var lines = stackTrace.split('\n');

  for (var i = 0; i < lines.length; i++) {
    var functionName = getFunctionNameFromStackTraceLine(lines[i]); // The first line of V8 stack traces is just "Error"

    if (!functionName) continue; // If we reach one of these, we have gone too far and should quit

    if (internalReactFunctionNames.has(functionName)) break; // The component name is the first function in the stack that starts with an
    // uppercase letter

    if (/^[A-Z]/.test(functionName)) return sanitizeIdentifier(functionName);
  }

  return undefined;
};

var isBrowser$1 = typeof document !== 'undefined';
var useInsertionEffect = React['useInsertion' + 'Effect'] ? React['useInsertion' + 'Effect'] : function useInsertionEffect(create) {
  create();
};
function useInsertionEffectMaybe(create) {
  if (!isBrowser$1) {
    return create();
  }

  useInsertionEffect(create);
}

var typePropName = '__EMOTION_TYPE_PLEASE_DO_NOT_USE__';
var labelPropName = '__EMOTION_LABEL_PLEASE_DO_NOT_USE__';
var createEmotionProps = function createEmotionProps(type, props) {
  if (process.env.NODE_ENV !== 'production' && typeof props.css === 'string' && // check if there is a css declaration
  props.css.indexOf(':') !== -1) {
    throw new Error("Strings are not allowed as css prop values, please wrap it in a css template literal from '@emotion/react' like this: css`" + props.css + "`");
  }

  var newProps = {};

  for (var key in props) {
    if (hasOwnProperty.call(props, key)) {
      newProps[key] = props[key];
    }
  }

  newProps[typePropName] = type; // For performance, only call getLabelFromStackTrace in development and when
  // the label hasn't already been computed

  if (process.env.NODE_ENV !== 'production' && !!props.css && (typeof props.css !== 'object' || typeof props.css.name !== 'string' || props.css.name.indexOf('-') === -1)) {
    var label = getLabelFromStackTrace(new Error().stack);
    if (label) newProps[labelPropName] = label;
  }

  return newProps;
};

var Insertion = function Insertion(_ref) {
  var cache = _ref.cache,
      serialized = _ref.serialized,
      isStringTag = _ref.isStringTag;
  registerStyles(cache, serialized, isStringTag);
  var rules = useInsertionEffectMaybe(function () {
    return insertStyles(cache, serialized, isStringTag);
  });

  if (!isBrowser && rules !== undefined) {
    var _ref2;

    var serializedNames = serialized.name;
    var next = serialized.next;

    while (next !== undefined) {
      serializedNames += ' ' + next.name;
      next = next.next;
    }

    return /*#__PURE__*/createElement$1("style", (_ref2 = {}, _ref2["data-emotion"] = cache.key + " " + serializedNames, _ref2.dangerouslySetInnerHTML = {
      __html: rules
    }, _ref2.nonce = cache.sheet.nonce, _ref2));
  }

  return null;
};

var Emotion = /* #__PURE__ */withEmotionCache(function (props, cache, ref) {
  var cssProp = props.css; // so that using `css` from `emotion` and passing the result to the css prop works
  // not passing the registered cache to serializeStyles because it would
  // make certain babel optimisations not possible

  if (typeof cssProp === 'string' && cache.registered[cssProp] !== undefined) {
    cssProp = cache.registered[cssProp];
  }

  var WrappedComponent = props[typePropName];
  var registeredStyles = [cssProp];
  var className = '';

  if (typeof props.className === 'string') {
    className = getRegisteredStyles(cache.registered, registeredStyles, props.className);
  } else if (props.className != null) {
    className = props.className + " ";
  }

  var serialized = serializeStyles(registeredStyles, undefined, useContext(ThemeContext));

  if (process.env.NODE_ENV !== 'production' && serialized.name.indexOf('-') === -1) {
    var labelFromStack = props[labelPropName];

    if (labelFromStack) {
      serialized = serializeStyles([serialized, 'label:' + labelFromStack + ';']);
    }
  }

  className += cache.key + "-" + serialized.name;
  var newProps = {};

  for (var key in props) {
    if (hasOwnProperty.call(props, key) && key !== 'css' && key !== typePropName && (process.env.NODE_ENV === 'production' || key !== labelPropName)) {
      newProps[key] = props[key];
    }
  }

  newProps.ref = ref;
  newProps.className = className;
  return /*#__PURE__*/createElement$1(Fragment$1, null, /*#__PURE__*/createElement$1(Insertion, {
    cache: cache,
    serialized: serialized,
    isStringTag: typeof WrappedComponent === 'string'
  }), /*#__PURE__*/createElement$1(WrappedComponent, newProps));
});

if (process.env.NODE_ENV !== 'production') {
  Emotion.displayName = 'EmotionCssPropInternal';
}

var Fragment = Fragment$2;
function jsx(type, props, key) {
  if (!hasOwnProperty.call(props, 'css')) {
    return jsx$1(type, props, key);
  }

  return jsx$1(Emotion, createEmotionProps(type, props), key);
}
function jsxs(type, props, key) {
  if (!hasOwnProperty.call(props, 'css')) {
    return jsxs$1(type, props, key);
  }

  return jsxs$1(Emotion, createEmotionProps(type, props), key);
}

const Container$1 = styled('form')({
  width: 300,
  boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.15)'
});
const ButtonGroup = styled('div')({
  display: 'flex',
  justifyContent: 'space-between',
  gap: 10,
  padding: 15
});
const StyledButton$1 = styled(Button)(() => ({
  textTransform: 'none'
}));
const FilterContainer = ({
  component,
  handleCancellation,
  handleConfirmation,
  className,
  submitDisabled: _submitDisabled = false
}) => {
  const handleSubmitClick = e => {
    e.preventDefault();
    handleConfirmation();
  };
  return jsxs(Container$1, Object.assign({
    className: className,
    "data-test-id": "filter-container"
  }, {
    children: [component, jsxs(ButtonGroup, {
      children: [jsx(StyledButton$1, Object.assign({
        "data-test-id": "panel-cancel",
        variant: "secondary",
        onClick: handleCancellation
      }, {
        children: "Cancel"
      })), jsx(StyledButton$1, Object.assign({
        "data-test-id": "panel-confirm",
        disabled: _submitDisabled,
        type: "submit",
        onClick: handleSubmitClick
      }, {
        children: "Confirm"
      }))]
    })]
  }));
};

const ColumnsIcon = props => {
  return jsx("svg", Object.assign({
    fill: "none",
    height: "17",
    viewBox: "0 0 17 17",
    width: "17",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    children: jsx("path", {
      d: "M8.5 1V16M8.5 1H14.3333C14.7754 1 15.1993 1.17559 15.5118 1.48816C15.8244 1.80072 16 2.22464 16 2.66667V14.3333C16 14.7754 15.8244 15.1993 15.5118 15.5118C15.1993 15.8244 14.7754 16 14.3333 16H8.5V1ZM8.5 1H2.66667C2.22464 1 1.80072 1.17559 1.48816 1.48816C1.17559 1.80072 1 2.22464 1 2.66667V14.3333C1 14.7754 1.17559 15.1993 1.48816 15.5118C1.80072 15.8244 2.22464 16 2.66667 16H8.5V1Z",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.5"
    })
  }));
};
const ResetIcon = props => jsx("svg", Object.assign({
  fill: "none",
  fontSize: "inherit",
  height: "12",
  viewBox: "0 0 14 12",
  width: "14",
  xmlns: "http://www.w3.org/2000/svg"
}, props, {
  children: jsx("path", {
    d: "M7.99667 0C4.68 0 2 2.68667 2 6H0L2.59667 8.59667L2.64333 8.69333L5.33333 6H3.33333C3.33333 3.42333 5.42333 1.33333 8 1.33333C10.5767 1.33333 12.6667 3.42333 12.6667 6C12.6667 8.57667 10.5767 10.6667 8 10.6667C6.71 10.6667 5.54667 10.14 4.70333 9.29667L3.76 10.24C4.84333 11.3267 6.34 12 7.99667 12C11.3133 12 14 9.31333 14 6C14 2.68667 11.3133 0 7.99667 0Z",
    fill: "#9A9EA4"
  })
}));

const createInitialFilterState = filters => {
  return {
    filterModel: {
      items: (filters === null || filters === void 0 ? void 0 : filters.map((filter, index) => Object({
        id: index,
        value: filter.value,
        columnField: filter.field,
        operatorValue: filter.operator
      }))) || []
    }
  };
};
const createInitialStateFilters = filters => {
  if (filters === null || filters === void 0 ? void 0 : filters.length) {
    return filters.reduce((acc, el) => {
      acc[el.field] = el;
      return acc;
    }, {});
  }
  return {};
};
const transformFiltersFromRecord = filters => {
  const entries = Object.entries(filters);
  if (entries === null || entries === void 0 ? void 0 : entries.length) {
    // eslint-disable-next-line no-unused-vars
    return entries.map(([, el]) => el);
  }
  return [];
};
const createColumnPanelCheck = (columnsToCheck, columns) => {
  let index = 0;
  const indexedMarkedColumns = columnsToCheck.map(item => {
    return {
      column: item,
      index: index++,
      checked: true
    };
  });
  columns === null || columns === void 0 ? void 0 : columns.forEach(col => {
    if (col && !columnsToCheck.includes(col)) {
      indexedMarkedColumns.push({
        column: col,
        index: index++,
        checked: false
      });
    }
  });
  return indexedMarkedColumns;
};
const getColumnsNumber = columns => {
  return columns.filter(item => item.field !== 'customActions' && item.hideable).length;
};

// TODO: discuss
const whatSwapped = (prevList, newList) => {
  var _a, _b;
  const swapped = [];
  for (let i = 0; i < prevList.length; i++) {
    if (((_a = prevList[i]) === null || _a === void 0 ? void 0 : _a.column) !== ((_b = newList[i]) === null || _b === void 0 ? void 0 : _b.column)) {
      swapped.push({
        from: i,
        to: newList.indexOf(prevList[i])
      });
    }
  }
  return swapped[0];
};
const Row = styled('div')(({
  theme
}) => ({
  position: 'relative',
  display: 'flex',
  alignItems: 'center',
  marginBottom: '8px',
  '&:hover': {
    '& button': {
      display: 'block'
    }
  },
  padding: `0 ${theme.spacing(3.5)}`
}));
const StyledCheckboxListContainer = styled(FilterContainer)(({
  tableHeight,
  toolbarMargin
}) => ({
  height: tableHeight + toolbarMargin,
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between'
}));
const DragIcon = styled(AppsIcon)(() => ({
  marginRight: theme.spacing(1),
  fontSize: theme.spacing(2.25),
  position: 'absolute',
  left: 0,
  color: theme.palette.grey[600],
  display: 'none'
}));
const ReorderGroup = styled(Reorder.Group)(({
  theme
}) => ({
  paddingLeft: theme.spacing(2),
  marginTop: 0,
  '& ul,li': {
    listStyle: 'none',
    padding: 0,
    margin: 0
  },
  '& li': {
    cursor: 'grab'
  }
}));
const ReorderItem = styled(Reorder.Item)(() => ({
  svg: {
    display: 'block'
  }
}));
const StyledEditedColumnContainer = styled(Box)(({
  theme
}) => ({
  display: 'flex',
  padding: theme.spacing(0, 2),
  justifyContent: 'space-between'
}));
const StyledEditedColumnsHeader = styled(Typography)(() => Object.assign(Object.assign({}, theme.typography.body2U), {
  color: theme.palette.grey[800]
}));
const StyledResetTypography = styled(Typography)(() => Object.assign(Object.assign({}, theme.typography.body2), {
  color: theme.palette.grey[400],
  cursor: 'pointer',
  display: 'flex',
  gap: theme.spacing(1),
  alignItems: 'baseline'
}));
const StyledTypography$1 = styled(Box)(() => ({
  '. &MuiFormControlLabel-label': Object.assign({}, theme.typography.body2)
}));
const ColumnsPanel = ({
  columns,
  columnsToCheck: colsToCheckProp,
  onConfirmSelectedColumns,
  onColumnsChange,
  onClose,
  tableHeight: _tableHeight = 300
}) => {
  const dragControls = useDragControls();
  const columnsFields = columns.map(item => item.field);
  const columnsToCheck = colsToCheckProp !== null && colsToCheckProp !== void 0 ? colsToCheckProp : columns.map(col => col.field);
  const initialColumns = createColumnPanelCheck(columnsToCheck, columnsFields).filter(col => !columns.some(item => col.column === item.field && !item.hideable));
  const [disableSubmit, setDisableSubmit] = useState(false);
  const [checkedColumns, setCheckedColumns] = React__default.useState(initialColumns);
  const resetHandel = () => {
    setCheckedColumns(initialColumns);
  };
  const toolbarMargin = 24;
  const allColumns = columns.map(col => ({
    value: col.field,
    label: col.headerName
  }));
  const handleChange = field => {
    let disabledConfirm = true;
    const newColumns = checkedColumns.map(item => {
      if (item.column === field) {
        item.checked = !item.checked;
      }
      disabledConfirm = disabledConfirm && !item.checked;
      return item;
    });
    setDisableSubmit(disabledConfirm);
    setCheckedColumns(newColumns);
  };
  const handleConfirm = () => {
    const customActions = columns.some(column => column.field === 'customActions');
    const result = checkedColumns.reduce((acc, curr) => {
      if (curr.checked) {
        acc.push(curr.column);
      }
      return acc;
    }, []);
    if (onConfirmSelectedColumns) {
      onConfirmSelectedColumns(result);
    }
    onColumnsChange([...result, ...(customActions ? ['customActions'] : [])]);
    onClose();
  };
  const handleReorder = list => {
    const swap = whatSwapped(checkedColumns, list);
    if (swap) {
      const result = Array.from(checkedColumns);
      result[swap.to].index = swap.from;
      result[swap.from].index = swap.to;
      const [removed] = result.splice(checkedColumns[swap.from].index, 1);
      result.splice(checkedColumns[swap.to].index, 0, removed);
      setCheckedColumns(result);
    }
  };
  return jsx(StyledCheckboxListContainer, {
    component: jsxs("div", Object.assign({
      style: {
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        overflowY: 'auto'
      }
    }, {
      children: [jsx(VerticalSpace, {
        units: 4
      }), jsxs(StyledEditedColumnContainer, {
        children: [jsx(StyledEditedColumnsHeader, Object.assign({
          variant: "body3"
        }, {
          children: "Edit Columns"
        })), jsxs(StyledResetTypography, Object.assign({
          dataTestId: "column-panel-reset",
          variant: "body2",
          onClick: resetHandel
        }, {
          children: [jsx(ResetIcon, {}), "Reset"]
        }))]
      }), jsx(VerticalSpace, {
        units: 2
      }), jsx(ScrollArea, Object.assign({
        height: '100%'
      }, {
        children: jsx(ReorderGroup, Object.assign({
          axis: "y",
          values: checkedColumns,
          onReorder: handleReorder
        }, {
          children: (checkedColumns !== null && checkedColumns !== void 0 ? checkedColumns : []).map(col => {
            var _a;
            const {
              column,
              checked
            } = col;
            const colData = allColumns.find(col => col.value === column) || {
              label: '',
              value: ''
            };
            return jsx(ReorderItem, Object.assign({
              value: col
            }, {
              children: jsxs(Row, {
                children: [jsx(DragIcon, {
                  onPointerDown: e => dragControls.start(e)
                }), jsx(StyledTypography$1, {
                  children: jsx(Checkbox, {
                    checked: checked,
                    dataTestId: `column-panel-checkbox-${(_a = colData.label) === null || _a === void 0 ? void 0 : _a.toLowerCase()}`,
                    label: colData.label,
                    value: colData,
                    onChange: () => handleChange(column)
                  }, column)
                })]
              }, column)
            }), column);
          })
        }))
      }))]
    })),
    handleCancellation: onClose,
    handleConfirmation: handleConfirm,
    submitDisabled: disableSubmit,
    tableHeight: _tableHeight,
    toolbarMargin: toolbarMargin
  });
};

var anObject$1 = anObject$7;

// `RegExp.prototype.flags` getter implementation
// https://tc39.es/ecma262/#sec-get-regexp.prototype.flags
var regexpFlags = function () {
  var that = anObject$1(this);
  var result = '';
  if (that.hasIndices) result += 'd';
  if (that.global) result += 'g';
  if (that.ignoreCase) result += 'i';
  if (that.multiline) result += 'm';
  if (that.dotAll) result += 's';
  if (that.unicode) result += 'u';
  if (that.unicodeSets) result += 'v';
  if (that.sticky) result += 'y';
  return result;
};

var call = functionCall;
var hasOwn$1 = hasOwnProperty_1;
var isPrototypeOf$1 = objectIsPrototypeOf;
var regExpFlags = regexpFlags;

var RegExpPrototype$1 = RegExp.prototype;

var regexpGetFlags = function (R) {
  var flags = R.flags;
  return flags === undefined && !('flags' in RegExpPrototype$1) && !hasOwn$1(R, 'flags') && isPrototypeOf$1(RegExpPrototype$1, R)
    ? call(regExpFlags, R) : flags;
};

var PROPER_FUNCTION_NAME = functionName.PROPER;
var defineBuiltIn = defineBuiltIn$4;
var anObject = anObject$7;
var $toString = toString$2;
var fails = fails$e;
var getRegExpFlags = regexpGetFlags;

var TO_STRING = 'toString';
var RegExpPrototype = RegExp.prototype;
var nativeToString = RegExpPrototype[TO_STRING];

var NOT_GENERIC = fails(function () { return nativeToString.call({ source: 'a', flags: 'b' }) != '/a/b'; });
// FF44- RegExp#toString has a wrong name
var INCORRECT_NAME = PROPER_FUNCTION_NAME && nativeToString.name != TO_STRING;

// `RegExp.prototype.toString` method
// https://tc39.es/ecma262/#sec-regexp.prototype.tostring
if (NOT_GENERIC || INCORRECT_NAME) {
  defineBuiltIn(RegExp.prototype, TO_STRING, function toString() {
    var R = anObject(this);
    var pattern = $toString(R.source);
    var flags = $toString(getRegExpFlags(R));
    return '/' + pattern + '/' + flags;
  }, { unsafe: true });
}

const DatePickerContainer = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  flex: 1,
  gap: 10
});
const Container = styled('div')({
  padding: 15
});
const RangeContainer = styled('div')(({
  theme
}) => ({
  borderBottom: `1px solid ${theme.palette.grey[200]}`,
  paddingBottom: 15
}));
const HorizontalStack = styled('div')(() => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center'
}));
// TODO: maybe this should be a new button variant,
// since it's being used on the several screens in the design
const StyledTypography = styled(Typography)(() => ({
  fontSize: '14px',
  fontWeight: 700,
  textDecoration: 'underline',
  textTransform: 'capitalize'
}));
const StyledButton = styled(Button)(() => ({
  width: 'fit-content',
  height: 'fit-content',
  padding: 0,
  minWidth: 'unset'
}));
const predefinedRanges = [{
  label: 'Today',
  value: '0'
}, {
  label: '3D',
  value: '3'
}, {
  label: '7D',
  value: '7'
}, {
  label: '30D',
  value: '30'
}, {
  label: '90D',
  value: '90'
}];
const dateDaysAgo = days => sub(new Date(), {
  days
});
const dateRangeDaysAgo = days => [dateDaysAgo(days), new Date()];
const hasRange = value => value && value[0] !== null && value[1] !== null;
const findPredefinedRange = value => {
  var _a, _b;
  const diff = Math.abs(differenceInDays((_a = value[0]) !== null && _a !== void 0 ? _a : Date.now(), (_b = value[1]) !== null && _b !== void 0 ? _b : Date.now())).toString();
  const item = predefinedRanges.find(item => item.value === diff);
  console.log({
    item
  });
  return item ? item.value : '';
};
const adjustDateRangeToIncludeFullDays = value => {
  return [startOfDay(value[0]), endOfDay(value[1])];
};
const DateFilter = ({
  onChange,
  value: valueProp,
  field,
  onClose,
  minDate,
  maxDate
}) => {
  const [value, setValue] = React__default.useState(hasRange(valueProp) ? valueProp : dateRangeDaysAgo(3));
  console.log({
    valueProp,
    value
  });
  const [errors, setErrors] = React__default.useState([null, null]);
  const handleConfirmation = React__default.useCallback(value => {
    onChange({
      field,
      value,
      operator: 'range'
    });
    onClose();
  },
  // eslint-disable-next-line react-hooks/exhaustive-deps
  [field]);
  const handleCancellation = () => {
    onClose();
    // TODO - Find a way to close the tooltip
  };

  const handlePredefinedDate = e => {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    const value = e.target.value;
    const result = dateRangeDaysAgo(Number(value));
    setValue(adjustDateRangeToIncludeFullDays(result));
  };
  const handleClear = () => {
    handleConfirmation(null);
  };
  const hasChosenDates = value[0] && value[1];
  const inputProps = {
    sx: {
      '& input': {
        cursor: 'pointer'
      }
    },
    endAdornment: jsx(CalendarTodayIcon, {
      color: "primary"
    })
  };
  return jsx(FilterContainer, {
    component: jsxs(Container, {
      children: [jsx(RangeContainer, {
        children: jsx(ToggleButton, {
          options: predefinedRanges,
          value: hasChosenDates ? findPredefinedRange(value) : null,
          onChange: handlePredefinedDate
        })
      }), jsx(VerticalSpace, {}), jsxs(HorizontalStack, {
        children: [jsx(Typography, {
          children: "Custom"
        }), jsx(StyledButton, Object.assign({
          size: "small",
          variant: "text",
          onClick: handleClear
        }, {
          children: jsx(StyledTypography, Object.assign({
            color: "primary",
            dataTestId: "date-clear"
          }, {
            children: "Clear"
          }))
        }))]
      }), jsx(VerticalSpace, {}), jsx(MobileDateRangePicker, {
        maxDate: maxDate,
        minDate: minDate,
        renderInput: (startProps, endProps) => {
          return jsxs(DatePickerContainer, {
            children: [jsx(TextField, Object.assign({
              autoFocus: true,
              "data-test-id": "start-date",
              InputProps: inputProps
            }, startProps, {
              error: Boolean(startProps.error),
              helperText: startProps.error ? 'Wrong date format' : ' '
            })), jsx(TextField, Object.assign({
              "data-test-id": "end-date",
              InputProps: inputProps
            }, endProps, {
              error: Boolean(endProps.error),
              helperText: endProps.error ? 'Wrong date format' : ' '
            }))]
          });
        },
        startText: 'From',
        value: value,
        onChange: newValue => {
          setValue(adjustDateRangeToIncludeFullDays(newValue));
        },
        onError: reason => {
          setErrors(reason);
        }
      })]
    }),
    handleCancellation: handleCancellation,
    handleConfirmation: () => handleConfirmation(value),
    submitDisabled: Boolean(errors[0] || errors[1])
  });
};

var $ = _export;
var DESCRIPTORS = descriptors;
var global$1 = global$d;
var uncurryThis = functionUncurryThis;
var hasOwn = hasOwnProperty_1;
var isCallable = isCallable$g;
var isPrototypeOf = objectIsPrototypeOf;
var toString = toString$2;
var defineProperty = objectDefineProperty.f;
var copyConstructorProperties = copyConstructorProperties$2;

var NativeSymbol = global$1.Symbol;
var SymbolPrototype = NativeSymbol && NativeSymbol.prototype;

if (DESCRIPTORS && isCallable(NativeSymbol) && (!('description' in SymbolPrototype) ||
  // Safari 12 bug
  NativeSymbol().description !== undefined
)) {
  var EmptyStringDescriptionStore = {};
  // wrap Symbol constructor for correct work with undefined description
  var SymbolWrapper = function Symbol() {
    var description = arguments.length < 1 || arguments[0] === undefined ? undefined : toString(arguments[0]);
    var result = isPrototypeOf(SymbolPrototype, this)
      ? new NativeSymbol(description)
      // in Edge 13, String(Symbol(undefined)) === 'Symbol(undefined)'
      : description === undefined ? NativeSymbol() : NativeSymbol(description);
    if (description === '') EmptyStringDescriptionStore[result] = true;
    return result;
  };

  copyConstructorProperties(SymbolWrapper, NativeSymbol);
  SymbolWrapper.prototype = SymbolPrototype;
  SymbolPrototype.constructor = SymbolWrapper;

  var NATIVE_SYMBOL = String(NativeSymbol('test')) == 'Symbol(test)';
  var thisSymbolValue = uncurryThis(SymbolPrototype.valueOf);
  var symbolDescriptiveString = uncurryThis(SymbolPrototype.toString);
  var regexp = /^Symbol\((.*)\)[^)]+$/;
  var replace = uncurryThis(''.replace);
  var stringSlice = uncurryThis(''.slice);

  defineProperty(SymbolPrototype, 'description', {
    configurable: true,
    get: function description() {
      var symbol = thisSymbolValue(this);
      if (hasOwn(EmptyStringDescriptionStore, symbol)) return '';
      var string = symbolDescriptiveString(symbol);
      var desc = NATIVE_SYMBOL ? stringSlice(string, 7, -1) : replace(string, regexp, '$1');
      return desc === '' ? undefined : desc;
    }
  });

  $({ global: true, constructor: true, forced: true }, {
    Symbol: SymbolWrapper
  });
}

const NoResultsIcon = props => {
  return jsxs(SvgIcon, Object.assign({
    color: "primary",
    fill: "none",
    style: {
      height: 280,
      width: 280
    },
    viewBox: "0 0 280 280",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    children: [jsx("path", {
      d: "M41.5003 212.398C49.1163 230.983 61.5343 234.851 70.2651 230.983C87.1502 223.501 131.012 215.143 176.059 234.791C235.722 260.814 248.416 221.552 229.375 181.837C210.334 142.123 203.88 101.96 225.831 79.8331C247.782 57.706 219.057 23.0912 168.044 59.1228C135.077 82.4078 110.884 77.2229 97.892 70.6403C85.6476 64.4365 72.0304 57.9507 59.2723 63.0148C43.7918 69.1598 37.692 82.4825 61.2449 112.246C94.6213 154.422 24.428 170.74 41.5003 212.398Z",
      fill: "#F4F7FF"
    }), jsx("path", {
      d: "M73.0103 122.364H190.538V213.02C190.538 213.073 190.517 213.123 190.48 213.161C190.442 213.199 190.392 213.22 190.338 213.22H73.2103C73.1572 213.22 73.1063 213.198 73.0688 213.161C73.0313 213.123 73.0103 213.073 73.0103 213.02V122.364Z",
      fillOpacity: "0.2",
      stroke: "currentColor",
      strokeOpacity: "0.2"
    }), jsx("path", {
      d: "M161.304 86.1428H106.19L72.5103 121.864H191.038L161.304 86.1428Z"
    }), jsx("path", {
      d: "M83.7368 71.8541L106.19 86.1427L72.51 121.864L46.9946 102.472L83.7368 71.8541Z",
      fillOpacity: "0.2"
    }), jsx("path", {
      d: "M183.757 71.8541L161.303 86.1427L191.038 121.864L220.499 102.472L183.757 71.8541Z",
      fillOpacity: "0.2"
    }), jsx("path", {
      d: "M120.67 72.5847C121.303 72.2843 121.796 71.7506 122.046 71.0952C122.295 70.4398 122.281 69.7134 122.008 69.0678L111.907 45.2499C111.764 44.9125 111.554 44.6075 111.29 44.3533C111.026 44.0991 110.713 43.9009 110.371 43.7706C110.028 43.6404 109.663 43.5807 109.297 43.5952C108.931 43.6097 108.571 43.6982 108.24 43.8552L106.294 44.7779C105.963 44.9349 105.667 45.1572 105.424 45.4315C105.181 45.7058 104.996 46.0264 104.88 46.3741C104.764 46.7217 104.72 47.0892 104.75 47.4544C104.779 47.8197 104.883 48.1751 105.053 48.4994L117.1 71.3944C117.427 72.015 117.98 72.4854 118.646 72.7072C119.311 72.929 120.036 72.8851 120.67 72.5847Z"
    }), jsx("path", {
      d: "M133.334 70.2757C133.792 70.243 134.221 70.0344 134.529 69.6934C134.837 69.3525 135.002 68.9055 134.989 68.446L134.49 51.4897C134.483 51.2496 134.427 51.0133 134.326 50.7951C134.226 50.577 134.082 50.3814 133.904 50.2203C133.725 50.0591 133.517 49.9356 133.289 49.8573C133.062 49.7789 132.822 49.7473 132.582 49.7644L131.173 49.8648C130.933 49.8818 130.7 49.9471 130.486 50.0568C130.272 50.1664 130.083 50.3182 129.929 50.5029C129.776 50.6875 129.661 50.9014 129.592 51.1315C129.524 51.3616 129.502 51.6033 129.529 51.842L131.437 68.698C131.488 69.155 131.714 69.5743 132.068 69.8683C132.422 70.1623 132.875 70.3083 133.334 70.2757V70.2757Z"
    }), jsx("path", {
      d: "M143.11 76.5438C144.371 77.2731 146.142 76.6039 147.124 75.0265L164.563 47.0191C165.605 45.3459 165.358 43.3067 164.02 42.5332L162.155 41.4552C160.818 40.6816 158.927 41.4849 157.997 43.2224L142.422 72.3077C141.545 73.9458 141.848 75.8144 143.11 76.5438Z"
    })]
  }));
};

const Grid = styled('div')({
  display: 'flex',
  '& > div': {
    alignSelf: 'center'
  }
});
const NoResults = ({
  header: _header = 'No Data Found',
  description,
  graphic: _graphic = jsx(NoResultsIcon, {})
}) => {
  return jsx(Box$1, Object.assign({
    alignItems: "center",
    display: "flex",
    height: "100%",
    justifyContent: "center"
  }, {
    children: jsxs(Grid, {
      children: [_graphic, jsxs("div", {
        children: [jsx(Typography, Object.assign({
          color: "primary",
          variant: "h2"
        }, {
          children: _header
        })), jsx(Typography, Object.assign({
          variant: "body3"
        }, {
          children: description
        }))]
      })]
    })
  }));
};

const SelectFilterWithSearch = ({
  options,
  selected,
  onChange,
  field,
  onClose,
  entityName
}) => {
  const [values, setValues] = React__default.useState(selected !== null && selected !== void 0 ? selected : []);
  const operator = 'in';
  const handleConfirmation = () => {
    onChange({
      field,
      value: values.length > 0 ? areOptionsOfTypeCollection(values) ? values.map(val => val.value) : values : null,
      operator
    });
    onClose();
  };
  const handleCancellation = () => {
    onClose();
  };
  return jsx(FilterContainer, {
    component: jsx(MultiSelectWithSearch, {
      options: options,
      placeholder: `Search ${entityName}`,
      selected: values,
      onChange: items => {
        setValues(items);
      }
    }),
    handleCancellation: handleCancellation,
    handleConfirmation: handleConfirmation
  });
};

const TextFilter = ({
  onChange,
  value: valueProp,
  field,
  onClose,
  operator: operatorProp
}) => {
  const [value, setValue] = React__default.useState(valueProp);
  const operator = operatorProp !== null && operatorProp !== void 0 ? operatorProp : 'eq';
  const handleChange = event => {
    setValue(event.target.value);
  };
  const handleConfirmation = () => {
    onChange({
      field,
      value: value.length > 0 ? value : null,
      operator
    });
    onClose();
  };
  const handleCancellation = () => {
    onClose();
  };
  const handleOnKeyDown = event => {
    const target = event.target;
    if (event.code === 'Home') {
      target.setSelectionRange(0, 0);
    } else if (event.code === 'End') {
      target.setSelectionRange(target.value.length, target.value.length);
    }
  };
  return jsx(FilterContainer, {
    component: jsx(TextField, {
      autoFocus: true,
      autoComplete: "off",
      "data-test-id": `text-filter-${field}`,
      value: value,
      onChange: handleChange,
      onKeyDown: handleOnKeyDown
    }),
    handleCancellation: handleCancellation,
    handleConfirmation: handleConfirmation
  });
};

const ToolbarButtonsWithTooltip = ({
  title,
  children
}) => {
  return jsx(Tooltip, Object.assign({
    componentsProps: {
      tooltip: {
        sx: {
          background: 'none',
          boxShadow: 'none',
          padding: 0
        }
      },
      transition: {
        style: {
          margin: '4px auto'
        }
      }
    },
    title: title
  }, {
    children: children
  }));
};

const FilterIconActive = props => {
  return jsxs(SvgIcon, Object.assign({
    color: "primary",
    fill: "none",
    style: {
      height: 32,
      width: 32
    },
    viewBox: "0 0 32 32",
    width: "32",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    children: [jsx("rect", {
      height: "32",
      rx: "4",
      width: "32"
    }), jsx("path", {
      d: "M24.6667 10H8L14.6667 17.8833V23.3333L18 25V17.8833L24.6667 10Z",
      fill: "white"
    })]
  }));
};

const FilterIconHidden = props => {
  return jsxs("svg", Object.assign({
    fill: "none",
    height: "32",
    viewBox: "0 0 33 32",
    width: "33",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    children: [jsx("rect", {
      fill: "none",
      height: "31",
      rx: "3.5",
      stroke: "#65686D",
      width: "32",
      x: "0.5",
      y: "0.5"
    }), jsx("path", {
      d: "M24.6667 9H8L14.6667 16.8833V22.3333L18 24V16.8833L24.6667 9Z",
      stroke: "#40444B",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "2"
    })]
  }));
};

const FilterIconVisible = props => {
  return jsxs(SvgIcon, Object.assign({
    fill: "none",
    style: {
      height: 32,
      width: 32
    },
    viewBox: "0 0 33 32",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    children: [jsx("rect", {
      fill: "none",
      height: "31",
      rx: "3.5",
      stroke: "currentColor",
      width: "32",
      x: "0.5",
      y: "0.5"
    }), jsx("path", {
      d: "M24.6667 9H8L14.6667 16.8833V22.3333L18 24V16.8833L24.6667 9Z",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "2"
    })]
  }));
};

const getFilterIcon = state => {
  switch (state) {
    case 'hidden':
      return FilterIconHidden;
    case 'visible':
      return FilterIconVisible;
    case 'active':
      return FilterIconActive;
  }
};

function usePreviousValue(value) {
  const ref = React__default.useRef(value);
  React__default.useEffect(() => {
    ref.current = value;
  }, [value]);
  return ref.current;
}

const ErrorIcon = props => {
  return jsxs(SvgIcon, Object.assign({
    color: "primary",
    fill: "none",
    style: {
      height: 280,
      width: 280
    },
    viewBox: "0 0 280 280",
    width: "280",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    children: [jsx("path", {
      d: "M84.5562 73.8864C84.5562 73.8864 114.58 96.6704 160.224 54.0684C200.76 16.2347 233.859 75.9278 234.09 104.514C234.39 141.544 193.554 171.174 213.372 195.496C233.189 219.817 174.07 259.981 142.208 225.222C102.572 181.983 91.8345 217.115 69.2424 217.115C53.0278 217.115 19.7376 176.826 42.2181 146.852C61.1352 121.629 50.8181 113.258 45.822 104.514C38.6149 91.9025 55.7303 57.6719 84.5562 73.8864Z",
      fillOpacity: "0.1"
    }), jsx("path", {
      d: "M205.092 124.236C206.706 124.836 208.469 124.875 210.147 124.49C217.177 122.877 241.35 118.604 237.15 137.336C236.235 141.052 222.078 161.865 242.239 169.463C243.717 170.027 245.279 170.334 246.86 170.373C253.068 170.501 265.369 169.035 270.517 163.794C276.737 157.464 269.942 160.466 269.942 160.466C269.942 160.466 246.298 170.784 237.946 159.837C237.017 158.619 236.425 156.85 236.256 155.327C235.962 152.687 237.134 149.197 238.674 146.16C240.759 142.049 250.766 123.556 229.038 118.169C224.033 116.977 216.763 115.906 207.39 119.853C201.922 122.155 203.133 123.508 205.092 124.236Z",
      fillOpacity: "0.2"
    }), jsx("path", {
      d: "M209.93 117.332L203.637 119.687C201.465 120.5 200.363 122.92 201.176 125.093L201.488 125.926C202.301 128.099 204.721 129.201 206.893 128.388L213.187 126.032C215.359 125.219 216.461 122.799 215.648 120.627L215.336 119.793C214.523 117.621 212.103 116.519 209.93 117.332Z"
    }), jsx("path", {
      d: "M171.3 124.148L150.546 131.915C149.459 132.322 148.908 133.532 149.315 134.618L149.397 134.837C149.803 135.923 151.013 136.474 152.1 136.067L172.854 128.299C173.941 127.893 174.492 126.683 174.085 125.597L174.003 125.378C173.597 124.292 172.387 123.741 171.3 124.148Z"
    }), jsx("path", {
      d: "M177.093 139.624L156.338 147.392C155.252 147.798 154.701 149.008 155.108 150.095L155.189 150.313C155.596 151.399 156.806 151.95 157.892 151.544L178.647 143.776C179.733 143.369 180.284 142.159 179.878 141.073L179.796 140.855C179.39 139.768 178.179 139.217 177.093 139.624Z"
    }), jsx("path", {
      d: "M196.255 113.586L179.434 119.881C177.261 120.694 176.159 123.115 176.972 125.287L182.716 140.632C183.529 142.805 185.949 143.907 188.121 143.094L204.943 136.798C207.115 135.985 208.217 133.565 207.404 131.392L201.661 116.047C200.848 113.875 198.428 112.773 196.255 113.586Z"
    }), jsx("path", {
      d: "M181.172 117.611L164.35 123.907C162.178 124.72 161.076 127.14 161.889 129.312L168.741 147.62C169.554 149.792 171.974 150.894 174.146 150.081L190.968 143.786C193.14 142.972 194.242 140.552 193.429 138.38L186.577 120.072C185.764 117.9 183.344 116.798 181.172 117.611Z"
    }), jsx("path", {
      d: "M183.805 113.896L183.673 113.945C182.225 114.487 181.49 116.101 182.032 117.549L191.631 143.196C192.173 144.644 193.786 145.379 195.234 144.837L195.366 144.787C196.815 144.245 197.549 142.632 197.007 141.183L187.409 115.537C186.867 114.089 185.253 113.354 183.805 113.896Z",
      fillOpacity: "0.6"
    }), jsx("path", {
      d: "M12.2816 130.293C12.2816 130.293 46.0647 120.799 41.16 142.672C40.3082 146.133 28.0471 163.954 42.6519 172.51C45.7879 174.347 49.4069 175.161 53.0412 175.142C59.5572 175.108 69.8871 173.854 74.5277 169.131C80.747 162.799 73.9526 165.802 73.9526 165.802C73.9526 165.802 54.5504 173.783 44.5687 167.421C41.1604 165.249 39.6155 161.043 40.541 157.108C41.0141 155.154 41.7344 153.268 42.6847 151.496C44.8555 147.43 54.7768 128.892 33.0488 123.505C28.0435 122.313 20.7737 121.242 11.4 125.189C2.02631 129.136 12.2816 130.293 12.2816 130.293Z",
      fillOpacity: "0.2"
    }), jsx("path", {
      d: "M79.0704 160.907L72.7772 163.262C70.6047 164.075 69.5027 166.495 70.3158 168.668L70.6278 169.501C71.4408 171.674 73.861 172.776 76.0335 171.963L82.3267 169.607C84.4992 168.794 85.6011 166.374 84.7881 164.202L84.4761 163.368C83.6631 161.196 81.2428 160.094 79.0704 160.907Z"
    }), jsx("path", {
      d: "M89.7031 150.553L80.3762 154.043C78.2037 154.857 77.1017 157.277 77.9148 159.449L82.4122 171.466C83.2253 173.638 85.6455 174.74 87.8179 173.927L97.1448 170.437C99.3173 169.623 100.419 167.203 99.6062 165.031L95.1088 153.014C94.2957 150.842 91.8755 149.74 89.7031 150.553Z"
    }), jsx("path", {
      d: "M105.23 141.301L91.3212 146.506C89.1488 147.319 88.0468 149.74 88.8599 151.912L95.7116 170.219C96.5247 172.392 98.9449 173.494 101.117 172.681L115.026 167.475C117.199 166.662 118.301 164.242 117.488 162.069L110.636 143.762C109.823 141.59 107.403 140.488 105.23 141.301Z"
    }), jsx("path", {
      d: "M108.177 137.51L108.045 137.56C106.596 138.102 105.862 139.715 106.404 141.163L116.002 166.81C116.544 168.258 118.158 168.993 119.606 168.451L119.738 168.401C121.186 167.859 121.921 166.246 121.379 164.798L111.78 139.151C111.238 137.703 109.625 136.968 108.177 137.51Z",
      fillOpacity: "0.6"
    }), jsx("path", {
      d: "M143.694 121.171C143.193 121.115 142.733 120.867 142.411 120.48C142.09 120.092 141.931 119.594 141.968 119.092L143.006 100.136C143.068 99.0035 144.024 98.1432 145.109 98.2433L146.621 98.3833C147.706 98.4834 148.483 99.5033 148.331 100.628L145.781 119.444C145.723 119.945 145.473 120.404 145.084 120.726C144.695 121.048 144.197 121.207 143.694 121.171Z"
    }), jsx("path", {
      d: "M134.733 122.805C134.577 122.851 134.414 122.866 134.252 122.848C134.091 122.831 133.934 122.782 133.792 122.704C133.649 122.626 133.524 122.521 133.422 122.395C133.32 122.268 133.244 122.123 133.198 121.967L129.492 110.176C129.384 109.84 129.414 109.476 129.574 109.162C129.735 108.849 130.013 108.612 130.349 108.503L131.308 108.214C131.473 108.166 131.646 108.152 131.816 108.174C131.986 108.197 132.149 108.254 132.296 108.342C132.443 108.431 132.57 108.549 132.669 108.689C132.768 108.829 132.837 108.988 132.871 109.156L135.618 121.237C135.695 121.562 135.646 121.904 135.482 122.194C135.318 122.485 135.051 122.703 134.733 122.805Z"
    }), jsx("path", {
      d: "M129.732 129.606C129.068 130.428 127.732 130.419 126.704 129.583L108.453 114.754C107.362 113.869 107.041 112.402 107.745 111.53L108.727 110.314C109.432 109.441 110.878 109.513 111.91 110.471L129.18 126.517C130.153 127.42 130.396 128.783 129.732 129.606Z"
    }), jsx("path", {
      d: "M138.169 167.907C138.639 168.089 139.02 168.446 139.232 168.903C139.445 169.36 139.471 169.881 139.307 170.358L133.462 188.42C133.113 189.499 131.969 190.086 130.945 189.712L129.518 189.191C128.495 188.817 128.004 187.632 128.438 186.584L135.709 169.044C135.894 168.574 136.252 168.193 136.711 167.982C137.169 167.77 137.691 167.743 138.169 167.907Z"
    }), jsx("path", {
      d: "M147.25 168.615C147.412 168.61 147.574 168.638 147.726 168.696C147.877 168.754 148.016 168.841 148.134 168.953C148.252 169.064 148.347 169.198 148.413 169.346C148.479 169.495 148.516 169.654 148.52 169.817L149.092 182.164C149.11 182.516 148.989 182.86 148.753 183.123C148.518 183.385 148.188 183.543 147.837 183.562L146.835 183.597C146.663 183.601 146.493 183.57 146.334 183.505C146.175 183.441 146.032 183.344 145.912 183.22C145.793 183.097 145.7 182.951 145.64 182.79C145.581 182.629 145.555 182.458 145.564 182.287L145.994 169.905C146.003 169.571 146.138 169.253 146.37 169.014C146.603 168.775 146.917 168.633 147.25 168.615Z"
    }), jsx("path", {
      d: "M153.822 163.318C154.674 162.692 155.963 163.042 156.743 164.112L170.603 183.11C171.43 184.245 171.367 185.745 170.463 186.408L169.203 187.334C168.299 187.998 166.918 187.559 166.165 186.369L153.565 166.445C152.857 165.323 152.97 163.944 153.822 163.318Z"
    })]
  }));
};

const FilterHeaderIconActive = props => {
  return jsx("svg", Object.assign({
    fill: "none",
    height: "13",
    viewBox: "0 0 15 13",
    width: "15",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    children: jsx("path", {
      d: "M14 1H1L6.2 6.78111V10.7778L8.8 12V6.78111L14 1Z",
      fill: "#40444B",
      stroke: "#65686D",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    })
  }));
};

const FilterHeaderIconInActive = props => {
  return jsx("svg", Object.assign({
    fill: "none",
    height: "13",
    viewBox: "0 0 15 13",
    width: "15",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    children: jsx("path", {
      d: "M14 1H1L6.2 6.78111V10.7778L8.8 12V6.78111L14 1Z",
      stroke: "#40444B",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    })
  }));
};

LicenseInfo.setLicenseKey('a8d28d4c2ea9cdb1d6205199a20036acTz0xMDg4ODQsRT0xNzcyNTgyMzk5MDAwLFM9cHJvLExNPXN1YnNjcmlwdGlvbixQVj1RMy0yMDI0LEtWPTI=');
const Styled = styled(DataGridPro)(({
  theme,
  whiteHeader
}) => ({
  '&.MuiDataGrid-root .MuiDataGrid-cell:focus': {
    outline: 'none'
  },
  '&.MuiDataGrid-root .MuiDataGrid-cell:focus-within': {
    outline: 'none'
  },
  '&.MuiDataGrid-root .MuiDataGrid-columnHeader:focus-within': {
    outline: 'none'
  },
  border: 'none',
  '& .MuiDataGrid-columnHeaders': Object.assign(Object.assign({}, theme.typography.body2), {
    fontWeight: 500,
    border: 'none',
    backgroundColor: whiteHeader ? 'white' : theme.palette.primary.lighter,
    borderBottom: whiteHeader ? `1px solid ${theme.palette.grey[300]}` : 'none'
  }),
  '& .MuiDataGrid-columnSeparator': {},
  '& .MuiDataGrid-cell': Object.assign(Object.assign({}, theme.typography.body3), {
    color: theme.palette.grey[800],
    borderColor: theme.palette.grey[200]
  }),
  '& .MuiDataGrid-pinnedColumns': {
    minHeight: 'unset !important'
  },
  backgroundColor: theme.palette.common.white
}));
const ToolbarButtonsWrap = styled('div')(({
  theme
}) => ({
  display: 'grid',
  alignItems: 'center',
  gridTemplateColumns: 'auto auto auto',
  gridGap: theme.spacing(2)
}));
const StyledToolbarContainer = styled(ToolbarButtonsWrap)(({
  theme
}) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  width: '100%',
  marginBottom: theme.spacing(3)
}));
const StyledToolbarButton = styled(IconButton)(({
  theme
}) => ({
  alignItems: 'end',
  padding: 0,
  ':hover': {
    background: theme.palette.grey['200'],
    borderRadius: 0
  }
}));
const StyledColumnsButton = styled(IconButton)(({
  theme
}) => Object.assign(Object.assign({}, theme.typography.body2), {
  border: `1px solid ${theme.palette.grey[800]}`,
  height: 32,
  width: 150,
  display: 'flex',
  justifyContent: 'space-evenly',
  borderRadius: theme.spacing(0.5),
  ':hover': {
    background: theme.palette.grey['200']
  }
}));
const LeftToolbarButtonsWrap = styled(ToolbarButtonsWrap)(() => ({
  gridTemplateColumns: 'repeat(auto-fit, minmax(auto, 1fr))'
}));
const StyledPreferencesPanel = styled(GridPreferencesPanel)(() => ({
  '& .MuiPaper-root': {
    maxHeight: '100%'
  }
}));
const FilterIconButton = styled(IconButton)(() => ({
  height: 28,
  width: 28
}));
// eslint-disable-next-line @typescript-eslint/naming-convention
function CustomToolbar({
  uiMode,
  clearFilters,
  toolbar,
  selectedRows,
  setFilterButtonEl,
  isAnyFilterSelected,
  isColumnsPanelOpen,
  handleColumnPanelVisibile,
  toggleSelectionMode,
  allowRowSelection,
  columnsNumber,
  checkedColumnsNumber
}) {
  var _a;
  const apiRef = useGridApiContext();
  const FilterIconComponent = getFilterIcon(isAnyFilterSelected ? 'active' : 'hidden');
  const toggleColumnsMenu = () => {
    handleColumnPanelVisibile();
    !isColumnsPanelOpen ? apiRef.current.showPreferences(GridPreferencePanelsValue.columns) : apiRef.current.hidePreferences();
  };
  if (!toolbar) {
    return null;
  }
  return jsx(GridToolbarContainer, Object.assign({
    "data-test-id": "datagrid-toolbar"
  }, {
    children: jsxs(StyledToolbarContainer, {
      children: [jsxs(LeftToolbarButtonsWrap, {
        children: [(_a = toolbar === null || toolbar === void 0 ? void 0 : toolbar.customActions) === null || _a === void 0 ? void 0 : _a.call(toolbar, {
          selectedRows
        }), toolbar.export && jsx("div", {
          children: jsx(GridToolbarExport, {
            "data-test-id": "export"
          })
        }), allowRowSelection && jsxs(Button, Object.assign({
          "data-test-id": "show-selected-rows",
          disabled: uiMode !== 'selectedOnly' && !(selectedRows === null || selectedRows === void 0 ? void 0 : selectedRows.length),
          variant: "secondary",
          onClick: toggleSelectionMode
        }, {
          children: ["Show Selected", (selectedRows === null || selectedRows === void 0 ? void 0 : selectedRows.length) ? ` (${selectedRows.length})` : null]
        }))]
      }), jsxs(ToolbarButtonsWrap, {
        children: [toolbar.filter && jsx(ToolbarButtonsWithTooltip, Object.assign({
          title: "Clear Filters"
        }, {
          children: jsx(StyledToolbarButton, Object.assign({
            "data-active": isAnyFilterSelected ? 'active' : 'inactive',
            "data-test-id": "clear-all-filters",
            onClick: clearFilters
          }, {
            children: jsx(FilterIconComponent, {})
          }))
        })), toolbar.columns && jsx(ToolbarButtonsWithTooltip, Object.assign({
          title: "Edit Columns"
        }, {
          children: jsxs(StyledColumnsButton, Object.assign({
            ref: setFilterButtonEl,
            columnMenuOpen: isColumnsPanelOpen,
            "data-test-id": "column-panel-switch",
            onClick: toggleColumnsMenu
          }, {
            children: [jsx(ColumnsIcon, {}), "Columns ", checkedColumnsNumber, "/", columnsNumber]
          }))
        }))]
      })]
    })
  }));
}
const StyledMenu = styled(Menu)(() => ({
  '& .MuiMenu-list': {
    padding: 0
  },
  '& .MuiMenu-listItem': {
    padding: '0px 16px'
  }
}));
const GridPreloader = styled('div')(() => ({
  display: 'flex',
  height: '100%',
  justifyContent: 'center',
  alignItems: 'center'
}));
function handleColumnWidth(column, columnWidths) {
  var _a, _b;
  const widthToSet = (_a = columnWidths === null || columnWidths === void 0 ? void 0 : columnWidths[column.field]) !== null && _a !== void 0 ? _a : column.width;
  return {
    width: widthToSet,
    minWidth: (_b = column.minWidth) !== null && _b !== void 0 ? _b : 200,
    flex: widthToSet ? undefined : 1
  };
}
function buildSortModelFromColumns(columns) {
  const initState = columns.find(c => Boolean(c.sortDirection));
  return initState ? {
    sorting: {
      sortModel: [{
        field: initState.field || '',
        sort: (initState.sortDirection || 'desc').toLowerCase()
      }]
    }
  } : undefined;
}
const mapOperatorToMuiOperator = {
  eq: 'equals',
  contains: 'contains',
  range: 'inDateRange',
  in: 'in'
};
const ActualDataGrid = ({
  columns: columnsProp,
  loadServerRows,
  onViewClick,
  onEditClick,
  onDeleteClick,
  onStateChange,
  onConfirmSelectedColumns,
  onError,
  toolbar: _toolbar = null,
  noDataComponent: _noDataComponent = jsx(NoResults, {
    description: "There is no data from server"
  }),
  errorComponent: _errorComponent = jsx(NoResults, {
    description: "Failed to get data from server",
    graphic: jsx(ErrorIcon, {}),
    header: "Something went wrong"
  }),
  noFilteredDataComponent: _noFilteredDataComponent = jsx(NoResults, {
    description: "There is no results that match your filter."
  }),
  reloadToken,
  customColumn,
  baseActions,
  allowRowSelection: _allowRowSelection = false,
  uppercaseHeader: _uppercaseHeader = true,
  whiteHeader: _whiteHeader = false,
  gridPreLoader: _gridPreLoader = true,
  inlineNoDataComponent: _inlineNoDataComponent = false,
  initialState,
  shouldPaginate: _shouldPaginate = false,
  infiniteScrollChunkSize: _infiniteScrollChunkSize = 30,
  hideFooter: _hideFooter = false,
  hideFooterPagination: _hideFooterPagination = false,
  heightDisplayMode: _heightDisplayMode = 'block',
  rowHeight: _rowHeight = 48,
  headerHeight: _headerHeight = 56,
  allowCellEdit: _allowCellEdit = false,
  externalFiltersFetch
}) => {
  var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
  const pagesNextCursor = useRef((_a = initialState === null || initialState === void 0 ? void 0 : initialState.pagesNextCursor) !== null && _a !== void 0 ? _a : {});
  const [rows, setRows] = useState((_b = initialState === null || initialState === void 0 ? void 0 : initialState.rows) !== null && _b !== void 0 ? _b : []);
  const [page, setPage] = useState((_c = initialState === null || initialState === void 0 ? void 0 : initialState.page) !== null && _c !== void 0 ? _c : 0);
  const [pageSize, setPageSize] = useState((_d = initialState === null || initialState === void 0 ? void 0 : initialState.pageSize) !== null && _d !== void 0 ? _d : 0);
  const [loading, setLoading] = useState(!_gridPreLoader);
  const [rowCount, setRowCount] = useState((_e = initialState === null || initialState === void 0 ? void 0 : initialState.rowCount) !== null && _e !== void 0 ? _e : 0);
  const [isGridHaveData, setIsGridHaveData] = useState(null);
  const [areFiltersVisible, setAreFiltersVisible] = useState(_toolbar === null || _toolbar === void 0 ? void 0 : _toolbar.filter);
  const [selectionModel, setSelectionModel] = useState([]);
  const [sortModel, setSortModel] = useState([...(((_f = initialState === null || initialState === void 0 ? void 0 : initialState.sorting) === null || _f === void 0 ? void 0 : _f.sortModel) || ((_h = (_g = buildSortModelFromColumns(columnsProp)) === null || _g === void 0 ? void 0 : _g.sorting) === null || _h === void 0 ? void 0 : _h.sortModel) || [])]);
  const [columnsButton, setColumnsButton] = useState(null);
  const [columnWidths, setColumnWidths] = useState({});
  const [filters, setFilters] = useState(createInitialStateFilters(initialState === null || initialState === void 0 ? void 0 : initialState.filter));
  const [uiMode, setUiMode] = useState('normal');
  const [selectedRowsData, setSelectedRowsData] = useState([]);
  const [selectedRowsDataInSelectionMode, setSelectedRowsDataInSelectionMode] = useState([]);
  const [clientFilters, setClientFilters] = useState(createInitialStateFilters(initialState === null || initialState === void 0 ? void 0 : initialState.clientFilters));
  const [errorComponentShown, setErrorComponentShown] = useState(false);
  useEffect(() => {
    if (externalFiltersFetch && externalFiltersFetch.length) {
      clearPageCursors();
      setFilters(externalFiltersFetch);
    }
  }, [externalFiltersFetch]);
  const handleChangeUiMode = newMode => {
    setUiMode(newMode);
    if (newMode === 'selectedOnly') {
      setSelectedRowsDataInSelectionMode(selectedRowsData);
      handlePageChange(0);
    } else if (newMode === 'normal') {
      setSelectedRowsData(selectedRowsDataInSelectionMode);
    }
  };
  const clearFilters = () => {
    setAreFiltersVisible((_toolbar === null || _toolbar === void 0 ? void 0 : _toolbar.filter) ? true : !areFiltersVisible);
    const didFiltersChange = Object.keys(uiMode === 'selectedOnly' ? clientFilters : filters).length > 0;
    const updateFiltersFn = () => {
      setClientFilters({});
      setFilters({});
    };
    areFiltersVisible && didFiltersChange && updateFiltersFn();
    areFiltersVisible && didFiltersChange && setRows([]);
  };
  const clearPageCursors = () => {
    pagesNextCursor.current = {};
  };
  const handleClientFilterChange = filterData => {
    clearPageCursors();
    const newFilters = Object.assign(Object.assign({}, clientFilters), {
      [filterData.field]: filterData
    });
    const newFilterValue = newFilters[filterData.field].value;
    if (newFilterValue === null) {
      delete newFilters[filterData.field];
    }
    setClientFilters(newFilters);
    setFilters(Object.assign(Object.assign({}, filters), newFilters));
  };
  const handleFilterChange = filterData => {
    clearPageCursors();
    const newFilters = Object.assign(Object.assign({}, filters), {
      [filterData.field]: filterData
    });
    const newFilterValue = newFilters[filterData.field].value;
    if (newFilterValue === null) {
      delete newFilters[filterData.field];
    }
    setFilters(newFilters);
    setClientFilters(Object.assign(Object.assign({}, clientFilters), newFilters));
  };
  const handleSortModelChange = newModel => {
    clearPageCursors();
    setRows([]);
    setSortModel(newModel);
  };
  const columns = useMemo(() => {
    var _a, _b;
    return [...columnsProp.map(column => {
      var _a;
      return Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, column), {
        columnVisibility: !column.hide,
        filterable: !!column.filter,
        hideable: (_a = column.hideable) !== null && _a !== void 0 ? _a : true
      }), handleColumnWidth(column, columnWidths)), column.type === 'string' && {
        filterOperators: [{
          value: 'in',
          getApplyFilterFn: filterItem => {
            if (!filterItem.field || !filterItem.value || !filterItem.operator) {
              return null;
            }
            return params => {
              return filterItem.value.includes(params.value);
            };
          },
          InputComponentProps: {
            type: 'string'
          }
        }]
      }), {
        renderHeader: params => {
          var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
          const {
            headerName,
            filterable,
            suffixHeaderComponent
          } = params.colDef;
          const filterType = (_b = (_a = column.filter) === null || _a === void 0 ? void 0 : _a.type) !== null && _b !== void 0 ? _b : null;
          // eslint-disable-next-line react-hooks/rules-of-hooks
          const anchorEl = useRef(null);
          const [isFilterPanelOpen, setIsFilterPanelOpen] =
          // eslint-disable-next-line react-hooks/rules-of-hooks
          useState(false);
          return jsxs(Fragment, {
            children: [jsx("div", Object.assign({
              ref: anchorEl,
              style: {
                display: 'flex',
                alignItems: 'center',
                textOverflow: 'ellipsis',
                overflow: 'hidden',
                whiteSpace: 'nowrap'
              }
            }, {
              children: jsx(Typography, Object.assign({
                component: "div",
                sx: {
                  marginRight: '4px',
                  textOverflow: 'ellipsis',
                  overflow: 'hidden',
                  whiteSpace: 'nowrap'
                },
                upperCase: _uppercaseHeader,
                variant: 'body3',
                weight: 500
              }, {
                children: headerName
              }))
            })), !!suffixHeaderComponent && jsx("div", Object.assign({
              style: {
                display: 'flex',
                marginBottom: '2px'
              }
            }, {
              children: suffixHeaderComponent
            })), filterable && areFiltersVisible && jsx(FilterIconButton, Object.assign({
              color: "inherit",
              size: "small",
              onClick: e => {
                e.stopPropagation();
                setIsFilterPanelOpen(true);
              }
            }, {
              children: (uiMode === 'normal' ? Object.keys(filters) : Object.keys(clientFilters)).includes(column.field) ? jsx(FilterHeaderIconActive, {
                "data-test-id": `filter-button-${column.field}`,
                style: {
                  marginBottom: '2px'
                }
              }) : jsx(FilterHeaderIconInActive, {
                "data-test-id": `filter-button-${column.field}`,
                style: {
                  marginBottom: '2px'
                }
              })
            })), jsxs(StyledMenu, Object.assign({
              anchorEl: anchorEl.current,
              id: "basic-menu",
              MenuListProps: {
                'aria-labelledby': 'basic-button'
              },
              open: isFilterPanelOpen,
              onClose: () => setIsFilterPanelOpen(false)
            }, {
              children: [filterType === 'text' && jsx(TextFilter, {
                field: column.field,
                operator: (_c = column.filter) === null || _c === void 0 ? void 0 : _c.operator,
                value: (_e = (_d = filters[column.field]) === null || _d === void 0 ? void 0 : _d.value) !== null && _e !== void 0 ? _e : '',
                onChange: uiMode === 'selectedOnly' ? handleClientFilterChange : handleFilterChange,
                onClose: () => setIsFilterPanelOpen(false)
              }), filterType === 'select' && jsx(SelectFilterWithSearch, {
                entityName: headerName,
                field: column.field,
                options: (_g = (_f = column.filter) === null || _f === void 0 ? void 0 : _f.options) !== null && _g !== void 0 ? _g : [],
                selected: (_j = (_h = filters[column.field]) === null || _h === void 0 ? void 0 : _h.value) !== null && _j !== void 0 ? _j : [],
                onChange: uiMode === 'selectedOnly' ? handleClientFilterChange : handleFilterChange,
                onClose: () => setIsFilterPanelOpen(false)
              }), filterType === 'date' && jsx(DateFilter, {
                field: column.field,
                maxDate: (_k = column.filter) === null || _k === void 0 ? void 0 : _k.maxDate,
                minDate: (_l = column.filter) === null || _l === void 0 ? void 0 : _l.minDate,
                value: (_m = filters[column.field]) === null || _m === void 0 ? void 0 : _m.value,
                onChange: uiMode === 'selectedOnly' ? handleClientFilterChange : handleFilterChange,
                onClose: () => setIsFilterPanelOpen(false)
              })]
            }))]
          });
        }
      });
    }), baseActions && Object.assign(Object.assign({}, handleColumnWidth(Object.assign(Object.assign({}, baseActions), {
      field: 'actions'
    }), columnWidths)), {
      headerName: baseActions.headerName,
      type: 'actions',
      field: 'actions',
      sortable: false,
      filterable: false,
      headerAlign: 'left',
      hideable: false,
      resizable: (_a = baseActions.resizable) !== null && _a !== void 0 ? _a : false,
      sx: {
        backgroundColor: 'transparent'
      },
      getActions: params => [onViewClick && jsx(GridActionsCellItem, {
        icon: jsx(ViewIcon, {}),
        label: "View",
        showInMenu: true,
        onClick: onViewClick({
          id: params.id
        })
      }), onEditClick && jsx(GridActionsCellItem, {
        icon: jsx(EditIcon, {}),
        label: "Edit",
        showInMenu: true,
        onClick: onEditClick({
          id: params.id
        })
      }), onDeleteClick && jsx(GridActionsCellItem, {
        icon: jsx(DeleteIcon, {}),
        label: "Delete",
        showInMenu: true,
        onClick: onDeleteClick({
          id: params.id
        })
      })].filter(Boolean)
    }), customColumn && Object.assign(Object.assign({}, handleColumnWidth(Object.assign(Object.assign({}, customColumn), {
      field: 'customActions'
    }), columnWidths)), {
      type: 'customActions',
      headerName: customColumn.headerName,
      field: 'customActions',
      sortable: false,
      headerAlign: 'left',
      filterable: false,
      hideable: false,
      resizable: (_b = customColumn.resizable) !== null && _b !== void 0 ? _b : false,
      renderCell: params => customColumn.component({
        rowData: params.row
      })
    })].filter(Boolean);
  },
  // eslint-disable-next-line react-hooks/exhaustive-deps
  [columnsProp, areFiltersVisible, filters, onViewClick, onEditClick, onDeleteClick, customColumn, uiMode]);
  const [columnsToCheck, setColumnsToCheck] = useState(columns.map(column => column.hide ? undefined : column.field).filter(Boolean));
  const [isColumnsPanelOpen, setIsColumnsPanelOpen] = useState(false);
  const handlePageChange = newPage => {
    if (newPage === 0 || pagesNextCursor.current[newPage - 1]) {
      setPage(newPage);
    }
  };
  const previousToken = usePreviousValue(reloadToken);
  const previousFilters = usePreviousValue(filters);
  const previousSortModel = usePreviousValue(sortModel);
  const fetchData = () => __awaiter(void 0, void 0, void 0, function* () {
    const actualPageSize = _shouldPaginate ? pageSize : _infiniteScrollChunkSize;
    if (actualPageSize === 0) {
      return;
    }
    const filtersChanged = previousFilters !== filters;
    const sortModelChanged = previousSortModel !== sortModel;
    const reloadTokenChanged = previousToken !== reloadToken;
    const freshData = Object.keys(pagesNextCursor.current).length === 0;
    const currentPage = _shouldPaginate ? page : freshData ? 0 : Math.floor(rows.length / actualPageSize);
    const nextCursor = pagesNextCursor.current[currentPage - 1];
    const hasSorting = sortModel.length > 0;
    // This checks if the user has reached the end. My friend.
    const isAnyFilters = Object.keys(uiMode === 'selectedOnly' ? clientFilters : filters).length > 0;
    const externalFiltersMode = !!externalFiltersFetch;
    const filtersUpdated = !!Object.keys(filters).length && filtersChanged;
    const commonCancelRequest = !filtersUpdated && !reloadTokenChanged && !nextCursor;
    const cancelRequest = !sortModelChanged && !isAnyFilters && !hasSorting && currentPage > 0;
    if (commonCancelRequest && (externalFiltersMode || cancelRequest)) {
      return;
    }
    setLoading(true);
    try {
      const response = yield loadServerRows({
        sortModel,
        fields: columns.map(column => column.field),
        cursor: nextCursor,
        pageSize: _shouldPaginate ? pageSize : _infiniteScrollChunkSize,
        filters: Object.entries(filters).map(([, filter]) => {
          return filter;
        }),
        shouldFetchTotalCount: _shouldPaginate
      });
      const newRows = _shouldPaginate ? response.rows : freshData ? response.rows : [...rows, ...response.rows];
      const totalRows = _shouldPaginate ? response.rowCount : response.rows.length;
      if (totalRows === 0) {
        setIsGridHaveData(false);
      } else {
        setIsGridHaveData(true);
      }
      if (response.nextCursor) {
        pagesNextCursor.current[currentPage] = response.nextCursor;
      }
      setRows(newRows);
      setRowCount(totalRows);
      setLoading(false);
    } catch (e) {
      setLoading(false);
      setErrorComponentShown(true);
      if (typeof onError === 'function') onError(e);
    }
  });
  useEffect(() => {
    if (uiMode !== 'selectedOnly') {
      fetchData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page, pageSize, filters, columnsToCheck, loadServerRows, reloadToken, sortModel, _shouldPaginate, uiMode]);
  const checkedColumns = useMemo(() => columnsToCheck.map(column => {
    var _a;
    return (_a = columns.find(item => item.field === column)) !== null && _a !== void 0 ? _a : undefined;
  })
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  .filter(Boolean), [columnsToCheck, columns]);
  const checkedNumberColumns = getColumnsNumber(checkedColumns);
  const totalNumberColumns = getColumnsNumber(columns);
  const handleColumnPanelVisible = () => {
    setIsColumnsPanelOpen(prevState => !prevState);
  };
  const hasFilter = Object.keys(filters).length > 0;
  useEffect(() => {
    if (typeof onStateChange === 'function') {
      onStateChange({
        filter: transformFiltersFromRecord(filters),
        clientFilters: transformFiltersFromRecord(clientFilters),
        sorting: {
          sortModel
        },
        cursor: pagesNextCursor,
        rows,
        rowCount,
        page,
        pageSize,
        visibleColumns: columnsToCheck,
        loading
      });
    }
  }, [onStateChange, filters, clientFilters, sortModel, pagesNextCursor, rows, rowCount, page, pageSize, columnsToCheck, loading]);
  const isLoaderShown = useMemo(() => {
    return _gridPreLoader && isGridHaveData === null && loading;
  }, [loading, isGridHaveData, _gridPreLoader]);
  if (isLoaderShown) {
    return jsx(GridPreloader, {
      children: jsx(CircularProgress, {})
    });
  }
  const pinnedColumns = {
    right: [customColumn && customColumn.pinned && 'customActions', baseActions && baseActions.pinned && 'actions'].filter(Boolean),
    left: ['__check__']
  };
  const isNoDataComponentShown = !_inlineNoDataComponent && !hasFilter && !isGridHaveData && isGridHaveData !== null;
  const updateSelectedRowsData = (prevRowsData, selectedIds) => {
    const prevIds = prevRowsData.map(row => row.id);
    const newIds = selectedIds.filter(id => !prevIds.includes(id));
    const filteredRows = prevRowsData.filter(row => selectedIds.includes(row.id));
    const newRows = newIds.map(id => rows.find(row => row.id === id)).filter(Boolean);
    return [...filteredRows, ...newRows];
  };
  const mapUiModeToProps = {
    normal: {
      pagination: _shouldPaginate,
      paginationMode: 'server',
      filterMode: 'server',
      filterModel: undefined,
      selectionModel,
      onSelectionModelChange: ids => {
        // TODO - If there was a filter, we need to show the original data when filter is removed
        setSelectedRowsData(prevState => updateSelectedRowsData(prevState, ids));
        setSelectionModel(ids);
      },
      rows,
      rowCount
    },
    selectedOnly: {
      pagination: false,
      paginationMode: undefined,
      filterMode: 'client',
      selectionModel,
      onSelectionModelChange: ids => {
        setSelectedRowsDataInSelectionMode(prevState => updateSelectedRowsData(prevState, ids));
        setSelectionModel(ids);
      },
      rows: selectedRowsData,
      rowCount: selectedRowsData === null || selectedRowsData === void 0 ? void 0 : selectedRowsData.length,
      filterModel: {
        items: (_j = Object.entries(clientFilters)) === null || _j === void 0 ? void 0 : _j.map(([fieldName, filterData]) => ({
          id: fieldName,
          columnField: fieldName,
          operatorValue: mapOperatorToMuiOperator[filterData === null || filterData === void 0 ? void 0 : filterData.operator],
          value: filterData === null || filterData === void 0 ? void 0 : filterData.value
        })),
        linkOperator: GridLinkOperator.And
      },
      autoPageSize: false,
      hideFooterRowCount: true,
      onRowsScrollEnd: undefined
    }
  };
  if (isNoDataComponentShown || errorComponentShown && !_inlineNoDataComponent) {
    // eslint-disable-next-line react/jsx-no-useless-fragment
    return jsx(Box, Object.assign({
      alignItems: "center",
      "data-test-id": "datagrid-no-data",
      display: "flex",
      height: "100%",
      justifyContent: "center"
    }, {
      children: errorComponentShown ? _errorComponent : _noDataComponent
    }));
  }
  return jsx("div", Object.assign({
    style: {
      height: _heightDisplayMode === 'block' || rowCount < 1 ? '100%' : rowCount * _rowHeight + _headerHeight,
      width: '100%'
    }
  }, {
    children: jsx(Styled, Object.assign({
      disableColumnReorder: true,
      "data-test-id": "datagrid",
      experimentalFeatures: {
        newEditingApi: _allowCellEdit
      }
    }, {
      columns: checkedColumns
    }, {
      disableColumnFilter: true,
      disableColumnMenu: true,
      disableSelectionOnClick: true,
      keepNonExistentRowsSelected: true,
      autoPageSize: !!_shouldPaginate,
      checkboxSelection: _allowRowSelection,
      // columns={checkedColumns as GridColumns<GridValidRowModel>}
      columnVisibilityModel: columns.reduce((acc, column) => Object.assign(Object.assign({}, acc), {
        [column.field]: columnsToCheck.includes(column.field)
      }), {}),
      components: {
        Toolbar: _toolbar ? CustomToolbar : null,
        PreferencesPanel: StyledPreferencesPanel,
        ColumnsPanel: () => {
          var _a, _b, _c, _d;
          const apiRef = useGridApiContext();
          const tableHeight = (_d = (_c = (_b = (_a = apiRef === null || apiRef === void 0 ? void 0 : apiRef.current) === null || _a === void 0 ? void 0 : _a.windowRef) === null || _b === void 0 ? void 0 : _b.current) === null || _c === void 0 ? void 0 : _c.offsetParent) === null || _d === void 0 ? void 0 : _d.clientHeight;
          return jsx(ColumnsPanel, {
            columns: columns,
            columnsToCheck: columnsToCheck,
            tableHeight: tableHeight,
            onClose: () => {
              setIsColumnsPanelOpen(false);
              apiRef.current.hidePreferences();
            },
            onColumnsChange: columnsToCheck => {
              clearPageCursors();
              setColumnsToCheck(columnsToCheck);
              apiRef.current.hidePreferences();
            },
            onConfirmSelectedColumns: onConfirmSelectedColumns
          });
        },
        NoRowsOverlay: () =>
        // eslint-disable-next-line react/jsx-no-useless-fragment
        jsx(Fragment, {
          children: errorComponentShown ? _errorComponent : _noDataComponent
        }),
        // eslint-disable-next-line react/jsx-no-useless-fragment
        NoResultsOverlay: () => jsx(Fragment, {
          children: _noFilteredDataComponent
        })
      },
      componentsProps: {
        panel: {
          anchorEl: columnsButton
        },
        loadingOverlay: {
          'data-test-id': 'data-grid-loader'
        },
        toolbar: {
          uiMode,
          isAnyFilterSelected: Object.keys(uiMode === 'selectedOnly' ? clientFilters : filters).length > 0,
          setFilterButtonEl: setColumnsButton,
          areFiltersVisible: areFiltersVisible,
          selectedRows: selectedRowsData,
          clearFilters: clearFilters,
          toolbar: _toolbar,
          isColumnsPanelOpen: isColumnsPanelOpen,
          handleColumnPanelVisibile: handleColumnPanelVisible,
          toggleSelectionMode: () => handleChangeUiMode(uiMode === 'normal' ? 'selectedOnly' : 'normal'),
          allowRowSelection: _allowRowSelection,
          columnsNumber: totalNumberColumns,
          checkedColumnsNumber: checkedNumberColumns
        }
      },
      headerHeight: _headerHeight,
      hideFooter: _hideFooter || _inlineNoDataComponent,
      hideFooterPagination: _hideFooterPagination || page === 0 && Object.keys(pagesNextCursor.current).length === 0,
      hideFooterRowCount: !_shouldPaginate && _hideFooter,
      initialState: {
        sorting: (initialState === null || initialState === void 0 ? void 0 : initialState.sorting) || ((_k = buildSortModelFromColumns(columnsProp)) === null || _k === void 0 ? void 0 : _k.sorting),
        filter: createInitialFilterState(initialState === null || initialState === void 0 ? void 0 : initialState.filter),
        pinnedColumns
      },
      loading: loading,
      page: page,
      processRowUpdate: _allowCellEdit ? newRow => {
        const index = rows.indexOf(rows.find(r => r.id === newRow.id));
        const newRows = [...rows];
        newRows[index] = newRow;
        setRows(newRows);
      } : null,
      rowHeight: _rowHeight,
      sortModel: sortModel,
      whiteHeader: _whiteHeader,
      onColumnVisibilityModelChange: newModel => console.log({
        newModel
      }),
      onColumnWidthChange: params => {
        const columnField = params.colDef.field;
        setColumnWidths(Object.assign(Object.assign({}, columnWidths), {
          [columnField]: params.width
        }));
      },
      onPageChange: handlePageChange,
      onPageSizeChange: newPageSize => {
        if (newPageSize === 0) {
          setLoading(false);
        }
        setPageSize(newPageSize);
      },
      onRowsScrollEnd: params => {
        if (params.virtualRowsCount === params.viewportPageSize) {
          return;
        }
        if (!_shouldPaginate && pagesNextCursor.current[Math.ceil(rows.length / _infiniteScrollChunkSize) - 1]) {
          //hasNextPage
          fetchData();
        }
      },
      onSortModelChange: handleSortModelChange
    }, mapUiModeToProps[uiMode], {
      sortingOrder: ['asc', 'desc']
    }))
  }));
};
const DataGrid = _a => {
  var {
      columns
    } = _a,
    props = __rest(_a, ["columns"]);
  if (!columns.length) return null;
  return jsx(ActualDataGrid, Object.assign({}, props, {
    columns: columns
  }));
};

export { DataGrid };
